import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: string; output: string; }
};

export type AccountInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  merchantId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<UserRole>;
  roles?: InputMaybe<Array<UserRole>>;
};

export type AddressObject = {
  city: Scalars['String']['output'];
  country: Scalars['String']['output'];
  countryCode: Scalars['String']['output'];
  line1: Scalars['String']['output'];
  line2?: Maybe<Scalars['String']['output']>;
  line3?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Geolocation>;
  postalCode: Scalars['String']['output'];
  stateOrProvince?: Maybe<Scalars['String']['output']>;
  stateOrProvinceCode?: Maybe<Scalars['String']['output']>;
};

export type AdjustGiftCardInput = {
  adjustmentType: GiftCardAccountAdjustmentType;
  amount: Scalars['Int']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  giftCardAccountId: Scalars['ID']['input'];
  type: GiftCardAdjustmentType;
};

export enum AppContentLocation {
  Account = 'account',
  Category = 'category',
  Home = 'home',
  Notification = 'notification',
  Voucher = 'voucher'
}

export enum AppContentType {
  Category = 'Category',
  Featured = 'Featured',
  New = 'New',
  Popular = 'Popular',
  Recommended = 'Recommended'
}

export type AppSection = {
  contentType: AppContentType;
  coordinate?: Maybe<Geolocation>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<Scalars['String']['output']>;
  items?: Maybe<Array<Maybe<AppSectionItem>>>;
  location: AppContentLocation;
  merchantIds?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  merchants?: Maybe<Array<Maybe<Merchant>>>;
  radiumInKm?: Maybe<Scalars['Float']['output']>;
  sort: Scalars['Int']['output'];
  status?: Maybe<ContentStatus>;
  title: Scalars['String']['output'];
  viewType: AppViewType;
};

export type AppSectionInput = {
  contentType: AppContentType;
  coordinate?: InputMaybe<GeolocationInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  images?: InputMaybe<Scalars['String']['input']>;
  items?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  location: AppContentLocation;
  merchantIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  radiumInKm?: InputMaybe<Scalars['Float']['input']>;
  sort: Scalars['Int']['input'];
  status: ContentStatus;
  title: Scalars['String']['input'];
  viewType: AppViewType;
};

export type AppSectionItem = {
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export enum AppService {
  Booking = 'booking',
  Delivery = 'delivery',
  Dinein = 'dinein',
  OnlineMenu = 'onlineMenu',
  Pickup = 'pickup'
}

export enum AppViewType {
  Banner = 'banner',
  BannerCarousel = 'bannerCarousel',
  BannerSlider = 'bannerSlider',
  Carousel = 'carousel',
  Grid = 'grid',
  HorizontalList = 'horizontalList',
  VerticalList = 'verticalList'
}

export type Booking = {
  bookingDetails?: Maybe<BookingDetails>;
  createdAt: Scalars['Int']['output'];
  customer?: Maybe<Customer>;
  id: Scalars['ID']['output'];
  merchantId: Scalars['String']['output'];
};

export type BookingDetails = {
  bookingSession?: Maybe<BookingSession>;
  bookingTime: Scalars['Int']['output'];
  numberOfGuests: Scalars['Int']['output'];
  promotionId?: Maybe<Scalars['ID']['output']>;
  specialInstructions?: Maybe<Scalars['String']['output']>;
};

export type BookingSession = {
  OpenTime: OpenTime;
  bookingTables?: Maybe<Array<Maybe<BookingTable>>>;
  description?: Maybe<Scalars['String']['output']>;
  guestCountLimit?: Maybe<Scalars['Int']['output']>;
  hideEndTime: Scalars['Boolean']['output'];
  hideTableNumber: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isEnabled: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  needDeposite: Scalars['Boolean']['output'];
};

export type BookingSessionInput = {
  OpenTime: OpenTimeInput;
  bookingTables?: InputMaybe<Array<InputMaybe<BookingTableInput>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  guestCountLimit?: InputMaybe<Scalars['Int']['input']>;
  hideEndTime: Scalars['Boolean']['input'];
  hideTableNumber: Scalars['Boolean']['input'];
  isEnabled: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  needDeposite: Scalars['Boolean']['input'];
};

export type BookingTable = {
  maximumNumberOfGuests: Scalars['Int']['output'];
  minimumNumberOfGuests: Scalars['Int']['output'];
  tableNumber: Scalars['String']['output'];
};

export type BookingTableInput = {
  maximumNumberOfGuests: Scalars['Int']['input'];
  minimumNumberOfGuests: Scalars['Int']['input'];
  tableNumber: Scalars['String']['input'];
};

export type BuyNGetNFreePromotion = {
  applyOptionDiscount?: Maybe<Scalars['Boolean']['output']>;
  availableType?: Maybe<Array<Maybe<OrderType>>>;
  buyN: Scalars['Int']['output'];
  canBeUsedWithOtherPromotions?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  discountAmount?: Maybe<Scalars['Float']['output']>;
  displaySettings?: Maybe<ItemDisplaySettings>;
  effectiveDateTime: Array<Maybe<EffectiveDateTime>>;
  excludedPromotionTags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  freeN: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  includedGetItemsPromoTags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  includedPromotionTags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  isHiddenInApp?: Maybe<Scalars['Boolean']['output']>;
  isLoyalty?: Maybe<Scalars['Boolean']['output']>;
  isOffer?: Maybe<Scalars['Boolean']['output']>;
  isPaymentRequired?: Maybe<Scalars['Boolean']['output']>;
  isPercentage?: Maybe<Scalars['Boolean']['output']>;
  isSignUpPromotion?: Maybe<Scalars['Boolean']['output']>;
  loyaltyDetails?: Maybe<LoyaltyDetails>;
  merchantId: Scalars['String']['output'];
  minimumAmount?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  numberOfDeals: Scalars['Int']['output'];
  offerVoucherSettings?: Maybe<OfferVoucherSettings>;
  percentage?: Maybe<Scalars['Float']['output']>;
  status: PromotionStatus;
  upToAmount?: Maybe<Scalars['Float']['output']>;
  useType: PromotionUseType;
};

export type BuyNGetNFreePromotionInput = {
  applyOptionDiscount?: InputMaybe<Scalars['Boolean']['input']>;
  availableType?: InputMaybe<Array<InputMaybe<OrderType>>>;
  buyN: Scalars['Int']['input'];
  canBeUsedWithOtherPromotions: Scalars['Boolean']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  discountAmount?: InputMaybe<Scalars['Float']['input']>;
  displaySettings: ItemDisplaySettingsInput;
  effectiveDateTime: Array<InputMaybe<EffectiveDateTimeInput>>;
  excludedPromotionTags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  freeN: Scalars['Int']['input'];
  includedGetItemsPromoTags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  includedPromotionTags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isHiddenInApp?: InputMaybe<Scalars['Boolean']['input']>;
  isLoyalty?: InputMaybe<Scalars['Boolean']['input']>;
  isOffer?: InputMaybe<Scalars['Boolean']['input']>;
  isPaymentRequired?: InputMaybe<Scalars['Boolean']['input']>;
  isPercentage?: InputMaybe<Scalars['Boolean']['input']>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  isSignUpPromotion?: InputMaybe<Scalars['Boolean']['input']>;
  loyaltyDetails?: InputMaybe<LoyaltyDetailsInput>;
  minimumAmount?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  numberOfDeals: Scalars['Int']['input'];
  offerVoucherSettings?: InputMaybe<OfferVoucherSettingsInput>;
  percentage?: InputMaybe<Scalars['Float']['input']>;
  upToAmount?: InputMaybe<Scalars['Float']['input']>;
  useType: PromotionUseType;
};

export enum ContentStatus {
  Draft = 'draft',
  Published = 'published'
}

export type Customer = {
  address?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  foodAllergies?: Maybe<Scalars['String']['output']>;
  geolocation?: Maybe<Geolocation>;
  guestNum?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  phoneNumber?: Maybe<Scalars['String']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
};

export type EffectiveDateTime = {
  endDate: Scalars['Date']['output'];
  hours?: Maybe<Array<Maybe<EffectiveHours>>>;
  recurringWeekDays?: Maybe<Array<Maybe<Weekday>>>;
  startDate: Scalars['Date']['output'];
};

export type EffectiveDateTimeInput = {
  endDate: Scalars['Date']['input'];
  hours?: InputMaybe<Array<InputMaybe<EffectiveHoursInput>>>;
  recurringWeekDays?: InputMaybe<Array<InputMaybe<Weekday>>>;
  startDate: Scalars['Date']['input'];
};

export type EffectiveHours = {
  openEnd: Scalars['Int']['output'];
  openStart: Scalars['Int']['output'];
};

export type EffectiveHoursInput = {
  openEnd: Scalars['Int']['input'];
  openStart: Scalars['Int']['input'];
};

export type Geolocation = {
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
};

export type GeolocationInput = {
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
};

export type GiftCard = {
  amount: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  createdUserId?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  expiredAt?: Maybe<Scalars['Int']['output']>;
  giftCardAccountId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  merchantId?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  recipientEmail: Scalars['String']['output'];
  recipientName: Scalars['String']['output'];
  recipientPhone?: Maybe<Scalars['String']['output']>;
  redeemCode: Scalars['String']['output'];
  sender?: Maybe<Scalars['String']['output']>;
  serialNumber: Scalars['String']['output'];
  status: GiftCardStatus;
  updatedAt: Scalars['Int']['output'];
};

export type GiftCardAccount = {
  activeGiftCards?: Maybe<Array<GiftCard>>;
  adjustmentRecords?: Maybe<Array<GiftCardAdjustmentRecord>>;
  adminUserIds: Array<Scalars['String']['output']>;
  balance: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  redeemedGiftCards?: Maybe<Array<GiftCard>>;
  updatedAt: Scalars['Int']['output'];
  updatedEmail?: Maybe<Scalars['String']['output']>;
  updatedUserId: Scalars['String']['output'];
  voidedGiftCards?: Maybe<Array<GiftCard>>;
};

export enum GiftCardAccountAdjustmentType {
  Deduct = 'deduct',
  NewGiftCard = 'newGiftCard',
  Other = 'other',
  TopUp = 'topUp',
  VoidGiftCard = 'voidGiftCard'
}

export type GiftCardAccountInput = {
  adminUserIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type GiftCardAdjustmentRecord = {
  adjustmentType?: Maybe<GiftCardAccountAdjustmentType>;
  amount: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  giftCardAccountId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  type: GiftCardAdjustmentType;
  updatedAt: Scalars['Int']['output'];
  updatedEmail?: Maybe<Scalars['String']['output']>;
  updatedUserId: Scalars['ID']['output'];
};

export enum GiftCardAdjustmentType {
  Credit = 'credit',
  Debit = 'debit'
}

export type GiftCardInput = {
  amount: Scalars['Int']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  message: Scalars['String']['input'];
  recipientEmail: Scalars['String']['input'];
  recipientName: Scalars['String']['input'];
  recipientPhone?: InputMaybe<Scalars['String']['input']>;
  sender?: InputMaybe<Scalars['String']['input']>;
};

export enum GiftCardStatus {
  Active = 'active',
  Expired = 'expired',
  Redeemed = 'redeemed',
  Void = 'void'
}

export type HolidaySurcharge = {
  amount: Scalars['Float']['output'];
  isEnabled: Scalars['Boolean']['output'];
  isPercentage: Scalars['Boolean']['output'];
  publicHolidayDays?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  weekDays?: Maybe<Array<Maybe<Weekday>>>;
};

export type HolidaySurchargeInput = {
  amount: Scalars['Float']['input'];
  isEnabled: Scalars['Boolean']['input'];
  isPercentage: Scalars['Boolean']['input'];
  publicHolidayDays?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  weekDays?: InputMaybe<Array<InputMaybe<Weekday>>>;
};

export type InactiveItem = {
  hiddenDate?: Maybe<Scalars['String']['output']>;
  menuItemId: Scalars['String']['output'];
};

export type ItemDisplaySettings = {
  displayAltDescription?: Maybe<Scalars['String']['output']>;
  displayAltTitle?: Maybe<Scalars['String']['output']>;
  displayDescription?: Maybe<Scalars['String']['output']>;
  displayImage?: Maybe<Scalars['String']['output']>;
  displayTerms?: Maybe<Scalars['String']['output']>;
  displayTitle?: Maybe<Scalars['String']['output']>;
};

export type ItemDisplaySettingsInput = {
  displayAltDescription: Scalars['String']['input'];
  displayAltTitle: Scalars['String']['input'];
  displayDescription: Scalars['String']['input'];
  displayImage?: InputMaybe<Scalars['String']['input']>;
  displayTerms?: InputMaybe<Scalars['String']['input']>;
  displayTitle: Scalars['String']['input'];
};

export type Loyalty = {
  earnHistory?: Maybe<Array<Maybe<LoyaltyEarnHistory>>>;
  loyaltyId: Scalars['ID']['output'];
  loyaltyPoints: Scalars['Int']['output'];
  merchantId: Scalars['ID']['output'];
  redeemHistory?: Maybe<Array<Maybe<LoyaltyRedeemHistory>>>;
  spendProgress?: Maybe<SpendProgress>;
  stampProgress?: Maybe<StampProgress>;
  userEmail?: Maybe<Scalars['String']['output']>;
  userId: Scalars['ID']['output'];
  userName?: Maybe<Scalars['String']['output']>;
  userPhone?: Maybe<Scalars['String']['output']>;
};

export type LoyaltyBenefit = {
  benefitPromotionIds: Array<Scalars['ID']['output']>;
  description: Scalars['String']['output'];
  displaySettings?: Maybe<ItemDisplaySettings>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  requiredPoints: Scalars['Int']['output'];
};

export type LoyaltyBenefitInput = {
  benefitPromotionIds: Array<Scalars['ID']['input']>;
  description: Scalars['String']['input'];
  displaySettings: ItemDisplaySettingsInput;
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  requiredPoints: Scalars['Int']['input'];
};

export type LoyaltyDetails = {
  expiryDays: Scalars['Int']['output'];
  loyaltyReviewDate: Scalars['Int']['output'];
};

export type LoyaltyDetailsInput = {
  expiryDays: Scalars['Int']['input'];
  loyaltyReviewDate: Scalars['Int']['input'];
};

export type LoyaltyEarnHistory = {
  createdAt: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  earnedAmount?: Maybe<Scalars['Float']['output']>;
  earnedPoints?: Maybe<Scalars['Int']['output']>;
  earnedStamps?: Maybe<Scalars['Int']['output']>;
  merchantId: Scalars['ID']['output'];
  orderItems?: Maybe<Array<Maybe<LoyaltyOrderItem>>>;
  orderNumber?: Maybe<Scalars['String']['output']>;
  orderTotal?: Maybe<Scalars['Float']['output']>;
  promotionId: Scalars['ID']['output'];
};

export type LoyaltyOrderItem = {
  itemId: Scalars['ID']['output'];
  loyaltyPromotionId: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  orderTime: Scalars['Int']['output'];
  price: Scalars['Float']['output'];
  quantity: Scalars['Int']['output'];
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type LoyaltyProgram = {
  pointsLoyaltyId?: Maybe<Scalars['ID']['output']>;
  progressLoyaltyId?: Maybe<Scalars['ID']['output']>;
  stampLoyaltyId?: Maybe<Scalars['ID']['output']>;
  type: LoyaltyProgramType;
};

export enum LoyaltyProgramType {
  Points = 'points',
  Progress = 'progress',
  Stamp = 'stamp'
}

export type LoyaltyPromotion = {
  canBeUsedWithOtherPromotions?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  displaySettings?: Maybe<ItemDisplaySettings>;
  effectiveDateTime: Array<Maybe<EffectiveDateTime>>;
  excludedPromotionTags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  id: Scalars['ID']['output'];
  includedPromotionTags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  isHiddenInApp?: Maybe<Scalars['Boolean']['output']>;
  isLoyalty?: Maybe<Scalars['Boolean']['output']>;
  isPublished?: Maybe<Scalars['Boolean']['output']>;
  loyaltySettings?: Maybe<LoyaltySettings>;
  merchantId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  numberOfDeals: Scalars['Int']['output'];
  status: PromotionStatus;
  type: PromotionType;
  useType: PromotionUseType;
};

export type LoyaltyPromotionInput = {
  canBeUsedWithOtherPromotions?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displaySettings: ItemDisplaySettingsInput;
  effectiveDateTime: Array<InputMaybe<EffectiveDateTimeInput>>;
  excludedPromotionTags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  includedPromotionTags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isHiddenInApp?: InputMaybe<Scalars['Boolean']['input']>;
  isLoyalty?: InputMaybe<Scalars['Boolean']['input']>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  loyaltySettings?: InputMaybe<LoyaltySettingsInput>;
  merchantId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  numberOfDeals: Scalars['Int']['input'];
  useType: PromotionUseType;
};

export type LoyaltyRedeemHistory = {
  createdAt?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  promotionId: Scalars['ID']['output'];
  usedAmount?: Maybe<Scalars['Float']['output']>;
  usedPoints?: Maybe<Scalars['Int']['output']>;
  usedStamps?: Maybe<Scalars['Int']['output']>;
  voucherId: Scalars['ID']['output'];
};

export type LoyaltySettings = {
  expiryDays: Scalars['Int']['output'];
  loyaltyBenefits: Array<LoyaltyBenefit>;
  loyaltyReviewDate: Scalars['Int']['output'];
  maxPointsPerTransaction: Scalars['Int']['output'];
  pointsPerDollar: Scalars['Int']['output'];
};

export type LoyaltySettingsInput = {
  expiryDays: Scalars['Int']['input'];
  loyaltyBenefits: Array<LoyaltyBenefitInput>;
  loyaltyReviewDate: Scalars['Int']['input'];
  maxPointsPerTransaction: Scalars['Int']['input'];
  pointsPerDollar: Scalars['Int']['input'];
};

export type LuckyDrawPromotion = {
  availableType?: Maybe<Array<Maybe<OrderType>>>;
  canBeUsedWithOtherPromotions?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  displaySettings?: Maybe<ItemDisplaySettings>;
  effectiveDateTime: Array<Maybe<EffectiveDateTime>>;
  entryLimitPerUser: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  isEntryAutomatic?: Maybe<Scalars['Boolean']['output']>;
  isHiddenInApp?: Maybe<Scalars['Boolean']['output']>;
  isLoyalty?: Maybe<Scalars['Boolean']['output']>;
  isPaymentRequired?: Maybe<Scalars['Boolean']['output']>;
  isPublished?: Maybe<Scalars['Boolean']['output']>;
  isSignUpPromotion?: Maybe<Scalars['Boolean']['output']>;
  loyaltyDetails?: Maybe<LoyaltyDetails>;
  merchantId: Scalars['String']['output'];
  minimumAmount?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  numberOfDeals: Scalars['Int']['output'];
  prizeDescription?: Maybe<Scalars['String']['output']>;
  resultingPromotionNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  resultingPromotions: Array<ResultingPromotion>;
  status: PromotionStatus;
  totalEntries?: Maybe<Scalars['Int']['output']>;
  totalWinnerCount?: Maybe<Scalars['Int']['output']>;
  useType: PromotionUseType;
  winCountLimitPerPerson?: Maybe<Scalars['Int']['output']>;
  winPercentage: Scalars['Float']['output'];
  winnerCount: Scalars['Int']['output'];
};

export type LuckyDrawPromotionInput = {
  availableType?: InputMaybe<Array<InputMaybe<OrderType>>>;
  canBeUsedWithOtherPromotions?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displaySettings: ItemDisplaySettingsInput;
  effectiveDateTime: Array<InputMaybe<EffectiveDateTimeInput>>;
  entryLimitPerUser: Scalars['Int']['input'];
  isEntryAutomatic?: InputMaybe<Scalars['Boolean']['input']>;
  isHiddenInApp?: InputMaybe<Scalars['Boolean']['input']>;
  isLoyalty?: InputMaybe<Scalars['Boolean']['input']>;
  isPaymentRequired?: InputMaybe<Scalars['Boolean']['input']>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  isSignUpPromotion?: InputMaybe<Scalars['Boolean']['input']>;
  loyaltyDetails?: InputMaybe<LoyaltyDetailsInput>;
  minimumAmount?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  numberOfDeals: Scalars['Int']['input'];
  prizeDescription?: InputMaybe<Scalars['String']['input']>;
  resultingPromotionNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  resultingPromotions: Array<ResultingPromotionInput>;
  useType: PromotionUseType;
  winCountLimitPerPerson?: InputMaybe<Scalars['Int']['input']>;
  winPercentage: Scalars['Float']['input'];
  winnerCount: Scalars['Int']['input'];
};

export type Menu = {
  createdAt: Scalars['Date']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isEnabled?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  promotionTags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  status: MenuStatus;
  type?: Maybe<OrderType>;
};

export type MenuCategory = {
  active: Scalars['Boolean']['output'];
  active_begin?: Maybe<Scalars['Int']['output']>;
  active_end?: Maybe<Scalars['Int']['output']>;
  altName?: Maybe<Scalars['String']['output']>;
  cookingPriority?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  groups?: Maybe<Array<Maybe<MenuGroup>>>;
  hidden_until?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  items?: Maybe<Array<Maybe<MenuItem>>>;
  menuId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  promotionTags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  sort: Scalars['Int']['output'];
};

export type MenuCategoryInput = {
  active: Scalars['Boolean']['input'];
  active_begin?: InputMaybe<Scalars['Int']['input']>;
  active_end?: InputMaybe<Scalars['Int']['input']>;
  altName?: InputMaybe<Scalars['String']['input']>;
  cookingPriority?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  hidden_until?: InputMaybe<Scalars['String']['input']>;
  menuId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  promotionTags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sort: Scalars['Int']['input'];
};

export type MenuGroup = {
  allow_quantity: Scalars['Boolean']['output'];
  force_max: Scalars['Int']['output'];
  force_min: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  menuId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  options?: Maybe<Array<Maybe<MenuOption>>>;
  required: Scalars['Boolean']['output'];
  sort?: Maybe<Scalars['Int']['output']>;
};

export type MenuGroupInput = {
  allow_quantity: Scalars['Boolean']['input'];
  force_max: Scalars['Int']['input'];
  force_min: Scalars['Int']['input'];
  menuId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  sort: Scalars['Int']['input'];
};

export type MenuInput = {
  description: Scalars['String']['input'];
  name: Scalars['String']['input'];
  promotionTags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type: OrderType;
};

export type MenuItem = {
  active: Scalars['Boolean']['output'];
  active_begin?: Maybe<Scalars['Int']['output']>;
  active_end?: Maybe<Scalars['Int']['output']>;
  altName?: Maybe<Scalars['String']['output']>;
  categoryId: Scalars['String']['output'];
  cookingCategory?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  displayNumber?: Maybe<Scalars['String']['output']>;
  groups?: Maybe<Array<Maybe<MenuGroup>>>;
  hidden_until?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<Scalars['String']['output']>;
  ingredients?: Maybe<Scalars['String']['output']>;
  menuId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  price: Scalars['Float']['output'];
  promotionTags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  recommendationIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  shortName?: Maybe<Scalars['String']['output']>;
  sizes?: Maybe<Array<Maybe<MenuItemSize>>>;
  sort: Scalars['Int']['output'];
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  thumbImage?: Maybe<Scalars['String']['output']>;
  uniqueId?: Maybe<Scalars['String']['output']>;
};

export type MenuItemGroupsInput = {
  id: Scalars['ID']['input'];
  sort: Scalars['Int']['input'];
};

export type MenuItemInput = {
  active: Scalars['Boolean']['input'];
  active_begin?: InputMaybe<Scalars['Int']['input']>;
  active_end?: InputMaybe<Scalars['Int']['input']>;
  altName?: InputMaybe<Scalars['String']['input']>;
  categoryId: Scalars['String']['input'];
  cookingCategory?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  displayNumber?: InputMaybe<Scalars['String']['input']>;
  groups?: InputMaybe<Array<InputMaybe<MenuItemGroupsInput>>>;
  hidden_until?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  ingredients?: InputMaybe<Scalars['String']['input']>;
  menuId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  price: Scalars['Float']['input'];
  promotionTags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sort: Scalars['Int']['input'];
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type MenuItemSize = {
  default: Scalars['Boolean']['output'];
  groups?: Maybe<Array<Maybe<MenuGroup>>>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  price: Scalars['String']['output'];
};

export type MenuOption = {
  default: Scalars['Boolean']['output'];
  groupId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  image?: Maybe<Scalars['String']['output']>;
  menuId: Scalars['String']['output'];
  menuItemId?: Maybe<Scalars['String']['output']>;
  menuItemName?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  price: Scalars['Float']['output'];
  shortName?: Maybe<Scalars['String']['output']>;
  sort: Scalars['Int']['output'];
};

export type MenuOptionInput = {
  default: Scalars['Boolean']['input'];
  groupId: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  menuId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  price: Scalars['Float']['input'];
  shortName?: InputMaybe<Scalars['String']['input']>;
  sort: Scalars['Int']['input'];
};

export enum MenuStatus {
  Draft = 'draft',
  Published = 'published'
}

export type Merchant = {
  abn: Scalars['String']['output'];
  address: Scalars['String']['output'];
  addressObject?: Maybe<AddressObject>;
  altName?: Maybe<Scalars['String']['output']>;
  bookingMerchantId?: Maybe<Scalars['String']['output']>;
  city: Scalars['String']['output'];
  contactEmail?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  holidaySurcharge?: Maybe<HolidaySurcharge>;
  latitude?: Maybe<Scalars['Float']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  logoImages?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  longitude?: Maybe<Scalars['Float']['output']>;
  loyaltyProgram?: Maybe<LoyaltyProgram>;
  loyaltyPromotionId?: Maybe<Scalars['ID']['output']>;
  merchantAdminEmail?: Maybe<Scalars['String']['output']>;
  merchantId: Scalars['ID']['output'];
  merchantStatus?: Maybe<MerchantStatus>;
  name: Scalars['String']['output'];
  onlineOrderCount?: Maybe<Scalars['Int']['output']>;
  onlineStatus?: Maybe<Scalars['Boolean']['output']>;
  openTime?: Maybe<OpenTime>;
  orderbuddyMerchantId?: Maybe<Scalars['String']['output']>;
  overview?: Maybe<MerchantOverview>;
  phoneNumber: Scalars['String']['output'];
  restaurantCategory?: Maybe<RestaurantCategory>;
  restaurantType?: Maybe<RestaurantType>;
  serviceMonthlyPrice?: Maybe<Scalars['Float']['output']>;
  settings?: Maybe<MerchantSetings>;
  stateOrProvinceCode?: Maybe<Scalars['String']['output']>;
  suburb: Scalars['String']['output'];
  surchargeSettings?: Maybe<Array<Maybe<Surcharge>>>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  timezone?: Maybe<Scalars['String']['output']>;
  type: MerchantType;
};

export type MerchantArea = {
  colorB: Scalars['Float']['output'];
  colorG: Scalars['Float']['output'];
  colorR: Scalars['Float']['output'];
  description?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  sort: Scalars['Int']['output'];
  tables?: Maybe<Array<Maybe<MerchantTable>>>;
};

export type MerchantInput = {
  abn: Scalars['String']['input'];
  address: Scalars['String']['input'];
  altName?: InputMaybe<Scalars['String']['input']>;
  bookingMerchantId?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
  merchantAdminEmail: Scalars['String']['input'];
  merchantId: Scalars['ID']['input'];
  merchantStatus: MerchantStatus;
  name: Scalars['String']['input'];
  orderbuddyMerchantId?: InputMaybe<Scalars['String']['input']>;
  phoneNumber: Scalars['String']['input'];
  restaurantCategory?: InputMaybe<RestaurantCategory>;
  restaurantType?: InputMaybe<RestaurantType>;
  serviceMonthlyPrice?: InputMaybe<Scalars['Float']['input']>;
  suburb: Scalars['String']['input'];
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  timezone: Scalars['String']['input'];
  type: MerchantType;
};

export type MerchantOverview = {
  highlights?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  overview?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  topRecommendations?: Maybe<Array<Maybe<SimpleMenuItem>>>;
};

export type MerchantSetings = {
  appServices?: Maybe<Array<Maybe<AppService>>>;
  areSoldOutItemsDisplayedInApp?: Maybe<Scalars['Boolean']['output']>;
  isStripePaymentEnabled?: Maybe<Scalars['Boolean']['output']>;
  maxPromotions?: Maybe<Scalars['Int']['output']>;
  stripeAccountId?: Maybe<Scalars['String']['output']>;
};

export type MerchantSetingsInput = {
  appServices?: InputMaybe<Array<InputMaybe<AppService>>>;
  areSoldOutItemsDisplayedInApp?: InputMaybe<Scalars['Boolean']['input']>;
  isStripePaymentEnabled: Scalars['Boolean']['input'];
  maxPromotions: Scalars['Int']['input'];
  stripeAccountId?: InputMaybe<Scalars['String']['input']>;
};

export enum MerchantStatus {
  Active = 'active',
  Inactive = 'inactive',
  Pending = 'pending'
}

export type MerchantTable = {
  colorB: Scalars['Float']['output'];
  colorG: Scalars['Float']['output'];
  colorR: Scalars['Float']['output'];
  height: Scalars['Float']['output'];
  isSymbol: Scalars['Boolean']['output'];
  maximumNumberOfGuests: Scalars['Int']['output'];
  minimumNumberOfGuests: Scalars['Int']['output'];
  rotationAngle: Scalars['Int']['output'];
  tableNumber: Scalars['String']['output'];
  width: Scalars['Float']['output'];
  x: Scalars['Float']['output'];
  y: Scalars['Float']['output'];
};

export enum MerchantType {
  Bakery = 'Bakery',
  Bar = 'Bar',
  Cafe = 'Cafe',
  Club = 'Club',
  Grocery = 'Grocery',
  Ktv = 'KTV',
  Other = 'Other',
  Restaurant = 'Restaurant',
  Retail = 'Retail',
  Salon = 'Salon',
  Supermarket = 'Supermarket'
}

export type Mutation = {
  addUserToMerchant: Scalars['Boolean']['output'];
  adjustGiftCardAccount?: Maybe<GiftCardAccount>;
  changePassword: Scalars['Boolean']['output'];
  createAppSection: Scalars['Boolean']['output'];
  createBookingSession: Scalars['Boolean']['output'];
  createBuyNGetNFreePromotion: Scalars['Boolean']['output'];
  createFAQQuestion: Scalars['Boolean']['output'];
  createFAQSection: Scalars['Boolean']['output'];
  createGiftCard?: Maybe<GiftCard>;
  createGiftCardAccount?: Maybe<Scalars['ID']['output']>;
  createGiftCards?: Maybe<Scalars['Boolean']['output']>;
  createLoyaltyPromotion: Scalars['Boolean']['output'];
  createLuckyDrawPromotion: Scalars['Boolean']['output'];
  createMenu: Scalars['Boolean']['output'];
  createMenuCategory: Scalars['Boolean']['output'];
  createMenuGroup: Scalars['Boolean']['output'];
  createMenuGroupOption: Scalars['Boolean']['output'];
  createMenuItem: Scalars['Boolean']['output'];
  createMerchant: Scalars['Boolean']['output'];
  createOrUpdateTopRestaurantTypes?: Maybe<Scalars['Boolean']['output']>;
  createPercentagePromotion: Scalars['Boolean']['output'];
  createSpendPromotion: Scalars['Boolean']['output'];
  createSubscriptionPaymentSession?: Maybe<Scalars['String']['output']>;
  createUser: Scalars['Boolean']['output'];
  deleteAppSection: Scalars['Boolean']['output'];
  deleteFAQQuestion: Scalars['Boolean']['output'];
  deleteFAQSection: Scalars['Boolean']['output'];
  deleteGiftCardAccount?: Maybe<Scalars['Boolean']['output']>;
  deleteMenu: Scalars['Boolean']['output'];
  deleteMenuCategory: Scalars['Boolean']['output'];
  deleteMenuGroup: Scalars['Boolean']['output'];
  deleteMenuItemImage: Scalars['Boolean']['output'];
  deleteMerchantLogo: Scalars['Boolean']['output'];
  deletePromotion: Scalars['Boolean']['output'];
  deleteUser: Scalars['Boolean']['output'];
  hideItemToday: Scalars['Boolean']['output'];
  hideOrShowItem: Scalars['Boolean']['output'];
  login: User;
  logout: Scalars['Boolean']['output'];
  moveMenuItemImage: Scalars['Boolean']['output'];
  publishAppSection: Scalars['Boolean']['output'];
  publishMenu: Scalars['Boolean']['output'];
  publishPromotion: Scalars['Boolean']['output'];
  refundGiftCardAmount?: Maybe<Scalars['Boolean']['output']>;
  resentGiftCard?: Maybe<Scalars['Boolean']['output']>;
  resetPassword: Scalars['Boolean']['output'];
  switchGiftCardAccount?: Maybe<Scalars['Boolean']['output']>;
  switchMerchant: Scalars['Boolean']['output'];
  syncPOSMerchantBasicInfo: Scalars['Boolean']['output'];
  syncPOSMerchantData: Scalars['Boolean']['output'];
  syncPOSMerchantOpenHours: Scalars['Boolean']['output'];
  syncPOSMerchantTables: Scalars['Boolean']['output'];
  tokenLogin: User;
  unpublishPromotion: Scalars['Boolean']['output'];
  updateAppSection: Scalars['Boolean']['output'];
  updateBookingSession: Scalars['Boolean']['output'];
  updateBuyNGetNFreePromotion: Scalars['Boolean']['output'];
  updateFAQQuestion: Scalars['Boolean']['output'];
  updateFAQSection: Scalars['Boolean']['output'];
  updateGiftCardAdminUsers?: Maybe<GiftCardAccount>;
  updateLoyaltyPromotion: Scalars['Boolean']['output'];
  updateLuckyDrawPromotion: Scalars['Boolean']['output'];
  updateMenu: Scalars['Boolean']['output'];
  updateMenuCategory: Scalars['Boolean']['output'];
  updateMenuGroup: Scalars['Boolean']['output'];
  updateMenuGroupOptions: Scalars['Boolean']['output'];
  updateMenuItem: Scalars['Boolean']['output'];
  updateMenuItemGroups: Scalars['Boolean']['output'];
  updateMenuItems: Scalars['Boolean']['output'];
  updateMerchant: Scalars['Boolean']['output'];
  updateMerchantDailyOrderNumbers: Scalars['Boolean']['output'];
  updateMerchantHolidaySurcharge: Scalars['Boolean']['output'];
  updateMerchantLogos: Scalars['Boolean']['output'];
  updateMerchantOnlineStatus: Scalars['Boolean']['output'];
  updateMerchantOpenTime: Scalars['Boolean']['output'];
  updateMerchantSettings: Scalars['Boolean']['output'];
  updateMerchantStatus: Scalars['Boolean']['output'];
  updateMerchantSurcharges: Scalars['Boolean']['output'];
  updatePercentagePromotion: Scalars['Boolean']['output'];
  updateSpendPromotion: Scalars['Boolean']['output'];
  updateUser: Scalars['Boolean']['output'];
  updateUserDetails: Scalars['Boolean']['output'];
  voidGiftCard?: Maybe<Scalars['Boolean']['output']>;
};


export type MutationAddUserToMerchantArgs = {
  email: Scalars['String']['input'];
  merchantId: Scalars['String']['input'];
  role: UserRole;
  roles?: InputMaybe<Array<UserRole>>;
};


export type MutationAdjustGiftCardAccountArgs = {
  input: AdjustGiftCardInput;
};


export type MutationChangePasswordArgs = {
  newPassword: Scalars['String']['input'];
  oldPassword: Scalars['String']['input'];
};


export type MutationCreateAppSectionArgs = {
  section: AppSectionInput;
};


export type MutationCreateBookingSessionArgs = {
  bookingSession: BookingSessionInput;
};


export type MutationCreateBuyNGetNFreePromotionArgs = {
  promotion: BuyNGetNFreePromotionInput;
};


export type MutationCreateFaqQuestionArgs = {
  app: ObApp;
  question: ObfaqQuestionInput;
  sectionId: Scalars['ID']['input'];
};


export type MutationCreateFaqSectionArgs = {
  app: ObApp;
  section: ObfaqSectionInput;
};


export type MutationCreateGiftCardArgs = {
  input: GiftCardInput;
};


export type MutationCreateGiftCardAccountArgs = {
  input: GiftCardAccountInput;
};


export type MutationCreateGiftCardsArgs = {
  input: Array<GiftCardInput>;
};


export type MutationCreateLoyaltyPromotionArgs = {
  promotion: LoyaltyPromotionInput;
};


export type MutationCreateLuckyDrawPromotionArgs = {
  promotion: LuckyDrawPromotionInput;
};


export type MutationCreateMenuArgs = {
  menu: MenuInput;
};


export type MutationCreateMenuCategoryArgs = {
  category?: InputMaybe<MenuCategoryInput>;
};


export type MutationCreateMenuGroupArgs = {
  group: MenuGroupInput;
};


export type MutationCreateMenuGroupOptionArgs = {
  option: MenuOptionInput;
};


export type MutationCreateMenuItemArgs = {
  item?: InputMaybe<MenuItemInput>;
};


export type MutationCreateMerchantArgs = {
  merchant: MerchantInput;
};


export type MutationCreateOrUpdateTopRestaurantTypesArgs = {
  types: Array<InputMaybe<RestaurantType>>;
};


export type MutationCreatePercentagePromotionArgs = {
  promotion: PercentagePromotionInput;
};


export type MutationCreateSpendPromotionArgs = {
  promotion: SpendPromotionInput;
};


export type MutationCreateSubscriptionPaymentSessionArgs = {
  priceId: Scalars['String']['input'];
};


export type MutationCreateUserArgs = {
  email: Scalars['String']['input'];
  merchantId?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  password: Scalars['String']['input'];
  role: UserRole;
  roles?: InputMaybe<Array<UserRole>>;
};


export type MutationDeleteAppSectionArgs = {
  sectionId: Scalars['ID']['input'];
};


export type MutationDeleteFaqQuestionArgs = {
  app: ObApp;
  questionId: Scalars['ID']['input'];
  sectionId: Scalars['ID']['input'];
};


export type MutationDeleteFaqSectionArgs = {
  app: ObApp;
  sectionId: Scalars['ID']['input'];
};


export type MutationDeleteGiftCardAccountArgs = {
  giftCardAccountId: Scalars['ID']['input'];
};


export type MutationDeleteMenuArgs = {
  menuId: Scalars['String']['input'];
};


export type MutationDeleteMenuCategoryArgs = {
  categroyId: Scalars['String']['input'];
  menuId: Scalars['String']['input'];
};


export type MutationDeleteMenuGroupArgs = {
  groupId: Scalars['String']['input'];
  menuId: Scalars['String']['input'];
};


export type MutationDeleteMenuItemImageArgs = {
  categroyId: Scalars['String']['input'];
  menuId: Scalars['String']['input'];
  menuItemId: Scalars['String']['input'];
};


export type MutationDeleteMerchantLogoArgs = {
  imageName: Scalars['String']['input'];
};


export type MutationDeletePromotionArgs = {
  promotionId: Scalars['String']['input'];
};


export type MutationDeleteUserArgs = {
  email: Scalars['String']['input'];
};


export type MutationHideItemTodayArgs = {
  isHidden: Scalars['Boolean']['input'];
  menuItemId: Scalars['String']['input'];
};


export type MutationHideOrShowItemArgs = {
  isHidden: Scalars['Boolean']['input'];
  menuItemId: Scalars['String']['input'];
};


export type MutationLoginArgs = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};


export type MutationMoveMenuItemImageArgs = {
  fromCategoryId: Scalars['ID']['input'];
  menuId: Scalars['ID']['input'];
  menuItemId: Scalars['ID']['input'];
  toCategoryId: Scalars['ID']['input'];
};


export type MutationPublishAppSectionArgs = {
  sectionId: Scalars['ID']['input'];
};


export type MutationPublishMenuArgs = {
  menuId: Scalars['String']['input'];
};


export type MutationPublishPromotionArgs = {
  promotionId: Scalars['String']['input'];
};


export type MutationRefundGiftCardAmountArgs = {
  amount: Scalars['Int']['input'];
  merchantId?: InputMaybe<Scalars['String']['input']>;
  orderNumber?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['ID']['input'];
};


export type MutationResentGiftCardArgs = {
  giftCardId: Scalars['ID']['input'];
};


export type MutationResetPasswordArgs = {
  email: Scalars['String']['input'];
};


export type MutationSwitchGiftCardAccountArgs = {
  giftCardAccountId: Scalars['ID']['input'];
};


export type MutationSwitchMerchantArgs = {
  merchantId: Scalars['String']['input'];
};


export type MutationTokenLoginArgs = {
  token: Scalars['String']['input'];
};


export type MutationUnpublishPromotionArgs = {
  promotionId: Scalars['String']['input'];
};


export type MutationUpdateAppSectionArgs = {
  section: AppSectionInput;
  sectionId: Scalars['ID']['input'];
};


export type MutationUpdateBookingSessionArgs = {
  bookingSession: BookingSessionInput;
  bookingSessionId: Scalars['String']['input'];
};


export type MutationUpdateBuyNGetNFreePromotionArgs = {
  promotion: BuyNGetNFreePromotionInput;
  promotionId: Scalars['String']['input'];
};


export type MutationUpdateFaqQuestionArgs = {
  app: ObApp;
  question: ObfaqQuestionInput;
  questionId: Scalars['ID']['input'];
  sectionId: Scalars['ID']['input'];
};


export type MutationUpdateFaqSectionArgs = {
  app: ObApp;
  section: ObfaqSectionInput;
  sectionId: Scalars['ID']['input'];
};


export type MutationUpdateGiftCardAdminUsersArgs = {
  giftCardAccountId: Scalars['ID']['input'];
  userIds: Array<Scalars['ID']['input']>;
};


export type MutationUpdateLoyaltyPromotionArgs = {
  promotion: LoyaltyPromotionInput;
  promotionId: Scalars['String']['input'];
};


export type MutationUpdateLuckyDrawPromotionArgs = {
  promotion: LuckyDrawPromotionInput;
  promotionId: Scalars['String']['input'];
};


export type MutationUpdateMenuArgs = {
  menu: MenuInput;
  menuId: Scalars['String']['input'];
};


export type MutationUpdateMenuCategoryArgs = {
  category: MenuCategoryInput;
  categroyId: Scalars['String']['input'];
  menuId: Scalars['String']['input'];
};


export type MutationUpdateMenuGroupArgs = {
  group: MenuGroupInput;
  groupId: Scalars['String']['input'];
  menuId: Scalars['String']['input'];
};


export type MutationUpdateMenuGroupOptionsArgs = {
  groupId: Scalars['String']['input'];
  menuId: Scalars['String']['input'];
  options: Array<InputMaybe<MenuOptionInput>>;
};


export type MutationUpdateMenuItemArgs = {
  categroyId: Scalars['String']['input'];
  menuId: Scalars['String']['input'];
  menuItem: MenuItemInput;
};


export type MutationUpdateMenuItemGroupsArgs = {
  categroyId: Scalars['String']['input'];
  groups?: InputMaybe<Array<InputMaybe<MenuItemGroupsInput>>>;
  menuId: Scalars['String']['input'];
  menuItemId: Scalars['String']['input'];
};


export type MutationUpdateMenuItemsArgs = {
  categroyId: Scalars['String']['input'];
  items: Array<InputMaybe<MenuItemInput>>;
  menuId: Scalars['String']['input'];
};


export type MutationUpdateMerchantArgs = {
  merchant: MerchantInput;
};


export type MutationUpdateMerchantDailyOrderNumbersArgs = {
  onlineOrderCount: Scalars['Int']['input'];
};


export type MutationUpdateMerchantHolidaySurchargeArgs = {
  holidaySurcharge: HolidaySurchargeInput;
  merchantId: Scalars['ID']['input'];
};


export type MutationUpdateMerchantLogosArgs = {
  urlStringArray: Array<InputMaybe<Scalars['String']['input']>>;
};


export type MutationUpdateMerchantOnlineStatusArgs = {
  onlineStatus: Scalars['Boolean']['input'];
};


export type MutationUpdateMerchantOpenTimeArgs = {
  merchantId: Scalars['String']['input'];
  openTime: OpenTimeInput;
};


export type MutationUpdateMerchantSettingsArgs = {
  merchantId: Scalars['ID']['input'];
  merchantSettings: MerchantSetingsInput;
};


export type MutationUpdateMerchantStatusArgs = {
  status: MerchantStatus;
};


export type MutationUpdateMerchantSurchargesArgs = {
  merchantId: Scalars['ID']['input'];
  surcharges: Array<InputMaybe<SurchargeInput>>;
};


export type MutationUpdatePercentagePromotionArgs = {
  promotion: PercentagePromotionInput;
  promotionId: Scalars['String']['input'];
};


export type MutationUpdateSpendPromotionArgs = {
  promotion: SpendPromotionInput;
  promotionId: Scalars['String']['input'];
};


export type MutationUpdateUserArgs = {
  user: AccountInput;
};


export type MutationUpdateUserDetailsArgs = {
  user: UserInput;
};


export type MutationVoidGiftCardArgs = {
  giftCardId: Scalars['ID']['input'];
};

export enum ObApp {
  Booking = 'booking',
  MerchantApp = 'merchantApp',
  MerchantPortal = 'merchantPortal',
  MobileBuddy = 'mobileBuddy',
  OrderbuddyApp = 'orderbuddyApp',
  OrderbuddyPortal = 'orderbuddyPortal',
  Pos = 'pos'
}

export type Obfaq = {
  app: ObApp;
  sections?: Maybe<Array<Maybe<ObfaqSection>>>;
};

export type ObfaqQuestion = {
  answer: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  question: Scalars['String']['output'];
  sort: Scalars['Int']['output'];
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  videoUrl?: Maybe<Scalars['String']['output']>;
};

export type ObfaqQuestionInput = {
  answer: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  question: Scalars['String']['input'];
  sort: Scalars['Int']['input'];
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  videoUrl?: InputMaybe<Scalars['String']['input']>;
};

export type ObfaqSection = {
  app: ObApp;
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  questions?: Maybe<Array<Maybe<ObfaqQuestion>>>;
  sort: Scalars['Int']['output'];
  title: Scalars['String']['output'];
};

export type ObfaqSectionInput = {
  description: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  questions?: InputMaybe<Array<InputMaybe<ObfaqQuestionInput>>>;
  sort: Scalars['Int']['input'];
  title: Scalars['String']['input'];
};

export type ObOrder = {
  appVersion?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Int']['output'];
  merchant: OrderMerchant;
  mobileModel?: Maybe<Scalars['String']['output']>;
  mobileOS?: Maybe<Scalars['String']['output']>;
  order: Order;
  orderFrom: OrderFrom;
  orderNumber: Scalars['String']['output'];
  orderStatus?: Maybe<OrderStatus>;
  sourceType?: Maybe<OrderSourceType>;
  user: Customer;
};

export type OfferVoucherSettings = {
  displaySettings?: Maybe<ItemDisplaySettings>;
  effectiveDateTime: Array<Maybe<EffectiveDateTime>>;
  effectiveHoursAfterOfferActivated: Scalars['Int']['output'];
  minimumAmount?: Maybe<Scalars['Float']['output']>;
  offerDescription?: Maybe<Scalars['String']['output']>;
  offerExcludedItemTags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  offerName: Scalars['String']['output'];
  upToAmount?: Maybe<Scalars['Float']['output']>;
  voucherTerms: Scalars['String']['output'];
};

export type OfferVoucherSettingsInput = {
  displaySettings: ItemDisplaySettingsInput;
  effectiveDateTime: Array<InputMaybe<EffectiveDateTimeInput>>;
  effectiveHoursAfterOfferActivated: Scalars['Int']['input'];
  minimumAmount?: InputMaybe<Scalars['Float']['input']>;
  offerDescription?: InputMaybe<Scalars['String']['input']>;
  offerExcludedItemTags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  offerName: Scalars['String']['input'];
  upToAmount?: InputMaybe<Scalars['Float']['input']>;
  voucherTerms: Scalars['String']['input'];
};

export type OpenHours = {
  openEnd: Scalars['Int']['output'];
  openStart: Scalars['Int']['output'];
  weekDays: Array<Maybe<Weekday>>;
};

export type OpenHoursInput = {
  openEnd: Scalars['Int']['input'];
  openStart: Scalars['Int']['input'];
  weekDays: Array<InputMaybe<Weekday>>;
};

export type OpenTime = {
  closeDates?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  openHours: Array<Maybe<OpenHours>>;
};

export type OpenTimeInput = {
  closeDates?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  openHours: Array<InputMaybe<OpenHoursInput>>;
};

export type OptionItem = {
  id: Scalars['String']['output'];
  menuItemCategory?: Maybe<Scalars['String']['output']>;
  menuItemId?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  optionDefault?: Maybe<Scalars['Boolean']['output']>;
  optionId?: Maybe<Scalars['String']['output']>;
  price: Scalars['Float']['output'];
  quantity: Scalars['Int']['output'];
  shortName?: Maybe<Scalars['String']['output']>;
  sort: Scalars['Int']['output'];
};

export type Order = {
  adjustments?: Maybe<Array<Maybe<OrderAdjustment>>>;
  items?: Maybe<Array<Maybe<OrderItem>>>;
  notes?: Maybe<Scalars['String']['output']>;
  orderTime?: Maybe<Scalars['Int']['output']>;
  paymentType: PaymentType;
  pickupTime?: Maybe<Scalars['String']['output']>;
  pickupTimeType?: Maybe<Scalars['String']['output']>;
  promotions?: Maybe<Array<PromotionItem>>;
  selectedDate?: Maybe<Scalars['String']['output']>;
  total: Scalars['Float']['output'];
  type: OrderType;
  voucher?: Maybe<Voucher>;
};

export type OrderAdjustment = {
  adjustmentType?: Maybe<OrderAdjustmentType>;
  amount?: Maybe<Scalars['Float']['output']>;
  createdTime: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  isDeletedAdj: Scalars['Boolean']['output'];
  isDishAdjustment: Scalars['Boolean']['output'];
  isDishOptionsIncluded: Scalars['Boolean']['output'];
  isOrderAdjustment: Scalars['Boolean']['output'];
  isPaymentSurcharge: Scalars['Boolean']['output'];
  isPercentage: Scalars['Boolean']['output'];
  isRefunded: Scalars['Boolean']['output'];
  isVoidedAdj: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  percentage?: Maybe<Scalars['Float']['output']>;
  percentageDecimalValue: Scalars['Float']['output'];
  permanentDeletion: Scalars['Boolean']['output'];
  priceDecimal: Scalars['Float']['output'];
  promotionId?: Maybe<Scalars['String']['output']>;
  promotionVersion?: Maybe<Scalars['String']['output']>;
  referencePaymentId: Scalars['String']['output'];
  selfUUID: Scalars['String']['output'];
  sendby: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
  voucherNo?: Maybe<Scalars['String']['output']>;
};

export enum OrderAdjustmentType {
  CardSurcharge = 'cardSurcharge',
  Discount = 'discount',
  HolidaySurcharge = 'holidaySurcharge',
  OtherSurcharge = 'otherSurcharge',
  Surcharge = 'surcharge',
  Tax = 'tax',
  Tip = 'tip'
}

export enum OrderFrom {
  OrderbuddyAppAndroid = 'orderbuddyAppAndroid',
  OrderbuddyAppIos = 'orderbuddyAppIos',
  Orderbuddyweb = 'orderbuddyweb',
  ThirdParty = 'thirdParty'
}

export type OrderItem = {
  dish?: Maybe<MenuItem>;
  id: Scalars['String']['output'];
  isTakeaway?: Maybe<Scalars['Boolean']['output']>;
  options?: Maybe<Array<Maybe<OptionItem>>>;
  quantity?: Maybe<Scalars['Int']['output']>;
  size?: Maybe<MenuItemSize>;
  specialInstructions?: Maybe<Scalars['String']['output']>;
  subTotal?: Maybe<Scalars['Float']['output']>;
};

export type OrderMerchant = {
  merchantId: Scalars['String']['output'];
  merchantName?: Maybe<Scalars['String']['output']>;
  rawTableId?: Maybe<Scalars['String']['output']>;
  tableId?: Maybe<Scalars['String']['output']>;
};

export enum OrderSourceType {
  Mobile = 'mobile',
  Pos = 'pos',
  ThirdParty = 'thirdParty',
  Web = 'web'
}

export enum OrderStatus {
  Deleted = 'deleted',
  None = 'none',
  PaymentFailed = 'paymentFailed',
  PaymentPending = 'paymentPending',
  PaymentSuccess = 'paymentSuccess',
  ReadyForPickup = 'readyForPickup',
  Received = 'received',
  Refunded = 'refunded',
  SentToKitchen = 'sentToKitchen'
}

export enum OrderType {
  Delivery = 'delivery',
  Dinein = 'dinein',
  Foodcourt = 'foodcourt',
  Pickup = 'pickup',
  Takeaway = 'takeaway'
}

export enum PaymentType {
  Alipay = 'alipay',
  Card = 'card',
  Cash = 'cash',
  Other = 'other',
  PayAtCounter = 'payAtCounter',
  Paylater = 'paylater',
  Paypal = 'paypal',
  WechatPay = 'wechatPay'
}

export type PercentagePromotion = {
  applyOptionDiscount?: Maybe<Scalars['Boolean']['output']>;
  availableType?: Maybe<Array<Maybe<OrderType>>>;
  canBeUsedWithOtherPromotions?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  discountAmount: Scalars['Float']['output'];
  displaySettings?: Maybe<ItemDisplaySettings>;
  effectiveDateTime: Array<Maybe<EffectiveDateTime>>;
  excludedPromotionTags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  id: Scalars['ID']['output'];
  includedGetItemsPromoTags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  includedPromotionTags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  isHiddenInApp?: Maybe<Scalars['Boolean']['output']>;
  isLoyalty?: Maybe<Scalars['Boolean']['output']>;
  isOffer?: Maybe<Scalars['Boolean']['output']>;
  isPaymentRequired?: Maybe<Scalars['Boolean']['output']>;
  isPercentage: Scalars['Boolean']['output'];
  isSignUpPromotion?: Maybe<Scalars['Boolean']['output']>;
  loyaltyDetails?: Maybe<LoyaltyDetails>;
  merchantId: Scalars['String']['output'];
  minimumAmount?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  numberOfDeals: Scalars['Int']['output'];
  offerVoucherSettings?: Maybe<OfferVoucherSettings>;
  percentage: Scalars['Float']['output'];
  status: PromotionStatus;
  upToAmount?: Maybe<Scalars['Float']['output']>;
  useType: PromotionUseType;
};

export type PercentagePromotionInput = {
  applyOptionDiscount?: InputMaybe<Scalars['Boolean']['input']>;
  availableType?: InputMaybe<Array<InputMaybe<OrderType>>>;
  canBeUsedWithOtherPromotions: Scalars['Boolean']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  discountAmount: Scalars['Float']['input'];
  displaySettings: ItemDisplaySettingsInput;
  effectiveDateTime: Array<InputMaybe<EffectiveDateTimeInput>>;
  excludedPromotionTags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  includedGetItemsPromoTags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  includedPromotionTags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isHiddenInApp?: InputMaybe<Scalars['Boolean']['input']>;
  isLoyalty?: InputMaybe<Scalars['Boolean']['input']>;
  isOffer?: InputMaybe<Scalars['Boolean']['input']>;
  isPaymentRequired?: InputMaybe<Scalars['Boolean']['input']>;
  isPercentage: Scalars['Boolean']['input'];
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  isSignUpPromotion?: InputMaybe<Scalars['Boolean']['input']>;
  loyaltyDetails?: InputMaybe<LoyaltyDetailsInput>;
  minimumAmount?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  numberOfDeals: Scalars['Int']['input'];
  offerVoucherSettings?: InputMaybe<OfferVoucherSettingsInput>;
  percentage: Scalars['Float']['input'];
  upToAmount?: InputMaybe<Scalars['Float']['input']>;
  useType: PromotionUseType;
};

export type Promotion = {
  applyOptionDiscount?: Maybe<Scalars['Boolean']['output']>;
  availableType?: Maybe<Array<Maybe<OrderType>>>;
  bookings?: Maybe<Array<Maybe<Booking>>>;
  buyN?: Maybe<Scalars['Int']['output']>;
  canBeUsedWithOtherPromotions?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['Float']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  discountAmount?: Maybe<Scalars['Float']['output']>;
  discountedItemQty?: Maybe<Scalars['Int']['output']>;
  displaySettings?: Maybe<ItemDisplaySettings>;
  effectiveDateTime: Array<Maybe<EffectiveDateTime>>;
  entryLimitPerUser?: Maybe<Scalars['Int']['output']>;
  entrySpendAmountCents?: Maybe<Scalars['Int']['output']>;
  excludedPromotionTags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  freeN?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  includedGetItemsPromoTags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  includedPromotionTags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  isEntryAutomatic?: Maybe<Scalars['Boolean']['output']>;
  isHiddenInApp?: Maybe<Scalars['Boolean']['output']>;
  isLoyalty?: Maybe<Scalars['Boolean']['output']>;
  isOffer?: Maybe<Scalars['Boolean']['output']>;
  isPaymentRequired?: Maybe<Scalars['Boolean']['output']>;
  isPercentage?: Maybe<Scalars['Boolean']['output']>;
  isSignUpPromotion?: Maybe<Scalars['Boolean']['output']>;
  loyaltyDetails?: Maybe<LoyaltyDetails>;
  loyaltySettings?: Maybe<LoyaltySettings>;
  merchantId: Scalars['String']['output'];
  minimumAmount?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  numberOfDeals: Scalars['Int']['output'];
  offerVoucherSettings?: Maybe<OfferVoucherSettings>;
  orders?: Maybe<Array<Maybe<ObOrder>>>;
  percentage?: Maybe<Scalars['Float']['output']>;
  prizeDescription?: Maybe<Scalars['String']['output']>;
  resultingPromotionNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  resultingPromotions?: Maybe<Array<ResultingPromotion>>;
  status: PromotionStatus;
  termsAndConditions?: Maybe<Scalars['String']['output']>;
  type: PromotionType;
  upToAmount?: Maybe<Scalars['Float']['output']>;
  useType: PromotionUseType;
  usedQuantity?: Maybe<Scalars['Int']['output']>;
  winCountLimitPerPerson?: Maybe<Scalars['Int']['output']>;
  winPercentage?: Maybe<Scalars['Float']['output']>;
  winnerCount?: Maybe<Scalars['Int']['output']>;
};

export type PromotionItem = {
  items: Array<OrderItem>;
  promotion: Promotion;
};

export enum PromotionStatus {
  Draft = 'draft',
  Published = 'published'
}

export enum PromotionType {
  BuynGetFree = 'buynGetFree',
  Loyalty = 'loyalty',
  LuckyDraw = 'luckyDraw',
  Percentage = 'percentage',
  Spend = 'spend',
  Voucher = 'voucher'
}

export enum PromotionUseType {
  Employee = 'employee',
  Giftcard = 'giftcard',
  LuckyDraw = 'luckyDraw',
  Offer = 'offer',
  Promotion = 'promotion',
  Refund = 'refund',
  Reward = 'reward'
}

export type Query = {
  apiVersion: Scalars['String']['output'];
  appSections?: Maybe<Array<Maybe<AppSection>>>;
  booking?: Maybe<Booking>;
  bookingSession?: Maybe<BookingSession>;
  bookingSessions?: Maybe<Array<Maybe<BookingSession>>>;
  bookings?: Maybe<Array<Maybe<Booking>>>;
  faq?: Maybe<Obfaq>;
  getAllMerchants?: Maybe<Array<Maybe<Merchant>>>;
  getAllUsers?: Maybe<Array<Maybe<User>>>;
  getBuyNGetNFreePromotion?: Maybe<BuyNGetNFreePromotion>;
  getInactiveItems?: Maybe<Array<Maybe<InactiveItem>>>;
  getLuckyDrawPromotion?: Maybe<LuckyDrawPromotion>;
  getMenu?: Maybe<Menu>;
  getMenuCategories?: Maybe<Array<Maybe<MenuCategory>>>;
  getMenuGroups?: Maybe<Array<Maybe<MenuGroup>>>;
  getMenus?: Maybe<Array<Maybe<Menu>>>;
  getMerchant: Merchant;
  getPercentagePromotion?: Maybe<PercentagePromotion>;
  getProducts?: Maybe<Array<Maybe<StripePrice>>>;
  getPromotions?: Maybe<Array<Maybe<Promotion>>>;
  getPublishedMenuCategories?: Maybe<Array<Maybe<MenuCategory>>>;
  getSpendPromotion?: Maybe<SpendPromotion>;
  getUserDetail: User;
  giftCardAccount?: Maybe<GiftCardAccount>;
  giftCardAccounts?: Maybe<Array<GiftCardAccount>>;
  loyaltyMembers?: Maybe<Array<Maybe<Loyalty>>>;
  loyaltyPromotion?: Maybe<LoyaltyPromotion>;
  merchantAreas?: Maybe<Array<Maybe<MerchantArea>>>;
  order?: Maybe<ObOrder>;
  orderBuddyAppSections?: Maybe<Array<Maybe<AppSection>>>;
  orders?: Maybe<Array<Maybe<ObOrder>>>;
  posMenu?: Maybe<Menu>;
  posMenus?: Maybe<Array<Maybe<Menu>>>;
  posMerchant?: Maybe<Merchant>;
  searchMerchants?: Maybe<Array<Maybe<Merchant>>>;
  subscriptions?: Maybe<Array<Maybe<StripeSubscription>>>;
  topRestaurantTypes?: Maybe<Array<Maybe<RestaurantType>>>;
  userGiftCard?: Maybe<UserGiftCardAccount>;
};


export type QueryBookingArgs = {
  bookingId: Scalars['String']['input'];
  dateString: Scalars['String']['input'];
};


export type QueryBookingSessionArgs = {
  bookingSessionId: Scalars['String']['input'];
};


export type QueryBookingsArgs = {
  dateString: Scalars['String']['input'];
};


export type QueryFaqArgs = {
  app: ObApp;
};


export type QueryGetBuyNGetNFreePromotionArgs = {
  promotionId: Scalars['String']['input'];
};


export type QueryGetLuckyDrawPromotionArgs = {
  promotionId: Scalars['String']['input'];
};


export type QueryGetMenuArgs = {
  menuId: Scalars['String']['input'];
};


export type QueryGetMenuCategoriesArgs = {
  menuId: Scalars['String']['input'];
};


export type QueryGetMenuGroupsArgs = {
  menuId: Scalars['String']['input'];
};


export type QueryGetMerchantArgs = {
  merchantId: Scalars['String']['input'];
};


export type QueryGetPercentagePromotionArgs = {
  promotionId: Scalars['String']['input'];
};


export type QueryGetSpendPromotionArgs = {
  promotionId: Scalars['String']['input'];
};


export type QueryLoyaltyPromotionArgs = {
  promotionId: Scalars['String']['input'];
};


export type QueryOrderArgs = {
  dateString: Scalars['String']['input'];
  orderNumber: Scalars['String']['input'];
};


export type QueryOrdersArgs = {
  dateString: Scalars['String']['input'];
};


export type QueryPosMenuArgs = {
  menuId: Scalars['String']['input'];
};


export type QueryPosMerchantArgs = {
  posRestaurantId: Scalars['String']['input'];
};


export type QuerySearchMerchantsArgs = {
  query: Scalars['String']['input'];
};


export type QueryUserGiftCardArgs = {
  userId: Scalars['String']['input'];
};

export enum RestaurantCategory {
  American = 'American',
  Arabian = 'Arabian',
  AsianFusion = 'AsianFusion',
  Australian = 'Australian',
  Chinese = 'Chinese',
  French = 'French',
  Indian = 'Indian',
  Italian = 'Italian',
  Japanese = 'Japanese',
  Korean = 'Korean',
  Lebanese = 'Lebanese',
  Malaysian = 'Malaysian',
  Mediterranean = 'Mediterranean',
  Mexican = 'Mexican',
  Other = 'Other',
  Persian = 'Persian',
  Portuguese = 'Portuguese',
  Thai = 'Thai',
  Turish = 'Turish',
  Vietnamese = 'Vietnamese'
}

export enum RestaurantType {
  Bakery = 'Bakery',
  Beverages = 'Beverages',
  BreakfastAndBrunch = 'BreakfastAndBrunch',
  BubbleTea = 'BubbleTea',
  Buffet = 'Buffet',
  Cafe = 'Cafe',
  CasualDining = 'CasualDining',
  Coffee = 'Coffee',
  Desserts = 'Desserts',
  FamilyStyle = 'FamilyStyle',
  FastFood = 'FastFood',
  FineDining = 'FineDining',
  FishChips = 'FishChips',
  Halal = 'Halal',
  IceCreamAndFrozenYoghurt = 'IceCreamAndFrozenYoghurt',
  JuiceAndSmoothies = 'JuiceAndSmoothies',
  Other = 'Other',
  Seafood = 'Seafood',
  Steakhouse = 'Steakhouse',
  Vegetarian = 'Vegetarian'
}

export type ResultingPromotion = {
  promotionId: Scalars['ID']['output'];
  winPercentage: Scalars['Float']['output'];
};

export type ResultingPromotionInput = {
  promotionId: Scalars['ID']['input'];
  winPercentage: Scalars['Float']['input'];
};

export type SimpleMenuItem = {
  altName?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  price: Scalars['Float']['output'];
};

export type SpendProgress = {
  currentSpend: Scalars['Float']['output'];
  promotionId: Scalars['ID']['output'];
  targetSpend: Scalars['Float']['output'];
};

export type SpendPromotion = {
  applyOptionDiscount: Scalars['Boolean']['output'];
  availableType?: Maybe<Array<Maybe<OrderType>>>;
  canBeUsedWithOtherPromotions?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  discountAmount: Scalars['Float']['output'];
  discountedItemQty: Scalars['Int']['output'];
  displaySettings?: Maybe<ItemDisplaySettings>;
  effectiveDateTime: Array<Maybe<EffectiveDateTime>>;
  excludedPromotionTags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  id: Scalars['ID']['output'];
  includedGetItemsPromoTags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  includedPromotionTags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  isHiddenInApp?: Maybe<Scalars['Boolean']['output']>;
  isLoyalty?: Maybe<Scalars['Boolean']['output']>;
  isOffer?: Maybe<Scalars['Boolean']['output']>;
  isPaymentRequired?: Maybe<Scalars['Boolean']['output']>;
  isPercentage: Scalars['Boolean']['output'];
  isSignUpPromotion?: Maybe<Scalars['Boolean']['output']>;
  loyaltyDetails?: Maybe<LoyaltyDetails>;
  merchantId: Scalars['String']['output'];
  minimumAmount: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  numberOfDeals: Scalars['Int']['output'];
  offerVoucherSettings?: Maybe<OfferVoucherSettings>;
  percentage: Scalars['Float']['output'];
  status: PromotionStatus;
  upToAmount?: Maybe<Scalars['Float']['output']>;
  useType: PromotionUseType;
};

export type SpendPromotionInput = {
  applyOptionDiscount: Scalars['Boolean']['input'];
  availableType?: InputMaybe<Array<InputMaybe<OrderType>>>;
  canBeUsedWithOtherPromotions: Scalars['Boolean']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  discountAmount: Scalars['Float']['input'];
  discountedItemQty: Scalars['Int']['input'];
  displaySettings: ItemDisplaySettingsInput;
  effectiveDateTime: Array<InputMaybe<EffectiveDateTimeInput>>;
  excludedPromotionTags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  includedGetItemsPromoTags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  includedPromotionTags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isHiddenInApp?: InputMaybe<Scalars['Boolean']['input']>;
  isLoyalty?: InputMaybe<Scalars['Boolean']['input']>;
  isOffer?: InputMaybe<Scalars['Boolean']['input']>;
  isPaymentRequired?: InputMaybe<Scalars['Boolean']['input']>;
  isPercentage: Scalars['Boolean']['input'];
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  isSignUpPromotion?: InputMaybe<Scalars['Boolean']['input']>;
  loyaltyDetails?: InputMaybe<LoyaltyDetailsInput>;
  minimumAmount: Scalars['Float']['input'];
  name: Scalars['String']['input'];
  numberOfDeals: Scalars['Int']['input'];
  offerVoucherSettings?: InputMaybe<OfferVoucherSettingsInput>;
  percentage: Scalars['Float']['input'];
  upToAmount?: InputMaybe<Scalars['Float']['input']>;
  useType: PromotionUseType;
};

export type StampProgress = {
  currentStamps: Scalars['Int']['output'];
  promotionId: Scalars['ID']['output'];
  targetStamps: Scalars['Int']['output'];
};

export type StripePrice = {
  id: Scalars['ID']['output'];
  product: StripeProduct;
  unit_amount: Scalars['Int']['output'];
};

export type StripeProduct = {
  description: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type StripeSubscription = {
  current_period_start: Scalars['Int']['output'];
  plan: Scalars['String']['output'];
  product: SubscriptionProduct;
};

export type SubscriptionPlan = {
  amount: Scalars['Float']['output'];
  interval: Scalars['String']['output'];
};

export type SubscriptionProduct = {
  description?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export type Surcharge = {
  amount: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  isEnabled: Scalars['Boolean']['output'];
  isPercentage: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  publicHolidayDays?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  surchargeDescription?: Maybe<Scalars['String']['output']>;
  weekdays?: Maybe<Array<Maybe<Weekday>>>;
};

export type SurchargeInput = {
  amount: Scalars['Float']['input'];
  id: Scalars['ID']['input'];
  isEnabled: Scalars['Boolean']['input'];
  isPercentage: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  publicHolidayDays?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  surchargeDescription?: InputMaybe<Scalars['String']['input']>;
  weekDays?: InputMaybe<Array<InputMaybe<Weekday>>>;
};

export type User = {
  createdAt: Scalars['Date']['output'];
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  loginToken?: Maybe<Scalars['String']['output']>;
  merchantId?: Maybe<Scalars['ID']['output']>;
  name: Scalars['String']['output'];
  permissions?: Maybe<Array<Maybe<UserPermission>>>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  role: UserRole;
  roles?: Maybe<Array<UserRole>>;
};

export type UserGiftCardAccount = {
  activities?: Maybe<Array<UserGiftCardActivity>>;
  balance: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type UserGiftCardActivity = {
  amount: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  giftCardAccountId?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  merchantId?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  orderNumber?: Maybe<Scalars['String']['output']>;
  orderRef?: Maybe<Scalars['String']['output']>;
  redeemCode?: Maybe<Scalars['String']['output']>;
  sender?: Maybe<Scalars['String']['output']>;
  serialNumber?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type UserInput = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export enum UserPermission {
  AdminDashboard = 'adminDashboard',
  AdsManagement = 'adsManagement',
  BookingManagement = 'bookingManagement',
  GiftcardManagement = 'giftcardManagement',
  MenuManagement = 'menuManagement',
  MerchantDashboard = 'merchantDashboard',
  MerchantManagement = 'merchantManagement',
  OrderManagement = 'orderManagement',
  PromotionManagement = 'promotionManagement',
  UserManagement = 'userManagement'
}

export enum UserRole {
  Admin = 'admin',
  BookingAdmin = 'bookingAdmin',
  BookingManager = 'bookingManager',
  BookingMerchantAdmin = 'bookingMerchantAdmin',
  GiftCardAdmin = 'giftCardAdmin',
  MarketingAdmin = 'marketingAdmin',
  MenuAdmin = 'menuAdmin',
  MerchantAdmin = 'merchantAdmin',
  MerchantGroupAdmin = 'merchantGroupAdmin',
  MerchantManager = 'merchantManager'
}

export type Voucher = {
  code: VoucherRedeemCode;
  createdAt: Scalars['Int']['output'];
  displaySettings?: Maybe<ItemDisplaySettings>;
  effectiveAt?: Maybe<Scalars['Int']['output']>;
  expiredAt?: Maybe<Scalars['Int']['output']>;
  merchantAltName?: Maybe<Scalars['String']['output']>;
  merchantId: Scalars['String']['output'];
  merchantName?: Maybe<Scalars['String']['output']>;
  promotionId: Scalars['String']['output'];
  promotionType: PromotionType;
  promotionVersion: Scalars['String']['output'];
  redeemedAt?: Maybe<Scalars['Int']['output']>;
  releasedAt?: Maybe<Scalars['Int']['output']>;
  status: VoucherStatus;
  terms?: Maybe<Scalars['String']['output']>;
  transactionId?: Maybe<Scalars['String']['output']>;
  type: VoucherType;
  updatedAt: Scalars['Int']['output'];
  userId: Scalars['String']['output'];
  voucherDescription?: Maybe<Scalars['String']['output']>;
  voucherId: Scalars['ID']['output'];
  voucherName: Scalars['String']['output'];
  voucherSettings?: Maybe<VoucherSetting>;
};

export type VoucherRedeemCode = {
  code: Scalars['String']['output'];
  createdAt: Scalars['Int']['output'];
  expiredAt: Scalars['Int']['output'];
};

export type VoucherSetting = {
  applyOptionDiscount?: Maybe<Scalars['Boolean']['output']>;
  availableOrderTypes?: Maybe<Array<Maybe<OrderType>>>;
  discountAmount?: Maybe<Scalars['Float']['output']>;
  discountedItemQty?: Maybe<Scalars['Int']['output']>;
  discountedItemTags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  effectiveDateTime: Array<Maybe<EffectiveDateTime>>;
  excludedItemTags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  isPercentage: Scalars['Boolean']['output'];
  minimumAmount?: Maybe<Scalars['Float']['output']>;
  percentage?: Maybe<Scalars['Float']['output']>;
  upToAmount?: Maybe<Scalars['Float']['output']>;
  voucherTerms: Scalars['String']['output'];
};

export enum VoucherStatus {
  Active = 'active',
  Expired = 'expired',
  Pending = 'pending',
  Redeemed = 'redeemed',
  Void = 'void'
}

export enum VoucherType {
  Employee = 'employee',
  Giftcard = 'giftcard',
  Loyalty = 'loyalty',
  LuckyDraw = 'luckyDraw',
  Offer = 'offer',
  Promotion = 'promotion',
  Refund = 'refund',
  Reward = 'reward'
}

export enum Weekday {
  Friday = 'Friday',
  Monday = 'Monday',
  Saturday = 'Saturday',
  Sunday = 'Sunday',
  Thursday = 'Thursday',
  Tuesday = 'Tuesday',
  Wednesday = 'Wednesday'
}

export type AppSectionsQueryVariables = Exact<{ [key: string]: never; }>;


export type AppSectionsQuery = { appSections?: Array<{ id: string, contentType: AppContentType, location: AppContentLocation, viewType: AppViewType, sort: number, title: string, description?: string | null, image?: string | null, status?: ContentStatus | null, radiumInKm?: number | null, merchants?: Array<{ merchantId: string, name: string, altName?: string | null, address: string, suburb: string, city: string, phoneNumber: string, abn: string, latitude?: number | null, longitude?: number | null, logo?: string | null, logoImages?: Array<string | null> | null, merchantAdminEmail?: string | null, createdAt: string, restaurantType?: RestaurantType | null, restaurantCategory?: RestaurantCategory | null, type: MerchantType, tags?: Array<string | null> | null, onlineStatus?: boolean | null, onlineOrderCount?: number | null, orderbuddyMerchantId?: string | null, bookingMerchantId?: string | null, openTime?: { closeDates?: Array<string | null> | null, openHours: Array<{ openStart: number, openEnd: number, weekDays: Array<Weekday | null> } | null> } | null } | null> | null, items?: Array<{ id: string, title: string, description?: string | null, image?: string | null } | null> | null, coordinate?: { latitude: number, longitude: number } | null } | null> | null };

export type CreateAppSectionMutationVariables = Exact<{
  section: AppSectionInput;
}>;


export type CreateAppSectionMutation = { createAppSection: boolean };

export type UpdateAppSectionMutationVariables = Exact<{
  section: AppSectionInput;
  sectionId: Scalars['ID']['input'];
}>;


export type UpdateAppSectionMutation = { updateAppSection: boolean };

export type PublishAppSectionMutationVariables = Exact<{
  sectionId: Scalars['ID']['input'];
}>;


export type PublishAppSectionMutation = { publishAppSection: boolean };

export type DeleteAppSectionMutationVariables = Exact<{
  sectionId: Scalars['ID']['input'];
}>;


export type DeleteAppSectionMutation = { deleteAppSection: boolean };

export type LoginMutationVariables = Exact<{
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
}>;


export type LoginMutation = { login: { id: string, name: string, role: UserRole, email: string, merchantId?: string | null, phoneNumber?: string | null, permissions?: Array<UserPermission | null> | null, createdAt: string, loginToken?: string | null } };

export type LogoutMutationVariables = Exact<{ [key: string]: never; }>;


export type LogoutMutation = { logout: boolean };

export type ResetPasswordMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type ResetPasswordMutation = { resetPassword: boolean };

export type BookingsQueryVariables = Exact<{
  dateString: Scalars['String']['input'];
}>;


export type BookingsQuery = { bookings?: Array<{ id: string, merchantId: string, createdAt: number, customer?: { name: string, email?: string | null, phoneNumber?: string | null, guestNum?: string | null, address?: string | null, postcode?: string | null, foodAllergies?: string | null, geolocation?: { longitude: number, latitude: number } | null } | null, bookingDetails?: { bookingTime: number, numberOfGuests: number, specialInstructions?: string | null, promotionId?: string | null } | null } | null> | null };

export type BookingQueryVariables = Exact<{
  dateString: Scalars['String']['input'];
  bookingId: Scalars['String']['input'];
}>;


export type BookingQuery = { booking?: { id: string, merchantId: string, createdAt: number, customer?: { name: string, email?: string | null, phoneNumber?: string | null, guestNum?: string | null, address?: string | null, postcode?: string | null, foodAllergies?: string | null, geolocation?: { longitude: number, latitude: number } | null } | null, bookingDetails?: { bookingTime: number, numberOfGuests: number, specialInstructions?: string | null, promotionId?: string | null } | null } | null };

export type BookingSessionsQueryVariables = Exact<{ [key: string]: never; }>;


export type BookingSessionsQuery = { bookingSessions?: Array<{ id: string, name: string, description?: string | null, guestCountLimit?: number | null, hideEndTime: boolean, hideTableNumber: boolean, needDeposite: boolean, isEnabled: boolean, OpenTime: { closeDates?: Array<string | null> | null, openHours: Array<{ openStart: number, openEnd: number, weekDays: Array<Weekday | null> } | null> }, bookingTables?: Array<{ minimumNumberOfGuests: number, maximumNumberOfGuests: number, tableNumber: string } | null> | null } | null> | null };

export type CreateBookingSessionMutationVariables = Exact<{
  bookingSession: BookingSessionInput;
}>;


export type CreateBookingSessionMutation = { createBookingSession: boolean };

export type BookingSessionQueryVariables = Exact<{
  bookingSessionId: Scalars['String']['input'];
}>;


export type BookingSessionQuery = { bookingSession?: { name: string, description?: string | null, guestCountLimit?: number | null, hideEndTime: boolean, hideTableNumber: boolean, needDeposite: boolean, isEnabled: boolean, OpenTime: { closeDates?: Array<string | null> | null, openHours: Array<{ openStart: number, openEnd: number, weekDays: Array<Weekday | null> } | null> }, bookingTables?: Array<{ minimumNumberOfGuests: number, maximumNumberOfGuests: number, tableNumber: string } | null> | null } | null };

export type UpdateBookingSessionMutationVariables = Exact<{
  bookingSession: BookingSessionInput;
  bookingSessionId: Scalars['String']['input'];
}>;


export type UpdateBookingSessionMutation = { updateBookingSession: boolean };

export type FaqQueryVariables = Exact<{
  app: ObApp;
}>;


export type FaqQuery = { faq?: { app: ObApp, sections?: Array<{ id: string, title: string, description: string, sort: number, questions?: Array<{ id: string, question: string, answer: string, sort: number, tags?: Array<string | null> | null, videoUrl?: string | null } | null> | null } | null> | null } | null };

export type CreateFaqSectionMutationVariables = Exact<{
  app: ObApp;
  section: ObfaqSectionInput;
}>;


export type CreateFaqSectionMutation = { createFAQSection: boolean };

export type UpdateFaqSectionMutationVariables = Exact<{
  app: ObApp;
  section: ObfaqSectionInput;
  sectionId: Scalars['ID']['input'];
}>;


export type UpdateFaqSectionMutation = { updateFAQSection: boolean };

export type DeleteFaqSectionMutationVariables = Exact<{
  app: ObApp;
  sectionId: Scalars['ID']['input'];
}>;


export type DeleteFaqSectionMutation = { deleteFAQSection: boolean };

export type CreateFaqQuestionMutationVariables = Exact<{
  app: ObApp;
  sectionId: Scalars['ID']['input'];
  question: ObfaqQuestionInput;
}>;


export type CreateFaqQuestionMutation = { createFAQQuestion: boolean };

export type UpdateFaqQuestionMutationVariables = Exact<{
  app: ObApp;
  sectionId: Scalars['ID']['input'];
  question: ObfaqQuestionInput;
  questionId: Scalars['ID']['input'];
}>;


export type UpdateFaqQuestionMutation = { updateFAQQuestion: boolean };

export type DeleteFaqQuestionMutationVariables = Exact<{
  app: ObApp;
  sectionId: Scalars['ID']['input'];
  questionId: Scalars['ID']['input'];
}>;


export type DeleteFaqQuestionMutation = { deleteFAQQuestion: boolean };

export type CreateGiftCardAccountMutationVariables = Exact<{
  input: GiftCardAccountInput;
}>;


export type CreateGiftCardAccountMutation = { createGiftCardAccount?: string | null };

export type DeleteGiftCardAccountMutationVariables = Exact<{
  giftCardAccountId: Scalars['ID']['input'];
}>;


export type DeleteGiftCardAccountMutation = { deleteGiftCardAccount?: boolean | null };

export type UpdateGiftCardAdminUsersMutationVariables = Exact<{
  giftCardAccountId: Scalars['ID']['input'];
  userIds: Array<Scalars['ID']['input']>;
}>;


export type UpdateGiftCardAdminUsersMutation = { updateGiftCardAdminUsers?: { id: string } | null };

export type AdjustGiftCardAccountMutationVariables = Exact<{
  input: AdjustGiftCardInput;
}>;


export type AdjustGiftCardAccountMutation = { adjustGiftCardAccount?: { id: string } | null };

export type CreateGiftCardMutationVariables = Exact<{
  input: GiftCardInput;
}>;


export type CreateGiftCardMutation = { createGiftCard?: { id: string } | null };

export type CreateGiftCardsMutationVariables = Exact<{
  input: Array<GiftCardInput>;
}>;


export type CreateGiftCardsMutation = { createGiftCards?: boolean | null };

export type VoidGiftCardMutationVariables = Exact<{
  giftCardId: Scalars['ID']['input'];
}>;


export type VoidGiftCardMutation = { voidGiftCard?: boolean | null };

export type ResentGiftCardMutationVariables = Exact<{
  giftCardId: Scalars['ID']['input'];
}>;


export type ResentGiftCardMutation = { resentGiftCard?: boolean | null };

export type SwitchGiftCardAccountMutationVariables = Exact<{
  giftCardAccountId: Scalars['ID']['input'];
}>;


export type SwitchGiftCardAccountMutation = { switchGiftCardAccount?: boolean | null };

export type GiftCardAccountsQueryVariables = Exact<{ [key: string]: never; }>;


export type GiftCardAccountsQuery = { giftCardAccounts?: Array<{ id: string, name: string, description?: string | null, adminUserIds: Array<string>, balance: number, createdAt: number, updatedAt: number, updatedUserId: string, activeGiftCards?: Array<{ id: string, message?: string | null, description?: string | null, giftCardAccountId: string, serialNumber: string, recipientName: string, recipientPhone?: string | null, recipientEmail: string, amount: number, createdAt: number, updatedAt: number, redeemCode: string, status: GiftCardStatus, merchantId?: string | null, expiredAt?: number | null, createdBy?: string | null, createdUserId?: string | null, sender?: string | null }> | null, redeemedGiftCards?: Array<{ id: string, message?: string | null, description?: string | null, giftCardAccountId: string, serialNumber: string, recipientName: string, recipientPhone?: string | null, recipientEmail: string, amount: number, createdAt: number, updatedAt: number, redeemCode: string, status: GiftCardStatus, merchantId?: string | null, expiredAt?: number | null, createdBy?: string | null, createdUserId?: string | null, sender?: string | null }> | null, voidedGiftCards?: Array<{ id: string, message?: string | null, description?: string | null, giftCardAccountId: string, serialNumber: string, recipientName: string, recipientPhone?: string | null, recipientEmail: string, amount: number, createdAt: number, updatedAt: number, redeemCode: string, status: GiftCardStatus, merchantId?: string | null, expiredAt?: number | null, createdBy?: string | null, createdUserId?: string | null, sender?: string | null }> | null, adjustmentRecords?: Array<{ id: string, giftCardAccountId: string, updatedUserId: string, amount: number, updatedAt: number, type: GiftCardAdjustmentType, adjustmentType?: GiftCardAccountAdjustmentType | null, description?: string | null }> | null }> | null };

export type GiftCardAccountsBaseInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type GiftCardAccountsBaseInfoQuery = { giftCardAccounts?: Array<{ id: string, name: string, description?: string | null, adminUserIds: Array<string>, balance: number, createdAt: number, updatedAt: number, updatedUserId: string }> | null };

export type GiftCardAccountQueryVariables = Exact<{ [key: string]: never; }>;


export type GiftCardAccountQuery = { giftCardAccount?: { id: string, name: string, description?: string | null, adminUserIds: Array<string>, balance: number, createdAt: number, updatedAt: number, updatedUserId: string } | null };

export type MyGiftCardsQueryVariables = Exact<{ [key: string]: never; }>;


export type MyGiftCardsQuery = { giftCardAccount?: { activeGiftCards?: Array<{ id: string, message?: string | null, description?: string | null, giftCardAccountId: string, serialNumber: string, recipientName: string, recipientPhone?: string | null, recipientEmail: string, amount: number, createdAt: number, updatedAt: number, redeemCode: string, status: GiftCardStatus, merchantId?: string | null, expiredAt?: number | null, createdBy?: string | null, createdUserId?: string | null, sender?: string | null }> | null, redeemedGiftCards?: Array<{ id: string, message?: string | null, description?: string | null, giftCardAccountId: string, serialNumber: string, recipientName: string, recipientPhone?: string | null, recipientEmail: string, amount: number, createdAt: number, updatedAt: number, redeemCode: string, status: GiftCardStatus, merchantId?: string | null, expiredAt?: number | null, createdBy?: string | null, createdUserId?: string | null, sender?: string | null }> | null, voidedGiftCards?: Array<{ id: string, message?: string | null, description?: string | null, giftCardAccountId: string, serialNumber: string, recipientName: string, recipientPhone?: string | null, recipientEmail: string, amount: number, createdAt: number, updatedAt: number, redeemCode: string, status: GiftCardStatus, merchantId?: string | null, expiredAt?: number | null, createdBy?: string | null, createdUserId?: string | null, sender?: string | null }> | null } | null };

export type MyAdjustmentRecordsQueryVariables = Exact<{ [key: string]: never; }>;


export type MyAdjustmentRecordsQuery = { giftCardAccount?: { adjustmentRecords?: Array<{ id: string, giftCardAccountId: string, updatedUserId: string, amount: number, updatedAt: number, type: GiftCardAdjustmentType, adjustmentType?: GiftCardAccountAdjustmentType | null, description?: string | null, updatedEmail?: string | null }> | null } | null };

export type LoyaltyMembersQueryVariables = Exact<{ [key: string]: never; }>;


export type LoyaltyMembersQuery = { loyaltyMembers?: Array<{ loyaltyId: string, userId: string, userName?: string | null, userPhone?: string | null, userEmail?: string | null, merchantId: string, loyaltyPoints: number, spendProgress?: { currentSpend: number, targetSpend: number, promotionId: string } | null, stampProgress?: { currentStamps: number, targetStamps: number, promotionId: string } | null, redeemHistory?: Array<{ promotionId: string, usedStamps?: number | null, usedPoints?: number | null, usedAmount?: number | null, createdAt?: number | null, voucherId: string, description?: string | null } | null> | null, earnHistory?: Array<{ promotionId: string, earnedStamps?: number | null, earnedPoints?: number | null, earnedAmount?: number | null, createdAt: number, orderNumber?: string | null, orderTotal?: number | null, merchantId: string, description?: string | null, orderItems?: Array<{ loyaltyPromotionId: string, itemId: string, name: string, tags?: Array<string | null> | null, quantity: number, price: number, orderTime: number } | null> | null } | null> | null } | null> | null };

export type GetPromotionsOnLoyaltyMembersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPromotionsOnLoyaltyMembersQuery = { getPromotions?: Array<{ id: string, name: string, status: PromotionStatus } | null> | null };

export type GetMenusQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMenusQuery = { getMenus?: Array<{ id: string, name: string, description?: string | null, isEnabled?: boolean | null, status: MenuStatus, type?: OrderType | null, createdAt: string, promotionTags?: Array<string | null> | null } | null> | null };

export type CreateMenuMutationVariables = Exact<{
  menu: MenuInput;
}>;


export type CreateMenuMutation = { createMenu: boolean };

export type UpdateMenuMutationVariables = Exact<{
  menu: MenuInput;
  menuId: Scalars['String']['input'];
}>;


export type UpdateMenuMutation = { updateMenu: boolean };

export type DeleteMenuMutationVariables = Exact<{
  menuId: Scalars['String']['input'];
}>;


export type DeleteMenuMutation = { deleteMenu: boolean };

export type MenuGroupQueryVariables = Exact<{
  menuId: Scalars['String']['input'];
}>;


export type MenuGroupQuery = { getMenuGroups?: Array<{ id: string, name: string, allow_quantity: boolean, force_max: number, force_min: number, sort?: number | null, options?: Array<{ id: string, name: string, shortName?: string | null, groupId: string, default: boolean, price: number, sort: number } | null> | null } | null> | null };

export type CreateMenuGroupMutationVariables = Exact<{
  group: MenuGroupInput;
}>;


export type CreateMenuGroupMutation = { createMenuGroup: boolean };

export type DeleteMenuGroupMutationVariables = Exact<{
  menuId: Scalars['String']['input'];
  groupId: Scalars['String']['input'];
}>;


export type DeleteMenuGroupMutation = { deleteMenuGroup: boolean };

export type GetMenuQueryVariables = Exact<{
  menuId: Scalars['String']['input'];
}>;


export type GetMenuQuery = { getMenu?: { name: string, description?: string | null, isEnabled?: boolean | null, status: MenuStatus, createdAt: string, type?: OrderType | null, promotionTags?: Array<string | null> | null } | null };

export type GetMenuCategoriesQueryVariables = Exact<{
  menuId: Scalars['String']['input'];
}>;


export type GetMenuCategoriesQuery = { getMenuCategories?: Array<{ name: string, id: string, altName?: string | null, active_begin?: number | null, description?: string | null, active_end?: number | null, hidden_until?: string | null, active: boolean, menuId: string, cookingPriority?: number | null, sort: number, promotionTags?: Array<string | null> | null, items?: Array<{ id: string, tags?: Array<string | null> | null, price: number, active: boolean, description: string, menuId: string, image?: string | null, hidden_until?: string | null, sort: number, name: string, active_end?: number | null, displayNumber?: string | null, altName?: string | null, ingredients?: string | null, active_begin?: number | null, cookingCategory?: string | null, categoryId: string, promotionTags?: Array<string | null> | null, sizes?: Array<{ name: string, price: string, id: string, default: boolean, groups?: Array<{ id: string, name: string, allow_quantity: boolean, force_max: number, force_min: number, menuId: string, options?: Array<{ id: string, name: string, shortName?: string | null, default: boolean, groupId: string, price: number, sort: number } | null> | null } | null> | null } | null> | null, groups?: Array<{ id: string, sort?: number | null } | null> | null } | null> | null } | null> | null };

export type CreateMenuCategoryMutationVariables = Exact<{
  category?: InputMaybe<MenuCategoryInput>;
}>;


export type CreateMenuCategoryMutation = { createMenuCategory: boolean };

export type UpdateMenuCategoryMutationVariables = Exact<{
  menuId: Scalars['String']['input'];
  categroyId: Scalars['String']['input'];
  category: MenuCategoryInput;
}>;


export type UpdateMenuCategoryMutation = { updateMenuCategory: boolean };

export type DeleteMenuCategoryMutationVariables = Exact<{
  menuId: Scalars['String']['input'];
  categroyId: Scalars['String']['input'];
}>;


export type DeleteMenuCategoryMutation = { deleteMenuCategory: boolean };

export type CreateMenuItemMutationVariables = Exact<{
  item?: InputMaybe<MenuItemInput>;
}>;


export type CreateMenuItemMutation = { createMenuItem: boolean };

export type CreateMenuGroupOptionMutationVariables = Exact<{
  option: MenuOptionInput;
}>;


export type CreateMenuGroupOptionMutation = { createMenuGroupOption: boolean };

export type UpdateMenuGroupOptionsMutationVariables = Exact<{
  menuId: Scalars['String']['input'];
  groupId: Scalars['String']['input'];
  options: Array<InputMaybe<MenuOptionInput>>;
}>;


export type UpdateMenuGroupOptionsMutation = { updateMenuGroupOptions: boolean };

export type UpdateMenuGroupMutationVariables = Exact<{
  menuId: Scalars['String']['input'];
  groupId: Scalars['String']['input'];
  group: MenuGroupInput;
}>;


export type UpdateMenuGroupMutation = { updateMenuGroup: boolean };

export type UpdateMenuItemGroupsMutationVariables = Exact<{
  menuId: Scalars['String']['input'];
  categroyId: Scalars['String']['input'];
  menuItemId: Scalars['String']['input'];
  groups?: InputMaybe<Array<InputMaybe<MenuItemGroupsInput>>>;
}>;


export type UpdateMenuItemGroupsMutation = { updateMenuItemGroups: boolean };

export type UpdateMenuItemMutationVariables = Exact<{
  menuId: Scalars['String']['input'];
  categroyId: Scalars['String']['input'];
  menuItem: MenuItemInput;
}>;


export type UpdateMenuItemMutation = { updateMenuItem: boolean };

export type UpdateMenuItemsMutationVariables = Exact<{
  menuId: Scalars['String']['input'];
  categroyId: Scalars['String']['input'];
  items: Array<InputMaybe<MenuItemInput>>;
}>;


export type UpdateMenuItemsMutation = { updateMenuItems: boolean };

export type PublishMenuMutationVariables = Exact<{
  menuId: Scalars['String']['input'];
}>;


export type PublishMenuMutation = { publishMenu: boolean };

export type DeleteMenuItemImageMutationVariables = Exact<{
  menuId: Scalars['String']['input'];
  categroyId: Scalars['String']['input'];
  menuItemId: Scalars['String']['input'];
}>;


export type DeleteMenuItemImageMutation = { deleteMenuItemImage: boolean };

export type MoveMenuItemImageMutationVariables = Exact<{
  menuItemId: Scalars['ID']['input'];
  fromCategoryId: Scalars['ID']['input'];
  toCategoryId: Scalars['ID']['input'];
  menuId: Scalars['ID']['input'];
}>;


export type MoveMenuItemImageMutation = { moveMenuItemImage: boolean };

export type GetAllMerchantsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllMerchantsQuery = { getAllMerchants?: Array<{ merchantId: string, name: string, altName?: string | null, address: string, phoneNumber: string, abn: string, suburb: string, city: string, latitude?: number | null, longitude?: number | null, logo?: string | null, logoImages?: Array<string | null> | null, createdAt: string, merchantAdminEmail?: string | null, tags?: Array<string | null> | null, type: MerchantType, restaurantType?: RestaurantType | null, restaurantCategory?: RestaurantCategory | null, timezone?: string | null, serviceMonthlyPrice?: number | null, orderbuddyMerchantId?: string | null, bookingMerchantId?: string | null, merchantStatus?: MerchantStatus | null, openTime?: { closeDates?: Array<string | null> | null, openHours: Array<{ openStart: number, openEnd: number, weekDays: Array<Weekday | null> } | null> } | null, settings?: { isStripePaymentEnabled?: boolean | null, areSoldOutItemsDisplayedInApp?: boolean | null, stripeAccountId?: string | null, maxPromotions?: number | null, appServices?: Array<AppService | null> | null } | null, surchargeSettings?: Array<{ id: string, name: string, surchargeDescription?: string | null, weekdays?: Array<Weekday | null> | null, isEnabled: boolean, isPercentage: boolean, amount: number, publicHolidayDays?: Array<string | null> | null } | null> | null, addressObject?: { city: string, country: string, countryCode: string, line1: string, line2?: string | null, line3?: string | null, postalCode: string, stateOrProvince?: string | null, stateOrProvinceCode?: string | null, location?: { longitude: number, latitude: number } | null } | null } | null> | null };

export type MerchantQueryVariables = Exact<{
  merchantId: Scalars['String']['input'];
}>;


export type MerchantQuery = { getMerchant: { merchantId: string, name: string, altName?: string | null, address: string, phoneNumber: string, abn: string, suburb: string, city: string, latitude?: number | null, longitude?: number | null, logo?: string | null, logoImages?: Array<string | null> | null, createdAt: string, merchantAdminEmail?: string | null, contactEmail?: string | null, tags?: Array<string | null> | null, type: MerchantType, restaurantType?: RestaurantType | null, restaurantCategory?: RestaurantCategory | null, timezone?: string | null, serviceMonthlyPrice?: number | null, orderbuddyMerchantId?: string | null, bookingMerchantId?: string | null, merchantStatus?: MerchantStatus | null, openTime?: { closeDates?: Array<string | null> | null, openHours: Array<{ openStart: number, openEnd: number, weekDays: Array<Weekday | null> } | null> } | null, settings?: { isStripePaymentEnabled?: boolean | null, areSoldOutItemsDisplayedInApp?: boolean | null, stripeAccountId?: string | null, maxPromotions?: number | null, appServices?: Array<AppService | null> | null } | null, surchargeSettings?: Array<{ id: string, name: string, surchargeDescription?: string | null, weekdays?: Array<Weekday | null> | null, isEnabled: boolean, isPercentage: boolean, amount: number, publicHolidayDays?: Array<string | null> | null } | null> | null, addressObject?: { city: string, country: string, countryCode: string, line1: string, line2?: string | null, line3?: string | null, postalCode: string, stateOrProvince?: string | null, stateOrProvinceCode?: string | null, location?: { longitude: number, latitude: number } | null } | null } };

export type PosMerchantQueryVariables = Exact<{
  posRestaurantId: Scalars['String']['input'];
}>;


export type PosMerchantQuery = { posMerchant?: { merchantId: string, name: string, altName?: string | null, address: string, abn: string, latitude?: number | null, longitude?: number | null, logo?: string | null, logoImages?: Array<string | null> | null, suburb: string, city: string, phoneNumber: string, merchantAdminEmail?: string | null, createdAt: string, restaurantType?: RestaurantType | null, restaurantCategory?: RestaurantCategory | null, tags?: Array<string | null> | null, timezone?: string | null, onlineStatus?: boolean | null, onlineOrderCount?: number | null, serviceMonthlyPrice?: number | null, orderbuddyMerchantId?: string | null, bookingMerchantId?: string | null, settings?: { isStripePaymentEnabled?: boolean | null, stripeAccountId?: string | null, maxPromotions?: number | null } | null, surchargeSettings?: Array<{ id: string, name: string, amount: number, isEnabled: boolean, isPercentage: boolean, publicHolidayDays?: Array<string | null> | null, weekdays?: Array<Weekday | null> | null, surchargeDescription?: string | null } | null> | null, addressObject?: { city: string, country: string, countryCode: string, line1: string, line2?: string | null, line3?: string | null, postalCode: string, stateOrProvince?: string | null, stateOrProvinceCode?: string | null, location?: { longitude: number, latitude: number } | null } | null } | null };

export type CreateMerchantMutationVariables = Exact<{
  merchant: MerchantInput;
}>;


export type CreateMerchantMutation = { createMerchant: boolean };

export type AddUserToMerchantMutationVariables = Exact<{
  role: UserRole;
  email: Scalars['String']['input'];
  merchantId: Scalars['String']['input'];
}>;


export type AddUserToMerchantMutation = { addUserToMerchant: boolean };

export type UpdateMerchantMutationVariables = Exact<{
  merchant: MerchantInput;
}>;


export type UpdateMerchantMutation = { updateMerchant: boolean };

export type UpdateMerchantOpenTimeMutationVariables = Exact<{
  openTime: OpenTimeInput;
  merchantId: Scalars['String']['input'];
}>;


export type UpdateMerchantOpenTimeMutation = { updateMerchantOpenTime: boolean };

export type SwitchMerchantMutationVariables = Exact<{
  merchantId: Scalars['String']['input'];
}>;


export type SwitchMerchantMutation = { switchMerchant: boolean };

export type UpdateMerchantSettingsMutationVariables = Exact<{
  merchantSettings: MerchantSetingsInput;
  merchantId: Scalars['ID']['input'];
}>;


export type UpdateMerchantSettingsMutation = { updateMerchantSettings: boolean };

export type UpdateMerchantSurchargesMutationVariables = Exact<{
  surcharges: Array<InputMaybe<SurchargeInput>>;
  merchantId: Scalars['ID']['input'];
}>;


export type UpdateMerchantSurchargesMutation = { updateMerchantSurcharges: boolean };

export type GetProductsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProductsQuery = { getProducts?: Array<{ unit_amount: number, id: string, product: { name: string, description: string } } | null> | null };

export type DeleteMerchantLogoMutationVariables = Exact<{
  imageName: Scalars['String']['input'];
}>;


export type DeleteMerchantLogoMutation = { deleteMerchantLogo: boolean };

export type UpdateMerchantLogosMutationVariables = Exact<{
  urlStringArray: Array<InputMaybe<Scalars['String']['input']>>;
}>;


export type UpdateMerchantLogosMutation = { updateMerchantLogos: boolean };

export type PosMenusQueryVariables = Exact<{ [key: string]: never; }>;


export type PosMenusQuery = { posMenus?: Array<{ id: string, name: string, description?: string | null, isEnabled?: boolean | null, type?: OrderType | null, status: MenuStatus, createdAt: string, promotionTags?: Array<string | null> | null } | null> | null };

export type PosMenuQueryVariables = Exact<{
  menuId: Scalars['String']['input'];
}>;


export type PosMenuQuery = { posMenu?: { id: string, name: string, description?: string | null, isEnabled?: boolean | null, type?: OrderType | null, status: MenuStatus, createdAt: string, promotionTags?: Array<string | null> | null } | null };

export type MerchantAreasQueryVariables = Exact<{ [key: string]: never; }>;


export type MerchantAreasQuery = { merchantAreas?: Array<{ name: string, description?: string | null, sort: number, tables?: Array<{ minimumNumberOfGuests: number, maximumNumberOfGuests: number, tableNumber: string } | null> | null } | null> | null };

export type SyncPosMerchantDataMutationVariables = Exact<{ [key: string]: never; }>;


export type SyncPosMerchantDataMutation = { syncPOSMerchantData: boolean };

export type SyncPosMerchantOpenHoursMutationVariables = Exact<{ [key: string]: never; }>;


export type SyncPosMerchantOpenHoursMutation = { syncPOSMerchantOpenHours: boolean };

export type SyncPosMerchantTablesMutationVariables = Exact<{ [key: string]: never; }>;


export type SyncPosMerchantTablesMutation = { syncPOSMerchantTables: boolean };

export type SyncPosMerchantBasicInfoMutationVariables = Exact<{ [key: string]: never; }>;


export type SyncPosMerchantBasicInfoMutation = { syncPOSMerchantBasicInfo: boolean };

export type OrdersQueryVariables = Exact<{
  dateString: Scalars['String']['input'];
}>;


export type OrdersQuery = { orders?: Array<{ orderNumber: string, createdAt: number, orderFrom: OrderFrom, merchant: { merchantId: string, tableId?: string | null }, order: { pickupTime?: string | null, total: number, paymentType: PaymentType, type: OrderType, selectedDate?: string | null, notes?: string | null, orderTime?: number | null, adjustments?: Array<{ adjustmentType?: OrderAdjustmentType | null, amount?: number | null, voucherNo?: string | null, description?: string | null } | null> | null, items?: Array<{ subTotal?: number | null, quantity?: number | null, specialInstructions?: string | null, isTakeaway?: boolean | null, id: string, size?: { name: string, price: string, groups?: Array<{ id: string, name: string, menuId: string, options?: Array<{ id: string, name: string, shortName?: string | null, price: number } | null> | null } | null> | null } | null, options?: Array<{ id: string, quantity: number, price: number, name: string, shortName?: string | null } | null> | null, dish?: { id: string, price: number, description: string, name: string } | null } | null> | null }, user: { name: string, email?: string | null, phoneNumber?: string | null, guestNum?: string | null, address?: string | null, postcode?: string | null, foodAllergies?: string | null, geolocation?: { longitude: number, latitude: number } | null } } | null> | null };

export type OrderQueryVariables = Exact<{
  dateString: Scalars['String']['input'];
  orderNumber: Scalars['String']['input'];
}>;


export type OrderQuery = { order?: { orderNumber: string, createdAt: number, orderFrom: OrderFrom, merchant: { merchantId: string, tableId?: string | null }, order: { pickupTime?: string | null, total: number, paymentType: PaymentType, type: OrderType, selectedDate?: string | null, notes?: string | null, orderTime?: number | null, adjustments?: Array<{ adjustmentType?: OrderAdjustmentType | null, priceDecimal: number, name: string } | null> | null, items?: Array<{ subTotal?: number | null, quantity?: number | null, specialInstructions?: string | null, isTakeaway?: boolean | null, id: string, size?: { name: string, price: string, groups?: Array<{ id: string, name: string, menuId: string, options?: Array<{ id: string, name: string, shortName?: string | null, price: number } | null> | null } | null> | null } | null, options?: Array<{ id: string, quantity: number, price: number, name: string, shortName?: string | null } | null> | null, dish?: { id: string, price: number, description: string, name: string } | null } | null> | null }, user: { name: string, email?: string | null, phoneNumber?: string | null, guestNum?: string | null, address?: string | null, postcode?: string | null, foodAllergies?: string | null, geolocation?: { longitude: number, latitude: number } | null } } | null };

export type GetPromotionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPromotionsQuery = { getPromotions?: Array<{ id: string, name: string, description?: string | null, status: PromotionStatus, type: PromotionType, numberOfDeals: number, usedQuantity?: number | null, createdAt?: number | null, minimumAmount?: number | null, merchantId: string, canBeUsedWithOtherPromotions?: boolean | null, applyOptionDiscount?: boolean | null, excludedPromotionTags?: Array<string | null> | null, includedPromotionTags?: Array<string | null> | null, includedGetItemsPromoTags?: Array<string | null> | null, discountedItemQty?: number | null, availableType?: Array<OrderType | null> | null, buyN?: number | null, freeN?: number | null, percentage?: number | null, discountAmount?: number | null, isPercentage?: boolean | null, upToAmount?: number | null, isOffer?: boolean | null, isSignUpPromotion?: boolean | null, isHiddenInApp?: boolean | null, useType: PromotionUseType, isLoyalty?: boolean | null, entrySpendAmountCents?: number | null, prizeDescription?: string | null, winPercentage?: number | null, winnerCount?: number | null, entryLimitPerUser?: number | null, winCountLimitPerPerson?: number | null, isEntryAutomatic?: boolean | null, isPaymentRequired?: boolean | null, orders?: Array<{ orderNumber: string, sourceType?: OrderSourceType | null, createdAt: number } | null> | null, bookings?: Array<{ id: string, createdAt: number, merchantId: string } | null> | null, effectiveDateTime: Array<{ startDate: string, endDate: string, recurringWeekDays?: Array<Weekday | null> | null, hours?: Array<{ openStart: number, openEnd: number } | null> | null } | null>, offerVoucherSettings?: { offerName: string, offerDescription?: string | null, offerExcludedItemTags?: Array<string | null> | null, effectiveHoursAfterOfferActivated: number, minimumAmount?: number | null, upToAmount?: number | null, voucherTerms: string, effectiveDateTime: Array<{ startDate: string, endDate: string, recurringWeekDays?: Array<Weekday | null> | null, hours?: Array<{ openStart: number, openEnd: number } | null> | null } | null>, displaySettings?: { displayTitle?: string | null, displayDescription?: string | null, displayAltDescription?: string | null, displayAltTitle?: string | null, displayImage?: string | null, displayTerms?: string | null } | null } | null, resultingPromotions?: Array<{ promotionId: string, winPercentage: number }> | null, loyaltyDetails?: { expiryDays: number, loyaltyReviewDate: number } | null, loyaltySettings?: { pointsPerDollar: number, maxPointsPerTransaction: number, expiryDays: number, loyaltyReviewDate: number, loyaltyBenefits: Array<{ id: string, name: string, description: string, requiredPoints: number, benefitPromotionIds: Array<string>, displaySettings?: { displayTitle?: string | null, displayDescription?: string | null, displayAltDescription?: string | null, displayAltTitle?: string | null, displayImage?: string | null, displayTerms?: string | null } | null }> } | null, displaySettings?: { displayTitle?: string | null, displayDescription?: string | null, displayAltDescription?: string | null, displayAltTitle?: string | null, displayImage?: string | null, displayTerms?: string | null } | null } | null> | null };

export type GetPromotionsOnLuckyDrawQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPromotionsOnLuckyDrawQuery = { getPromotions?: Array<{ id: string, name: string, status: PromotionStatus, isOffer?: boolean | null, type: PromotionType, effectiveDateTime: Array<{ startDate: string, endDate: string, recurringWeekDays?: Array<Weekday | null> | null, hours?: Array<{ openStart: number, openEnd: number } | null> | null } | null> } | null> | null };

export type GetPublishedMenuCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPublishedMenuCategoriesQuery = { getPublishedMenuCategories?: Array<{ name: string, id: string, altName?: string | null, active_begin?: number | null, description?: string | null, active_end?: number | null, hidden_until?: string | null, active: boolean, menuId: string, cookingPriority?: number | null, groups?: Array<{ id: string, name: string, allow_quantity: boolean, force_max: number, force_min: number, menuId: string, options?: Array<{ id: string, name: string, shortName?: string | null, default: boolean, groupId: string, price: number, sort: number } | null> | null } | null> | null, items?: Array<{ id: string, tags?: Array<string | null> | null, price: number, active: boolean, description: string, menuId: string, image?: string | null, hidden_until?: string | null, sort: number, name: string, active_end?: number | null, displayNumber?: string | null, altName?: string | null, ingredients?: string | null, active_begin?: number | null, cookingCategory?: string | null, categoryId: string, sizes?: Array<{ name: string, price: string, id: string, default: boolean, groups?: Array<{ id: string, name: string, allow_quantity: boolean, force_max: number, force_min: number, menuId: string, options?: Array<{ id: string, name: string, shortName?: string | null, default: boolean, groupId: string, price: number, sort: number } | null> | null } | null> | null } | null> | null } | null> | null } | null> | null };

export type GetPercentagePromotionQueryVariables = Exact<{
  promotionId: Scalars['String']['input'];
}>;


export type GetPercentagePromotionQuery = { getPercentagePromotion?: { id: string, name: string, description?: string | null, percentage: number, discountAmount: number, isPercentage: boolean, excludedPromotionTags?: Array<string | null> | null, includedPromotionTags?: Array<string | null> | null, includedGetItemsPromoTags?: Array<string | null> | null, numberOfDeals: number, availableType?: Array<OrderType | null> | null, minimumAmount?: number | null, isHiddenInApp?: boolean | null, canBeUsedWithOtherPromotions?: boolean | null, isSignUpPromotion?: boolean | null, upToAmount?: number | null, isOffer?: boolean | null, useType: PromotionUseType, applyOptionDiscount?: boolean | null, isLoyalty?: boolean | null, effectiveDateTime: Array<{ startDate: string, endDate: string, recurringWeekDays?: Array<Weekday | null> | null, hours?: Array<{ openStart: number, openEnd: number } | null> | null } | null>, offerVoucherSettings?: { offerName: string, offerDescription?: string | null, offerExcludedItemTags?: Array<string | null> | null, effectiveHoursAfterOfferActivated: number, minimumAmount?: number | null, upToAmount?: number | null, voucherTerms: string, effectiveDateTime: Array<{ startDate: string, endDate: string, recurringWeekDays?: Array<Weekday | null> | null, hours?: Array<{ openStart: number, openEnd: number } | null> | null } | null>, displaySettings?: { displayTitle?: string | null, displayDescription?: string | null, displayAltDescription?: string | null, displayAltTitle?: string | null, displayImage?: string | null, displayTerms?: string | null } | null } | null, loyaltyDetails?: { expiryDays: number, loyaltyReviewDate: number } | null, displaySettings?: { displayTitle?: string | null, displayDescription?: string | null, displayAltDescription?: string | null, displayAltTitle?: string | null, displayImage?: string | null, displayTerms?: string | null } | null } | null };

export type GetLoyaltyPromotionQueryVariables = Exact<{
  promotionId: Scalars['String']['input'];
}>;


export type GetLoyaltyPromotionQuery = { loyaltyPromotion?: { id: string, name: string, description?: string | null, status: PromotionStatus, type: PromotionType, numberOfDeals: number, merchantId: string, useType: PromotionUseType, isHiddenInApp?: boolean | null, isLoyalty?: boolean | null, includedPromotionTags?: Array<string | null> | null, excludedPromotionTags?: Array<string | null> | null, canBeUsedWithOtherPromotions?: boolean | null, effectiveDateTime: Array<{ startDate: string, endDate: string, recurringWeekDays?: Array<Weekday | null> | null, hours?: Array<{ openStart: number, openEnd: number } | null> | null } | null>, loyaltySettings?: { pointsPerDollar: number, maxPointsPerTransaction: number, expiryDays: number, loyaltyReviewDate: number, loyaltyBenefits: Array<{ id: string, name: string, description: string, requiredPoints: number, benefitPromotionIds: Array<string>, displaySettings?: { displayTitle?: string | null, displayDescription?: string | null, displayAltDescription?: string | null, displayAltTitle?: string | null, displayImage?: string | null, displayTerms?: string | null } | null }> } | null, displaySettings?: { displayTitle?: string | null, displayDescription?: string | null, displayAltDescription?: string | null, displayAltTitle?: string | null, displayImage?: string | null, displayTerms?: string | null } | null } | null };

export type GetSpendPromotionQueryVariables = Exact<{
  promotionId: Scalars['String']['input'];
}>;


export type GetSpendPromotionQuery = { getSpendPromotion?: { name: string, description?: string | null, percentage: number, discountAmount: number, isPercentage: boolean, numberOfDeals: number, availableType?: Array<OrderType | null> | null, excludedPromotionTags?: Array<string | null> | null, includedPromotionTags?: Array<string | null> | null, isHiddenInApp?: boolean | null, canBeUsedWithOtherPromotions?: boolean | null, includedGetItemsPromoTags?: Array<string | null> | null, discountedItemQty: number, minimumAmount: number, isSignUpPromotion?: boolean | null, upToAmount?: number | null, isOffer?: boolean | null, useType: PromotionUseType, applyOptionDiscount: boolean, isLoyalty?: boolean | null, effectiveDateTime: Array<{ startDate: string, endDate: string, recurringWeekDays?: Array<Weekday | null> | null, hours?: Array<{ openStart: number, openEnd: number } | null> | null } | null>, offerVoucherSettings?: { offerName: string, offerDescription?: string | null, offerExcludedItemTags?: Array<string | null> | null, effectiveHoursAfterOfferActivated: number, minimumAmount?: number | null, upToAmount?: number | null, voucherTerms: string, effectiveDateTime: Array<{ startDate: string, endDate: string, recurringWeekDays?: Array<Weekday | null> | null, hours?: Array<{ openStart: number, openEnd: number } | null> | null } | null>, displaySettings?: { displayTitle?: string | null, displayDescription?: string | null, displayAltDescription?: string | null, displayAltTitle?: string | null, displayImage?: string | null, displayTerms?: string | null } | null } | null, loyaltyDetails?: { expiryDays: number, loyaltyReviewDate: number } | null, displaySettings?: { displayTitle?: string | null, displayDescription?: string | null, displayAltDescription?: string | null, displayAltTitle?: string | null, displayImage?: string | null, displayTerms?: string | null } | null } | null };

export type GetBuyNGetNFreePromotionQueryVariables = Exact<{
  promotionId: Scalars['String']['input'];
}>;


export type GetBuyNGetNFreePromotionQuery = { getBuyNGetNFreePromotion?: { id: string, name: string, description?: string | null, buyN: number, freeN: number, numberOfDeals: number, availableType?: Array<OrderType | null> | null, minimumAmount?: number | null, includedGetItemsPromoTags?: Array<string | null> | null, excludedPromotionTags?: Array<string | null> | null, includedPromotionTags?: Array<string | null> | null, canBeUsedWithOtherPromotions?: boolean | null, percentage?: number | null, discountAmount?: number | null, isPercentage?: boolean | null, upToAmount?: number | null, isOffer?: boolean | null, isHiddenInApp?: boolean | null, useType: PromotionUseType, isSignUpPromotion?: boolean | null, applyOptionDiscount?: boolean | null, isLoyalty?: boolean | null, effectiveDateTime: Array<{ startDate: string, endDate: string, recurringWeekDays?: Array<Weekday | null> | null, hours?: Array<{ openStart: number, openEnd: number } | null> | null } | null>, offerVoucherSettings?: { offerName: string, offerDescription?: string | null, offerExcludedItemTags?: Array<string | null> | null, effectiveHoursAfterOfferActivated: number, minimumAmount?: number | null, upToAmount?: number | null, voucherTerms: string, effectiveDateTime: Array<{ startDate: string, endDate: string, recurringWeekDays?: Array<Weekday | null> | null, hours?: Array<{ openStart: number, openEnd: number } | null> | null } | null>, displaySettings?: { displayTitle?: string | null, displayDescription?: string | null, displayAltDescription?: string | null, displayAltTitle?: string | null, displayImage?: string | null, displayTerms?: string | null } | null } | null, loyaltyDetails?: { expiryDays: number, loyaltyReviewDate: number } | null, displaySettings?: { displayTitle?: string | null, displayDescription?: string | null, displayAltDescription?: string | null, displayAltTitle?: string | null, displayImage?: string | null, displayTerms?: string | null } | null } | null };

export type PublishPromotionMutationVariables = Exact<{
  promotionId: Scalars['String']['input'];
}>;


export type PublishPromotionMutation = { publishPromotion: boolean };

export type UnpublishPromotionMutationVariables = Exact<{
  promotionId: Scalars['String']['input'];
}>;


export type UnpublishPromotionMutation = { unpublishPromotion: boolean };

export type DeletePromotionMutationVariables = Exact<{
  promotionId: Scalars['String']['input'];
}>;


export type DeletePromotionMutation = { deletePromotion: boolean };

export type CreatePercentagePromotionMutationVariables = Exact<{
  promotion: PercentagePromotionInput;
}>;


export type CreatePercentagePromotionMutation = { createPercentagePromotion: boolean };

export type CreateLoyaltyPromotionMutationVariables = Exact<{
  promotion: LoyaltyPromotionInput;
}>;


export type CreateLoyaltyPromotionMutation = { createLoyaltyPromotion: boolean };

export type UpdatePercentagePromotionMutationVariables = Exact<{
  promotion: PercentagePromotionInput;
  promotionId: Scalars['String']['input'];
}>;


export type UpdatePercentagePromotionMutation = { updatePercentagePromotion: boolean };

export type UpdateLoyaltyPromotionMutationVariables = Exact<{
  promotion: LoyaltyPromotionInput;
  promotionId: Scalars['String']['input'];
}>;


export type UpdateLoyaltyPromotionMutation = { updateLoyaltyPromotion: boolean };

export type CreateSpendPromotionMutationVariables = Exact<{
  promotion: SpendPromotionInput;
}>;


export type CreateSpendPromotionMutation = { createSpendPromotion: boolean };

export type UpdateSpendPromotionMutationVariables = Exact<{
  promotion: SpendPromotionInput;
  promotionId: Scalars['String']['input'];
}>;


export type UpdateSpendPromotionMutation = { updateSpendPromotion: boolean };

export type UpdateBuyNGetNFreePromotionMutationVariables = Exact<{
  promotion: BuyNGetNFreePromotionInput;
  promotionId: Scalars['String']['input'];
}>;


export type UpdateBuyNGetNFreePromotionMutation = { updateBuyNGetNFreePromotion: boolean };

export type CreateBuyNGetNFreePromotionMutationVariables = Exact<{
  promotion: BuyNGetNFreePromotionInput;
}>;


export type CreateBuyNGetNFreePromotionMutation = { createBuyNGetNFreePromotion: boolean };

export type GetLuckyDrawPromotionQueryVariables = Exact<{
  promotionId: Scalars['String']['input'];
}>;


export type GetLuckyDrawPromotionQuery = { getLuckyDrawPromotion?: { id: string, name: string, description?: string | null, numberOfDeals: number, availableType?: Array<OrderType | null> | null, isPublished?: boolean | null, useType: PromotionUseType, isSignUpPromotion?: boolean | null, prizeDescription?: string | null, winPercentage: number, winnerCount: number, entryLimitPerUser: number, minimumAmount?: number | null, winCountLimitPerPerson?: number | null, isEntryAutomatic?: boolean | null, isPaymentRequired?: boolean | null, isLoyalty?: boolean | null, effectiveDateTime: Array<{ startDate: string, endDate: string, recurringWeekDays?: Array<Weekday | null> | null, hours?: Array<{ openStart: number, openEnd: number } | null> | null } | null>, resultingPromotions: Array<{ promotionId: string, winPercentage: number }>, loyaltyDetails?: { expiryDays: number, loyaltyReviewDate: number } | null, displaySettings?: { displayTitle?: string | null, displayDescription?: string | null, displayAltDescription?: string | null, displayAltTitle?: string | null, displayImage?: string | null, displayTerms?: string | null } | null } | null };

export type CreateLuckyDrawPromotionMutationVariables = Exact<{
  promotion: LuckyDrawPromotionInput;
}>;


export type CreateLuckyDrawPromotionMutation = { createLuckyDrawPromotion: boolean };

export type UpdateLuckyDrawPromotionMutationVariables = Exact<{
  promotion: LuckyDrawPromotionInput;
  promotionId: Scalars['String']['input'];
}>;


export type UpdateLuckyDrawPromotionMutation = { updateLuckyDrawPromotion: boolean };

export type TopRestaurantTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type TopRestaurantTypesQuery = { topRestaurantTypes?: Array<RestaurantType | null> | null };

export type CreateOrUpdateTopRestaurantTypesMutationVariables = Exact<{
  types: Array<InputMaybe<RestaurantType>>;
}>;


export type CreateOrUpdateTopRestaurantTypesMutation = { createOrUpdateTopRestaurantTypes?: boolean | null };

export type GetAllUsersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllUsersQuery = { getAllUsers?: Array<{ id: string, name: string, role: UserRole, roles?: Array<UserRole> | null, email: string, merchantId?: string | null, phoneNumber?: string | null, permissions?: Array<UserPermission | null> | null, createdAt: string } | null> | null };

export type CreateUserMutationVariables = Exact<{
  email: Scalars['String']['input'];
  merchantId?: InputMaybe<Scalars['ID']['input']>;
  password: Scalars['String']['input'];
  role: UserRole;
  name: Scalars['String']['input'];
  roles?: InputMaybe<Array<UserRole>>;
}>;


export type CreateUserMutation = { createUser: boolean };

export type DeleteUserMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type DeleteUserMutation = { deleteUser: boolean };

export type GetUserDetailQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserDetailQuery = { getUserDetail: { id: string, name: string, role: UserRole, roles?: Array<UserRole> | null, email: string, merchantId?: string | null, phoneNumber?: string | null, permissions?: Array<UserPermission | null> | null, createdAt: string, loginToken?: string | null } };

export type ChangePasswordMutationVariables = Exact<{
  oldPassword: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
}>;


export type ChangePasswordMutation = { changePassword: boolean };

export type UpdateUserDetailsMutationVariables = Exact<{
  user: UserInput;
}>;


export type UpdateUserDetailsMutation = { updateUserDetails: boolean };

export type UpdateUserMutationVariables = Exact<{
  user: AccountInput;
}>;


export type UpdateUserMutation = { updateUser: boolean };


export const AppSectionsDocument = gql`
    query appSections {
  appSections {
    id
    contentType
    location
    viewType
    sort
    merchants {
      merchantId
      name
      altName
      address
      suburb
      city
      phoneNumber
      abn
      latitude
      longitude
      openTime {
        closeDates
        openHours {
          openStart
          openEnd
          weekDays
        }
      }
      logo
      logoImages
      merchantAdminEmail
      createdAt
      restaurantType
      restaurantCategory
      type
      tags
      onlineStatus
      onlineOrderCount
      orderbuddyMerchantId
      bookingMerchantId
    }
    items {
      id
      title
      description
      image
    }
    title
    description
    image
    status
    radiumInKm
    coordinate {
      latitude
      longitude
    }
  }
}
    `;

/**
 * __useAppSectionsQuery__
 *
 * To run a query within a React component, call `useAppSectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAppSectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAppSectionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAppSectionsQuery(baseOptions?: Apollo.QueryHookOptions<AppSectionsQuery, AppSectionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AppSectionsQuery, AppSectionsQueryVariables>(AppSectionsDocument, options);
      }
export function useAppSectionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AppSectionsQuery, AppSectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AppSectionsQuery, AppSectionsQueryVariables>(AppSectionsDocument, options);
        }
export function useAppSectionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AppSectionsQuery, AppSectionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AppSectionsQuery, AppSectionsQueryVariables>(AppSectionsDocument, options);
        }
export type AppSectionsQueryHookResult = ReturnType<typeof useAppSectionsQuery>;
export type AppSectionsLazyQueryHookResult = ReturnType<typeof useAppSectionsLazyQuery>;
export type AppSectionsSuspenseQueryHookResult = ReturnType<typeof useAppSectionsSuspenseQuery>;
export type AppSectionsQueryResult = Apollo.QueryResult<AppSectionsQuery, AppSectionsQueryVariables>;
export const CreateAppSectionDocument = gql`
    mutation createAppSection($section: AppSectionInput!) {
  createAppSection(section: $section)
}
    `;
export type CreateAppSectionMutationFn = Apollo.MutationFunction<CreateAppSectionMutation, CreateAppSectionMutationVariables>;

/**
 * __useCreateAppSectionMutation__
 *
 * To run a mutation, you first call `useCreateAppSectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAppSectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAppSectionMutation, { data, loading, error }] = useCreateAppSectionMutation({
 *   variables: {
 *      section: // value for 'section'
 *   },
 * });
 */
export function useCreateAppSectionMutation(baseOptions?: Apollo.MutationHookOptions<CreateAppSectionMutation, CreateAppSectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAppSectionMutation, CreateAppSectionMutationVariables>(CreateAppSectionDocument, options);
      }
export type CreateAppSectionMutationHookResult = ReturnType<typeof useCreateAppSectionMutation>;
export type CreateAppSectionMutationResult = Apollo.MutationResult<CreateAppSectionMutation>;
export type CreateAppSectionMutationOptions = Apollo.BaseMutationOptions<CreateAppSectionMutation, CreateAppSectionMutationVariables>;
export const UpdateAppSectionDocument = gql`
    mutation updateAppSection($section: AppSectionInput!, $sectionId: ID!) {
  updateAppSection(section: $section, sectionId: $sectionId)
}
    `;
export type UpdateAppSectionMutationFn = Apollo.MutationFunction<UpdateAppSectionMutation, UpdateAppSectionMutationVariables>;

/**
 * __useUpdateAppSectionMutation__
 *
 * To run a mutation, you first call `useUpdateAppSectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAppSectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAppSectionMutation, { data, loading, error }] = useUpdateAppSectionMutation({
 *   variables: {
 *      section: // value for 'section'
 *      sectionId: // value for 'sectionId'
 *   },
 * });
 */
export function useUpdateAppSectionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAppSectionMutation, UpdateAppSectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAppSectionMutation, UpdateAppSectionMutationVariables>(UpdateAppSectionDocument, options);
      }
export type UpdateAppSectionMutationHookResult = ReturnType<typeof useUpdateAppSectionMutation>;
export type UpdateAppSectionMutationResult = Apollo.MutationResult<UpdateAppSectionMutation>;
export type UpdateAppSectionMutationOptions = Apollo.BaseMutationOptions<UpdateAppSectionMutation, UpdateAppSectionMutationVariables>;
export const PublishAppSectionDocument = gql`
    mutation publishAppSection($sectionId: ID!) {
  publishAppSection(sectionId: $sectionId)
}
    `;
export type PublishAppSectionMutationFn = Apollo.MutationFunction<PublishAppSectionMutation, PublishAppSectionMutationVariables>;

/**
 * __usePublishAppSectionMutation__
 *
 * To run a mutation, you first call `usePublishAppSectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishAppSectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishAppSectionMutation, { data, loading, error }] = usePublishAppSectionMutation({
 *   variables: {
 *      sectionId: // value for 'sectionId'
 *   },
 * });
 */
export function usePublishAppSectionMutation(baseOptions?: Apollo.MutationHookOptions<PublishAppSectionMutation, PublishAppSectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PublishAppSectionMutation, PublishAppSectionMutationVariables>(PublishAppSectionDocument, options);
      }
export type PublishAppSectionMutationHookResult = ReturnType<typeof usePublishAppSectionMutation>;
export type PublishAppSectionMutationResult = Apollo.MutationResult<PublishAppSectionMutation>;
export type PublishAppSectionMutationOptions = Apollo.BaseMutationOptions<PublishAppSectionMutation, PublishAppSectionMutationVariables>;
export const DeleteAppSectionDocument = gql`
    mutation deleteAppSection($sectionId: ID!) {
  deleteAppSection(sectionId: $sectionId)
}
    `;
export type DeleteAppSectionMutationFn = Apollo.MutationFunction<DeleteAppSectionMutation, DeleteAppSectionMutationVariables>;

/**
 * __useDeleteAppSectionMutation__
 *
 * To run a mutation, you first call `useDeleteAppSectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAppSectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAppSectionMutation, { data, loading, error }] = useDeleteAppSectionMutation({
 *   variables: {
 *      sectionId: // value for 'sectionId'
 *   },
 * });
 */
export function useDeleteAppSectionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAppSectionMutation, DeleteAppSectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAppSectionMutation, DeleteAppSectionMutationVariables>(DeleteAppSectionDocument, options);
      }
export type DeleteAppSectionMutationHookResult = ReturnType<typeof useDeleteAppSectionMutation>;
export type DeleteAppSectionMutationResult = Apollo.MutationResult<DeleteAppSectionMutation>;
export type DeleteAppSectionMutationOptions = Apollo.BaseMutationOptions<DeleteAppSectionMutation, DeleteAppSectionMutationVariables>;
export const LoginDocument = gql`
    mutation Login($email: String!, $password: String!) {
  login(email: $email, password: $password) {
    id
    name
    role
    email
    merchantId
    phoneNumber
    permissions
    createdAt
    loginToken
  }
}
    `;
export type LoginMutationFn = Apollo.MutationFunction<LoginMutation, LoginMutationVariables>;

/**
 * __useLoginMutation__
 *
 * To run a mutation, you first call `useLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginMutation, { data, loading, error }] = useLoginMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useLoginMutation(baseOptions?: Apollo.MutationHookOptions<LoginMutation, LoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginMutation, LoginMutationVariables>(LoginDocument, options);
      }
export type LoginMutationHookResult = ReturnType<typeof useLoginMutation>;
export type LoginMutationResult = Apollo.MutationResult<LoginMutation>;
export type LoginMutationOptions = Apollo.BaseMutationOptions<LoginMutation, LoginMutationVariables>;
export const LogoutDocument = gql`
    mutation Logout {
  logout
}
    `;
export type LogoutMutationFn = Apollo.MutationFunction<LogoutMutation, LogoutMutationVariables>;

/**
 * __useLogoutMutation__
 *
 * To run a mutation, you first call `useLogoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logoutMutation, { data, loading, error }] = useLogoutMutation({
 *   variables: {
 *   },
 * });
 */
export function useLogoutMutation(baseOptions?: Apollo.MutationHookOptions<LogoutMutation, LogoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LogoutMutation, LogoutMutationVariables>(LogoutDocument, options);
      }
export type LogoutMutationHookResult = ReturnType<typeof useLogoutMutation>;
export type LogoutMutationResult = Apollo.MutationResult<LogoutMutation>;
export type LogoutMutationOptions = Apollo.BaseMutationOptions<LogoutMutation, LogoutMutationVariables>;
export const ResetPasswordDocument = gql`
    mutation resetPassword($email: String!) {
  resetPassword(email: $email)
}
    `;
export type ResetPasswordMutationFn = Apollo.MutationFunction<ResetPasswordMutation, ResetPasswordMutationVariables>;

/**
 * __useResetPasswordMutation__
 *
 * To run a mutation, you first call `useResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPasswordMutation, { data, loading, error }] = useResetPasswordMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useResetPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ResetPasswordMutation, ResetPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetPasswordMutation, ResetPasswordMutationVariables>(ResetPasswordDocument, options);
      }
export type ResetPasswordMutationHookResult = ReturnType<typeof useResetPasswordMutation>;
export type ResetPasswordMutationResult = Apollo.MutationResult<ResetPasswordMutation>;
export type ResetPasswordMutationOptions = Apollo.BaseMutationOptions<ResetPasswordMutation, ResetPasswordMutationVariables>;
export const BookingsDocument = gql`
    query bookings($dateString: String!) {
  bookings(dateString: $dateString) {
    id
    merchantId
    createdAt
    customer {
      name
      email
      phoneNumber
      guestNum
      address
      postcode
      foodAllergies
      geolocation {
        longitude
        latitude
      }
    }
    bookingDetails {
      bookingTime
      numberOfGuests
      specialInstructions
      promotionId
    }
  }
}
    `;

/**
 * __useBookingsQuery__
 *
 * To run a query within a React component, call `useBookingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookingsQuery({
 *   variables: {
 *      dateString: // value for 'dateString'
 *   },
 * });
 */
export function useBookingsQuery(baseOptions: Apollo.QueryHookOptions<BookingsQuery, BookingsQueryVariables> & ({ variables: BookingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BookingsQuery, BookingsQueryVariables>(BookingsDocument, options);
      }
export function useBookingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BookingsQuery, BookingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BookingsQuery, BookingsQueryVariables>(BookingsDocument, options);
        }
export function useBookingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BookingsQuery, BookingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BookingsQuery, BookingsQueryVariables>(BookingsDocument, options);
        }
export type BookingsQueryHookResult = ReturnType<typeof useBookingsQuery>;
export type BookingsLazyQueryHookResult = ReturnType<typeof useBookingsLazyQuery>;
export type BookingsSuspenseQueryHookResult = ReturnType<typeof useBookingsSuspenseQuery>;
export type BookingsQueryResult = Apollo.QueryResult<BookingsQuery, BookingsQueryVariables>;
export const BookingDocument = gql`
    query booking($dateString: String!, $bookingId: String!) {
  booking(dateString: $dateString, bookingId: $bookingId) {
    id
    merchantId
    createdAt
    customer {
      name
      email
      phoneNumber
      guestNum
      address
      postcode
      foodAllergies
      geolocation {
        longitude
        latitude
      }
    }
    bookingDetails {
      bookingTime
      numberOfGuests
      specialInstructions
      promotionId
    }
  }
}
    `;

/**
 * __useBookingQuery__
 *
 * To run a query within a React component, call `useBookingQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookingQuery({
 *   variables: {
 *      dateString: // value for 'dateString'
 *      bookingId: // value for 'bookingId'
 *   },
 * });
 */
export function useBookingQuery(baseOptions: Apollo.QueryHookOptions<BookingQuery, BookingQueryVariables> & ({ variables: BookingQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BookingQuery, BookingQueryVariables>(BookingDocument, options);
      }
export function useBookingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BookingQuery, BookingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BookingQuery, BookingQueryVariables>(BookingDocument, options);
        }
export function useBookingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BookingQuery, BookingQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BookingQuery, BookingQueryVariables>(BookingDocument, options);
        }
export type BookingQueryHookResult = ReturnType<typeof useBookingQuery>;
export type BookingLazyQueryHookResult = ReturnType<typeof useBookingLazyQuery>;
export type BookingSuspenseQueryHookResult = ReturnType<typeof useBookingSuspenseQuery>;
export type BookingQueryResult = Apollo.QueryResult<BookingQuery, BookingQueryVariables>;
export const BookingSessionsDocument = gql`
    query bookingSessions {
  bookingSessions {
    id
    name
    description
    guestCountLimit
    OpenTime {
      closeDates
      openHours {
        openStart
        openEnd
        weekDays
      }
    }
    hideEndTime
    hideTableNumber
    needDeposite
    isEnabled
    bookingTables {
      minimumNumberOfGuests
      maximumNumberOfGuests
      tableNumber
    }
  }
}
    `;

/**
 * __useBookingSessionsQuery__
 *
 * To run a query within a React component, call `useBookingSessionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookingSessionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookingSessionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useBookingSessionsQuery(baseOptions?: Apollo.QueryHookOptions<BookingSessionsQuery, BookingSessionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BookingSessionsQuery, BookingSessionsQueryVariables>(BookingSessionsDocument, options);
      }
export function useBookingSessionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BookingSessionsQuery, BookingSessionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BookingSessionsQuery, BookingSessionsQueryVariables>(BookingSessionsDocument, options);
        }
export function useBookingSessionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BookingSessionsQuery, BookingSessionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BookingSessionsQuery, BookingSessionsQueryVariables>(BookingSessionsDocument, options);
        }
export type BookingSessionsQueryHookResult = ReturnType<typeof useBookingSessionsQuery>;
export type BookingSessionsLazyQueryHookResult = ReturnType<typeof useBookingSessionsLazyQuery>;
export type BookingSessionsSuspenseQueryHookResult = ReturnType<typeof useBookingSessionsSuspenseQuery>;
export type BookingSessionsQueryResult = Apollo.QueryResult<BookingSessionsQuery, BookingSessionsQueryVariables>;
export const CreateBookingSessionDocument = gql`
    mutation createBookingSession($bookingSession: BookingSessionInput!) {
  createBookingSession(bookingSession: $bookingSession)
}
    `;
export type CreateBookingSessionMutationFn = Apollo.MutationFunction<CreateBookingSessionMutation, CreateBookingSessionMutationVariables>;

/**
 * __useCreateBookingSessionMutation__
 *
 * To run a mutation, you first call `useCreateBookingSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBookingSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBookingSessionMutation, { data, loading, error }] = useCreateBookingSessionMutation({
 *   variables: {
 *      bookingSession: // value for 'bookingSession'
 *   },
 * });
 */
export function useCreateBookingSessionMutation(baseOptions?: Apollo.MutationHookOptions<CreateBookingSessionMutation, CreateBookingSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBookingSessionMutation, CreateBookingSessionMutationVariables>(CreateBookingSessionDocument, options);
      }
export type CreateBookingSessionMutationHookResult = ReturnType<typeof useCreateBookingSessionMutation>;
export type CreateBookingSessionMutationResult = Apollo.MutationResult<CreateBookingSessionMutation>;
export type CreateBookingSessionMutationOptions = Apollo.BaseMutationOptions<CreateBookingSessionMutation, CreateBookingSessionMutationVariables>;
export const BookingSessionDocument = gql`
    query bookingSession($bookingSessionId: String!) {
  bookingSession(bookingSessionId: $bookingSessionId) {
    name
    description
    guestCountLimit
    OpenTime {
      closeDates
      openHours {
        openStart
        openEnd
        weekDays
      }
    }
    hideEndTime
    hideTableNumber
    needDeposite
    isEnabled
    bookingTables {
      minimumNumberOfGuests
      maximumNumberOfGuests
      tableNumber
    }
  }
}
    `;

/**
 * __useBookingSessionQuery__
 *
 * To run a query within a React component, call `useBookingSessionQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookingSessionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookingSessionQuery({
 *   variables: {
 *      bookingSessionId: // value for 'bookingSessionId'
 *   },
 * });
 */
export function useBookingSessionQuery(baseOptions: Apollo.QueryHookOptions<BookingSessionQuery, BookingSessionQueryVariables> & ({ variables: BookingSessionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BookingSessionQuery, BookingSessionQueryVariables>(BookingSessionDocument, options);
      }
export function useBookingSessionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BookingSessionQuery, BookingSessionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BookingSessionQuery, BookingSessionQueryVariables>(BookingSessionDocument, options);
        }
export function useBookingSessionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BookingSessionQuery, BookingSessionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BookingSessionQuery, BookingSessionQueryVariables>(BookingSessionDocument, options);
        }
export type BookingSessionQueryHookResult = ReturnType<typeof useBookingSessionQuery>;
export type BookingSessionLazyQueryHookResult = ReturnType<typeof useBookingSessionLazyQuery>;
export type BookingSessionSuspenseQueryHookResult = ReturnType<typeof useBookingSessionSuspenseQuery>;
export type BookingSessionQueryResult = Apollo.QueryResult<BookingSessionQuery, BookingSessionQueryVariables>;
export const UpdateBookingSessionDocument = gql`
    mutation updateBookingSession($bookingSession: BookingSessionInput!, $bookingSessionId: String!) {
  updateBookingSession(
    bookingSession: $bookingSession
    bookingSessionId: $bookingSessionId
  )
}
    `;
export type UpdateBookingSessionMutationFn = Apollo.MutationFunction<UpdateBookingSessionMutation, UpdateBookingSessionMutationVariables>;

/**
 * __useUpdateBookingSessionMutation__
 *
 * To run a mutation, you first call `useUpdateBookingSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBookingSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBookingSessionMutation, { data, loading, error }] = useUpdateBookingSessionMutation({
 *   variables: {
 *      bookingSession: // value for 'bookingSession'
 *      bookingSessionId: // value for 'bookingSessionId'
 *   },
 * });
 */
export function useUpdateBookingSessionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBookingSessionMutation, UpdateBookingSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBookingSessionMutation, UpdateBookingSessionMutationVariables>(UpdateBookingSessionDocument, options);
      }
export type UpdateBookingSessionMutationHookResult = ReturnType<typeof useUpdateBookingSessionMutation>;
export type UpdateBookingSessionMutationResult = Apollo.MutationResult<UpdateBookingSessionMutation>;
export type UpdateBookingSessionMutationOptions = Apollo.BaseMutationOptions<UpdateBookingSessionMutation, UpdateBookingSessionMutationVariables>;
export const FaqDocument = gql`
    query faq($app: OBApp!) {
  faq(app: $app) {
    app
    sections {
      id
      title
      description
      sort
      questions {
        id
        question
        answer
        sort
        tags
        videoUrl
      }
    }
  }
}
    `;

/**
 * __useFaqQuery__
 *
 * To run a query within a React component, call `useFaqQuery` and pass it any options that fit your needs.
 * When your component renders, `useFaqQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFaqQuery({
 *   variables: {
 *      app: // value for 'app'
 *   },
 * });
 */
export function useFaqQuery(baseOptions: Apollo.QueryHookOptions<FaqQuery, FaqQueryVariables> & ({ variables: FaqQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FaqQuery, FaqQueryVariables>(FaqDocument, options);
      }
export function useFaqLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FaqQuery, FaqQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FaqQuery, FaqQueryVariables>(FaqDocument, options);
        }
export function useFaqSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FaqQuery, FaqQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FaqQuery, FaqQueryVariables>(FaqDocument, options);
        }
export type FaqQueryHookResult = ReturnType<typeof useFaqQuery>;
export type FaqLazyQueryHookResult = ReturnType<typeof useFaqLazyQuery>;
export type FaqSuspenseQueryHookResult = ReturnType<typeof useFaqSuspenseQuery>;
export type FaqQueryResult = Apollo.QueryResult<FaqQuery, FaqQueryVariables>;
export const CreateFaqSectionDocument = gql`
    mutation createFAQSection($app: OBApp!, $section: OBFAQSectionInput!) {
  createFAQSection(app: $app, section: $section)
}
    `;
export type CreateFaqSectionMutationFn = Apollo.MutationFunction<CreateFaqSectionMutation, CreateFaqSectionMutationVariables>;

/**
 * __useCreateFaqSectionMutation__
 *
 * To run a mutation, you first call `useCreateFaqSectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFaqSectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFaqSectionMutation, { data, loading, error }] = useCreateFaqSectionMutation({
 *   variables: {
 *      app: // value for 'app'
 *      section: // value for 'section'
 *   },
 * });
 */
export function useCreateFaqSectionMutation(baseOptions?: Apollo.MutationHookOptions<CreateFaqSectionMutation, CreateFaqSectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFaqSectionMutation, CreateFaqSectionMutationVariables>(CreateFaqSectionDocument, options);
      }
export type CreateFaqSectionMutationHookResult = ReturnType<typeof useCreateFaqSectionMutation>;
export type CreateFaqSectionMutationResult = Apollo.MutationResult<CreateFaqSectionMutation>;
export type CreateFaqSectionMutationOptions = Apollo.BaseMutationOptions<CreateFaqSectionMutation, CreateFaqSectionMutationVariables>;
export const UpdateFaqSectionDocument = gql`
    mutation updateFAQSection($app: OBApp!, $section: OBFAQSectionInput!, $sectionId: ID!) {
  updateFAQSection(app: $app, section: $section, sectionId: $sectionId)
}
    `;
export type UpdateFaqSectionMutationFn = Apollo.MutationFunction<UpdateFaqSectionMutation, UpdateFaqSectionMutationVariables>;

/**
 * __useUpdateFaqSectionMutation__
 *
 * To run a mutation, you first call `useUpdateFaqSectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFaqSectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFaqSectionMutation, { data, loading, error }] = useUpdateFaqSectionMutation({
 *   variables: {
 *      app: // value for 'app'
 *      section: // value for 'section'
 *      sectionId: // value for 'sectionId'
 *   },
 * });
 */
export function useUpdateFaqSectionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFaqSectionMutation, UpdateFaqSectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFaqSectionMutation, UpdateFaqSectionMutationVariables>(UpdateFaqSectionDocument, options);
      }
export type UpdateFaqSectionMutationHookResult = ReturnType<typeof useUpdateFaqSectionMutation>;
export type UpdateFaqSectionMutationResult = Apollo.MutationResult<UpdateFaqSectionMutation>;
export type UpdateFaqSectionMutationOptions = Apollo.BaseMutationOptions<UpdateFaqSectionMutation, UpdateFaqSectionMutationVariables>;
export const DeleteFaqSectionDocument = gql`
    mutation deleteFAQSection($app: OBApp!, $sectionId: ID!) {
  deleteFAQSection(app: $app, sectionId: $sectionId)
}
    `;
export type DeleteFaqSectionMutationFn = Apollo.MutationFunction<DeleteFaqSectionMutation, DeleteFaqSectionMutationVariables>;

/**
 * __useDeleteFaqSectionMutation__
 *
 * To run a mutation, you first call `useDeleteFaqSectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFaqSectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFaqSectionMutation, { data, loading, error }] = useDeleteFaqSectionMutation({
 *   variables: {
 *      app: // value for 'app'
 *      sectionId: // value for 'sectionId'
 *   },
 * });
 */
export function useDeleteFaqSectionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteFaqSectionMutation, DeleteFaqSectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteFaqSectionMutation, DeleteFaqSectionMutationVariables>(DeleteFaqSectionDocument, options);
      }
export type DeleteFaqSectionMutationHookResult = ReturnType<typeof useDeleteFaqSectionMutation>;
export type DeleteFaqSectionMutationResult = Apollo.MutationResult<DeleteFaqSectionMutation>;
export type DeleteFaqSectionMutationOptions = Apollo.BaseMutationOptions<DeleteFaqSectionMutation, DeleteFaqSectionMutationVariables>;
export const CreateFaqQuestionDocument = gql`
    mutation createFAQQuestion($app: OBApp!, $sectionId: ID!, $question: OBFAQQuestionInput!) {
  createFAQQuestion(app: $app, sectionId: $sectionId, question: $question)
}
    `;
export type CreateFaqQuestionMutationFn = Apollo.MutationFunction<CreateFaqQuestionMutation, CreateFaqQuestionMutationVariables>;

/**
 * __useCreateFaqQuestionMutation__
 *
 * To run a mutation, you first call `useCreateFaqQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFaqQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFaqQuestionMutation, { data, loading, error }] = useCreateFaqQuestionMutation({
 *   variables: {
 *      app: // value for 'app'
 *      sectionId: // value for 'sectionId'
 *      question: // value for 'question'
 *   },
 * });
 */
export function useCreateFaqQuestionMutation(baseOptions?: Apollo.MutationHookOptions<CreateFaqQuestionMutation, CreateFaqQuestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFaqQuestionMutation, CreateFaqQuestionMutationVariables>(CreateFaqQuestionDocument, options);
      }
export type CreateFaqQuestionMutationHookResult = ReturnType<typeof useCreateFaqQuestionMutation>;
export type CreateFaqQuestionMutationResult = Apollo.MutationResult<CreateFaqQuestionMutation>;
export type CreateFaqQuestionMutationOptions = Apollo.BaseMutationOptions<CreateFaqQuestionMutation, CreateFaqQuestionMutationVariables>;
export const UpdateFaqQuestionDocument = gql`
    mutation updateFAQQuestion($app: OBApp!, $sectionId: ID!, $question: OBFAQQuestionInput!, $questionId: ID!) {
  updateFAQQuestion(
    app: $app
    sectionId: $sectionId
    question: $question
    questionId: $questionId
  )
}
    `;
export type UpdateFaqQuestionMutationFn = Apollo.MutationFunction<UpdateFaqQuestionMutation, UpdateFaqQuestionMutationVariables>;

/**
 * __useUpdateFaqQuestionMutation__
 *
 * To run a mutation, you first call `useUpdateFaqQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFaqQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFaqQuestionMutation, { data, loading, error }] = useUpdateFaqQuestionMutation({
 *   variables: {
 *      app: // value for 'app'
 *      sectionId: // value for 'sectionId'
 *      question: // value for 'question'
 *      questionId: // value for 'questionId'
 *   },
 * });
 */
export function useUpdateFaqQuestionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFaqQuestionMutation, UpdateFaqQuestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFaqQuestionMutation, UpdateFaqQuestionMutationVariables>(UpdateFaqQuestionDocument, options);
      }
export type UpdateFaqQuestionMutationHookResult = ReturnType<typeof useUpdateFaqQuestionMutation>;
export type UpdateFaqQuestionMutationResult = Apollo.MutationResult<UpdateFaqQuestionMutation>;
export type UpdateFaqQuestionMutationOptions = Apollo.BaseMutationOptions<UpdateFaqQuestionMutation, UpdateFaqQuestionMutationVariables>;
export const DeleteFaqQuestionDocument = gql`
    mutation deleteFAQQuestion($app: OBApp!, $sectionId: ID!, $questionId: ID!) {
  deleteFAQQuestion(app: $app, sectionId: $sectionId, questionId: $questionId)
}
    `;
export type DeleteFaqQuestionMutationFn = Apollo.MutationFunction<DeleteFaqQuestionMutation, DeleteFaqQuestionMutationVariables>;

/**
 * __useDeleteFaqQuestionMutation__
 *
 * To run a mutation, you first call `useDeleteFaqQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFaqQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFaqQuestionMutation, { data, loading, error }] = useDeleteFaqQuestionMutation({
 *   variables: {
 *      app: // value for 'app'
 *      sectionId: // value for 'sectionId'
 *      questionId: // value for 'questionId'
 *   },
 * });
 */
export function useDeleteFaqQuestionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteFaqQuestionMutation, DeleteFaqQuestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteFaqQuestionMutation, DeleteFaqQuestionMutationVariables>(DeleteFaqQuestionDocument, options);
      }
export type DeleteFaqQuestionMutationHookResult = ReturnType<typeof useDeleteFaqQuestionMutation>;
export type DeleteFaqQuestionMutationResult = Apollo.MutationResult<DeleteFaqQuestionMutation>;
export type DeleteFaqQuestionMutationOptions = Apollo.BaseMutationOptions<DeleteFaqQuestionMutation, DeleteFaqQuestionMutationVariables>;
export const CreateGiftCardAccountDocument = gql`
    mutation createGiftCardAccount($input: GiftCardAccountInput!) {
  createGiftCardAccount(input: $input)
}
    `;
export type CreateGiftCardAccountMutationFn = Apollo.MutationFunction<CreateGiftCardAccountMutation, CreateGiftCardAccountMutationVariables>;

/**
 * __useCreateGiftCardAccountMutation__
 *
 * To run a mutation, you first call `useCreateGiftCardAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGiftCardAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGiftCardAccountMutation, { data, loading, error }] = useCreateGiftCardAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateGiftCardAccountMutation(baseOptions?: Apollo.MutationHookOptions<CreateGiftCardAccountMutation, CreateGiftCardAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateGiftCardAccountMutation, CreateGiftCardAccountMutationVariables>(CreateGiftCardAccountDocument, options);
      }
export type CreateGiftCardAccountMutationHookResult = ReturnType<typeof useCreateGiftCardAccountMutation>;
export type CreateGiftCardAccountMutationResult = Apollo.MutationResult<CreateGiftCardAccountMutation>;
export type CreateGiftCardAccountMutationOptions = Apollo.BaseMutationOptions<CreateGiftCardAccountMutation, CreateGiftCardAccountMutationVariables>;
export const DeleteGiftCardAccountDocument = gql`
    mutation deleteGiftCardAccount($giftCardAccountId: ID!) {
  deleteGiftCardAccount(giftCardAccountId: $giftCardAccountId)
}
    `;
export type DeleteGiftCardAccountMutationFn = Apollo.MutationFunction<DeleteGiftCardAccountMutation, DeleteGiftCardAccountMutationVariables>;

/**
 * __useDeleteGiftCardAccountMutation__
 *
 * To run a mutation, you first call `useDeleteGiftCardAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteGiftCardAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteGiftCardAccountMutation, { data, loading, error }] = useDeleteGiftCardAccountMutation({
 *   variables: {
 *      giftCardAccountId: // value for 'giftCardAccountId'
 *   },
 * });
 */
export function useDeleteGiftCardAccountMutation(baseOptions?: Apollo.MutationHookOptions<DeleteGiftCardAccountMutation, DeleteGiftCardAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteGiftCardAccountMutation, DeleteGiftCardAccountMutationVariables>(DeleteGiftCardAccountDocument, options);
      }
export type DeleteGiftCardAccountMutationHookResult = ReturnType<typeof useDeleteGiftCardAccountMutation>;
export type DeleteGiftCardAccountMutationResult = Apollo.MutationResult<DeleteGiftCardAccountMutation>;
export type DeleteGiftCardAccountMutationOptions = Apollo.BaseMutationOptions<DeleteGiftCardAccountMutation, DeleteGiftCardAccountMutationVariables>;
export const UpdateGiftCardAdminUsersDocument = gql`
    mutation updateGiftCardAdminUsers($giftCardAccountId: ID!, $userIds: [ID!]!) {
  updateGiftCardAdminUsers(
    giftCardAccountId: $giftCardAccountId
    userIds: $userIds
  ) {
    id
  }
}
    `;
export type UpdateGiftCardAdminUsersMutationFn = Apollo.MutationFunction<UpdateGiftCardAdminUsersMutation, UpdateGiftCardAdminUsersMutationVariables>;

/**
 * __useUpdateGiftCardAdminUsersMutation__
 *
 * To run a mutation, you first call `useUpdateGiftCardAdminUsersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGiftCardAdminUsersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGiftCardAdminUsersMutation, { data, loading, error }] = useUpdateGiftCardAdminUsersMutation({
 *   variables: {
 *      giftCardAccountId: // value for 'giftCardAccountId'
 *      userIds: // value for 'userIds'
 *   },
 * });
 */
export function useUpdateGiftCardAdminUsersMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGiftCardAdminUsersMutation, UpdateGiftCardAdminUsersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateGiftCardAdminUsersMutation, UpdateGiftCardAdminUsersMutationVariables>(UpdateGiftCardAdminUsersDocument, options);
      }
export type UpdateGiftCardAdminUsersMutationHookResult = ReturnType<typeof useUpdateGiftCardAdminUsersMutation>;
export type UpdateGiftCardAdminUsersMutationResult = Apollo.MutationResult<UpdateGiftCardAdminUsersMutation>;
export type UpdateGiftCardAdminUsersMutationOptions = Apollo.BaseMutationOptions<UpdateGiftCardAdminUsersMutation, UpdateGiftCardAdminUsersMutationVariables>;
export const AdjustGiftCardAccountDocument = gql`
    mutation adjustGiftCardAccount($input: AdjustGiftCardInput!) {
  adjustGiftCardAccount(input: $input) {
    id
  }
}
    `;
export type AdjustGiftCardAccountMutationFn = Apollo.MutationFunction<AdjustGiftCardAccountMutation, AdjustGiftCardAccountMutationVariables>;

/**
 * __useAdjustGiftCardAccountMutation__
 *
 * To run a mutation, you first call `useAdjustGiftCardAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdjustGiftCardAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adjustGiftCardAccountMutation, { data, loading, error }] = useAdjustGiftCardAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdjustGiftCardAccountMutation(baseOptions?: Apollo.MutationHookOptions<AdjustGiftCardAccountMutation, AdjustGiftCardAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdjustGiftCardAccountMutation, AdjustGiftCardAccountMutationVariables>(AdjustGiftCardAccountDocument, options);
      }
export type AdjustGiftCardAccountMutationHookResult = ReturnType<typeof useAdjustGiftCardAccountMutation>;
export type AdjustGiftCardAccountMutationResult = Apollo.MutationResult<AdjustGiftCardAccountMutation>;
export type AdjustGiftCardAccountMutationOptions = Apollo.BaseMutationOptions<AdjustGiftCardAccountMutation, AdjustGiftCardAccountMutationVariables>;
export const CreateGiftCardDocument = gql`
    mutation createGiftCard($input: GiftCardInput!) {
  createGiftCard(input: $input) {
    id
  }
}
    `;
export type CreateGiftCardMutationFn = Apollo.MutationFunction<CreateGiftCardMutation, CreateGiftCardMutationVariables>;

/**
 * __useCreateGiftCardMutation__
 *
 * To run a mutation, you first call `useCreateGiftCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGiftCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGiftCardMutation, { data, loading, error }] = useCreateGiftCardMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateGiftCardMutation(baseOptions?: Apollo.MutationHookOptions<CreateGiftCardMutation, CreateGiftCardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateGiftCardMutation, CreateGiftCardMutationVariables>(CreateGiftCardDocument, options);
      }
export type CreateGiftCardMutationHookResult = ReturnType<typeof useCreateGiftCardMutation>;
export type CreateGiftCardMutationResult = Apollo.MutationResult<CreateGiftCardMutation>;
export type CreateGiftCardMutationOptions = Apollo.BaseMutationOptions<CreateGiftCardMutation, CreateGiftCardMutationVariables>;
export const CreateGiftCardsDocument = gql`
    mutation createGiftCards($input: [GiftCardInput!]!) {
  createGiftCards(input: $input)
}
    `;
export type CreateGiftCardsMutationFn = Apollo.MutationFunction<CreateGiftCardsMutation, CreateGiftCardsMutationVariables>;

/**
 * __useCreateGiftCardsMutation__
 *
 * To run a mutation, you first call `useCreateGiftCardsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGiftCardsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGiftCardsMutation, { data, loading, error }] = useCreateGiftCardsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateGiftCardsMutation(baseOptions?: Apollo.MutationHookOptions<CreateGiftCardsMutation, CreateGiftCardsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateGiftCardsMutation, CreateGiftCardsMutationVariables>(CreateGiftCardsDocument, options);
      }
export type CreateGiftCardsMutationHookResult = ReturnType<typeof useCreateGiftCardsMutation>;
export type CreateGiftCardsMutationResult = Apollo.MutationResult<CreateGiftCardsMutation>;
export type CreateGiftCardsMutationOptions = Apollo.BaseMutationOptions<CreateGiftCardsMutation, CreateGiftCardsMutationVariables>;
export const VoidGiftCardDocument = gql`
    mutation voidGiftCard($giftCardId: ID!) {
  voidGiftCard(giftCardId: $giftCardId)
}
    `;
export type VoidGiftCardMutationFn = Apollo.MutationFunction<VoidGiftCardMutation, VoidGiftCardMutationVariables>;

/**
 * __useVoidGiftCardMutation__
 *
 * To run a mutation, you first call `useVoidGiftCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVoidGiftCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [voidGiftCardMutation, { data, loading, error }] = useVoidGiftCardMutation({
 *   variables: {
 *      giftCardId: // value for 'giftCardId'
 *   },
 * });
 */
export function useVoidGiftCardMutation(baseOptions?: Apollo.MutationHookOptions<VoidGiftCardMutation, VoidGiftCardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VoidGiftCardMutation, VoidGiftCardMutationVariables>(VoidGiftCardDocument, options);
      }
export type VoidGiftCardMutationHookResult = ReturnType<typeof useVoidGiftCardMutation>;
export type VoidGiftCardMutationResult = Apollo.MutationResult<VoidGiftCardMutation>;
export type VoidGiftCardMutationOptions = Apollo.BaseMutationOptions<VoidGiftCardMutation, VoidGiftCardMutationVariables>;
export const ResentGiftCardDocument = gql`
    mutation resentGiftCard($giftCardId: ID!) {
  resentGiftCard(giftCardId: $giftCardId)
}
    `;
export type ResentGiftCardMutationFn = Apollo.MutationFunction<ResentGiftCardMutation, ResentGiftCardMutationVariables>;

/**
 * __useResentGiftCardMutation__
 *
 * To run a mutation, you first call `useResentGiftCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResentGiftCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resentGiftCardMutation, { data, loading, error }] = useResentGiftCardMutation({
 *   variables: {
 *      giftCardId: // value for 'giftCardId'
 *   },
 * });
 */
export function useResentGiftCardMutation(baseOptions?: Apollo.MutationHookOptions<ResentGiftCardMutation, ResentGiftCardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResentGiftCardMutation, ResentGiftCardMutationVariables>(ResentGiftCardDocument, options);
      }
export type ResentGiftCardMutationHookResult = ReturnType<typeof useResentGiftCardMutation>;
export type ResentGiftCardMutationResult = Apollo.MutationResult<ResentGiftCardMutation>;
export type ResentGiftCardMutationOptions = Apollo.BaseMutationOptions<ResentGiftCardMutation, ResentGiftCardMutationVariables>;
export const SwitchGiftCardAccountDocument = gql`
    mutation switchGiftCardAccount($giftCardAccountId: ID!) {
  switchGiftCardAccount(giftCardAccountId: $giftCardAccountId)
}
    `;
export type SwitchGiftCardAccountMutationFn = Apollo.MutationFunction<SwitchGiftCardAccountMutation, SwitchGiftCardAccountMutationVariables>;

/**
 * __useSwitchGiftCardAccountMutation__
 *
 * To run a mutation, you first call `useSwitchGiftCardAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSwitchGiftCardAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [switchGiftCardAccountMutation, { data, loading, error }] = useSwitchGiftCardAccountMutation({
 *   variables: {
 *      giftCardAccountId: // value for 'giftCardAccountId'
 *   },
 * });
 */
export function useSwitchGiftCardAccountMutation(baseOptions?: Apollo.MutationHookOptions<SwitchGiftCardAccountMutation, SwitchGiftCardAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SwitchGiftCardAccountMutation, SwitchGiftCardAccountMutationVariables>(SwitchGiftCardAccountDocument, options);
      }
export type SwitchGiftCardAccountMutationHookResult = ReturnType<typeof useSwitchGiftCardAccountMutation>;
export type SwitchGiftCardAccountMutationResult = Apollo.MutationResult<SwitchGiftCardAccountMutation>;
export type SwitchGiftCardAccountMutationOptions = Apollo.BaseMutationOptions<SwitchGiftCardAccountMutation, SwitchGiftCardAccountMutationVariables>;
export const GiftCardAccountsDocument = gql`
    query giftCardAccounts {
  giftCardAccounts {
    id
    name
    description
    adminUserIds
    activeGiftCards {
      id
      message
      description
      giftCardAccountId
      serialNumber
      recipientName
      recipientPhone
      recipientEmail
      amount
      createdAt
      updatedAt
      redeemCode
      status
      merchantId
      expiredAt
      createdBy
      createdUserId
      sender
    }
    redeemedGiftCards {
      id
      message
      description
      giftCardAccountId
      serialNumber
      recipientName
      recipientPhone
      recipientEmail
      amount
      createdAt
      updatedAt
      redeemCode
      status
      merchantId
      expiredAt
      createdBy
      createdUserId
      sender
    }
    voidedGiftCards {
      id
      message
      description
      giftCardAccountId
      serialNumber
      recipientName
      recipientPhone
      recipientEmail
      amount
      createdAt
      updatedAt
      redeemCode
      status
      merchantId
      expiredAt
      createdBy
      createdUserId
      sender
    }
    balance
    createdAt
    updatedAt
    updatedUserId
    adjustmentRecords {
      id
      giftCardAccountId
      updatedUserId
      amount
      updatedAt
      type
      adjustmentType
      description
    }
  }
}
    `;

/**
 * __useGiftCardAccountsQuery__
 *
 * To run a query within a React component, call `useGiftCardAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGiftCardAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGiftCardAccountsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGiftCardAccountsQuery(baseOptions?: Apollo.QueryHookOptions<GiftCardAccountsQuery, GiftCardAccountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GiftCardAccountsQuery, GiftCardAccountsQueryVariables>(GiftCardAccountsDocument, options);
      }
export function useGiftCardAccountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GiftCardAccountsQuery, GiftCardAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GiftCardAccountsQuery, GiftCardAccountsQueryVariables>(GiftCardAccountsDocument, options);
        }
export function useGiftCardAccountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GiftCardAccountsQuery, GiftCardAccountsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GiftCardAccountsQuery, GiftCardAccountsQueryVariables>(GiftCardAccountsDocument, options);
        }
export type GiftCardAccountsQueryHookResult = ReturnType<typeof useGiftCardAccountsQuery>;
export type GiftCardAccountsLazyQueryHookResult = ReturnType<typeof useGiftCardAccountsLazyQuery>;
export type GiftCardAccountsSuspenseQueryHookResult = ReturnType<typeof useGiftCardAccountsSuspenseQuery>;
export type GiftCardAccountsQueryResult = Apollo.QueryResult<GiftCardAccountsQuery, GiftCardAccountsQueryVariables>;
export const GiftCardAccountsBaseInfoDocument = gql`
    query giftCardAccountsBaseInfo {
  giftCardAccounts {
    id
    name
    description
    adminUserIds
    balance
    createdAt
    updatedAt
    updatedUserId
  }
}
    `;

/**
 * __useGiftCardAccountsBaseInfoQuery__
 *
 * To run a query within a React component, call `useGiftCardAccountsBaseInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGiftCardAccountsBaseInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGiftCardAccountsBaseInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useGiftCardAccountsBaseInfoQuery(baseOptions?: Apollo.QueryHookOptions<GiftCardAccountsBaseInfoQuery, GiftCardAccountsBaseInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GiftCardAccountsBaseInfoQuery, GiftCardAccountsBaseInfoQueryVariables>(GiftCardAccountsBaseInfoDocument, options);
      }
export function useGiftCardAccountsBaseInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GiftCardAccountsBaseInfoQuery, GiftCardAccountsBaseInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GiftCardAccountsBaseInfoQuery, GiftCardAccountsBaseInfoQueryVariables>(GiftCardAccountsBaseInfoDocument, options);
        }
export function useGiftCardAccountsBaseInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GiftCardAccountsBaseInfoQuery, GiftCardAccountsBaseInfoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GiftCardAccountsBaseInfoQuery, GiftCardAccountsBaseInfoQueryVariables>(GiftCardAccountsBaseInfoDocument, options);
        }
export type GiftCardAccountsBaseInfoQueryHookResult = ReturnType<typeof useGiftCardAccountsBaseInfoQuery>;
export type GiftCardAccountsBaseInfoLazyQueryHookResult = ReturnType<typeof useGiftCardAccountsBaseInfoLazyQuery>;
export type GiftCardAccountsBaseInfoSuspenseQueryHookResult = ReturnType<typeof useGiftCardAccountsBaseInfoSuspenseQuery>;
export type GiftCardAccountsBaseInfoQueryResult = Apollo.QueryResult<GiftCardAccountsBaseInfoQuery, GiftCardAccountsBaseInfoQueryVariables>;
export const GiftCardAccountDocument = gql`
    query giftCardAccount {
  giftCardAccount {
    id
    name
    description
    adminUserIds
    balance
    createdAt
    updatedAt
    updatedUserId
  }
}
    `;

/**
 * __useGiftCardAccountQuery__
 *
 * To run a query within a React component, call `useGiftCardAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGiftCardAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGiftCardAccountQuery({
 *   variables: {
 *   },
 * });
 */
export function useGiftCardAccountQuery(baseOptions?: Apollo.QueryHookOptions<GiftCardAccountQuery, GiftCardAccountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GiftCardAccountQuery, GiftCardAccountQueryVariables>(GiftCardAccountDocument, options);
      }
export function useGiftCardAccountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GiftCardAccountQuery, GiftCardAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GiftCardAccountQuery, GiftCardAccountQueryVariables>(GiftCardAccountDocument, options);
        }
export function useGiftCardAccountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GiftCardAccountQuery, GiftCardAccountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GiftCardAccountQuery, GiftCardAccountQueryVariables>(GiftCardAccountDocument, options);
        }
export type GiftCardAccountQueryHookResult = ReturnType<typeof useGiftCardAccountQuery>;
export type GiftCardAccountLazyQueryHookResult = ReturnType<typeof useGiftCardAccountLazyQuery>;
export type GiftCardAccountSuspenseQueryHookResult = ReturnType<typeof useGiftCardAccountSuspenseQuery>;
export type GiftCardAccountQueryResult = Apollo.QueryResult<GiftCardAccountQuery, GiftCardAccountQueryVariables>;
export const MyGiftCardsDocument = gql`
    query myGiftCards {
  giftCardAccount {
    activeGiftCards {
      id
      message
      description
      giftCardAccountId
      serialNumber
      recipientName
      recipientPhone
      recipientEmail
      amount
      createdAt
      updatedAt
      redeemCode
      status
      merchantId
      expiredAt
      createdBy
      createdUserId
      sender
    }
    redeemedGiftCards {
      id
      message
      description
      giftCardAccountId
      serialNumber
      recipientName
      recipientPhone
      recipientEmail
      amount
      createdAt
      updatedAt
      redeemCode
      status
      merchantId
      expiredAt
      createdBy
      createdUserId
      sender
    }
    voidedGiftCards {
      id
      message
      description
      giftCardAccountId
      serialNumber
      recipientName
      recipientPhone
      recipientEmail
      amount
      createdAt
      updatedAt
      redeemCode
      status
      merchantId
      expiredAt
      createdBy
      createdUserId
      sender
    }
  }
}
    `;

/**
 * __useMyGiftCardsQuery__
 *
 * To run a query within a React component, call `useMyGiftCardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyGiftCardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyGiftCardsQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyGiftCardsQuery(baseOptions?: Apollo.QueryHookOptions<MyGiftCardsQuery, MyGiftCardsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyGiftCardsQuery, MyGiftCardsQueryVariables>(MyGiftCardsDocument, options);
      }
export function useMyGiftCardsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyGiftCardsQuery, MyGiftCardsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyGiftCardsQuery, MyGiftCardsQueryVariables>(MyGiftCardsDocument, options);
        }
export function useMyGiftCardsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyGiftCardsQuery, MyGiftCardsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MyGiftCardsQuery, MyGiftCardsQueryVariables>(MyGiftCardsDocument, options);
        }
export type MyGiftCardsQueryHookResult = ReturnType<typeof useMyGiftCardsQuery>;
export type MyGiftCardsLazyQueryHookResult = ReturnType<typeof useMyGiftCardsLazyQuery>;
export type MyGiftCardsSuspenseQueryHookResult = ReturnType<typeof useMyGiftCardsSuspenseQuery>;
export type MyGiftCardsQueryResult = Apollo.QueryResult<MyGiftCardsQuery, MyGiftCardsQueryVariables>;
export const MyAdjustmentRecordsDocument = gql`
    query myAdjustmentRecords {
  giftCardAccount {
    adjustmentRecords {
      id
      giftCardAccountId
      updatedUserId
      amount
      updatedAt
      type
      adjustmentType
      description
      updatedEmail
    }
  }
}
    `;

/**
 * __useMyAdjustmentRecordsQuery__
 *
 * To run a query within a React component, call `useMyAdjustmentRecordsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyAdjustmentRecordsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyAdjustmentRecordsQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyAdjustmentRecordsQuery(baseOptions?: Apollo.QueryHookOptions<MyAdjustmentRecordsQuery, MyAdjustmentRecordsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyAdjustmentRecordsQuery, MyAdjustmentRecordsQueryVariables>(MyAdjustmentRecordsDocument, options);
      }
export function useMyAdjustmentRecordsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyAdjustmentRecordsQuery, MyAdjustmentRecordsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyAdjustmentRecordsQuery, MyAdjustmentRecordsQueryVariables>(MyAdjustmentRecordsDocument, options);
        }
export function useMyAdjustmentRecordsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyAdjustmentRecordsQuery, MyAdjustmentRecordsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MyAdjustmentRecordsQuery, MyAdjustmentRecordsQueryVariables>(MyAdjustmentRecordsDocument, options);
        }
export type MyAdjustmentRecordsQueryHookResult = ReturnType<typeof useMyAdjustmentRecordsQuery>;
export type MyAdjustmentRecordsLazyQueryHookResult = ReturnType<typeof useMyAdjustmentRecordsLazyQuery>;
export type MyAdjustmentRecordsSuspenseQueryHookResult = ReturnType<typeof useMyAdjustmentRecordsSuspenseQuery>;
export type MyAdjustmentRecordsQueryResult = Apollo.QueryResult<MyAdjustmentRecordsQuery, MyAdjustmentRecordsQueryVariables>;
export const LoyaltyMembersDocument = gql`
    query loyaltyMembers {
  loyaltyMembers {
    loyaltyId
    userId
    userName
    userPhone
    userEmail
    merchantId
    loyaltyPoints
    spendProgress {
      currentSpend
      targetSpend
      promotionId
    }
    stampProgress {
      currentStamps
      targetStamps
      promotionId
    }
    redeemHistory {
      promotionId
      usedStamps
      usedPoints
      usedAmount
      createdAt
      voucherId
      description
    }
    earnHistory {
      promotionId
      earnedStamps
      earnedPoints
      earnedAmount
      createdAt
      orderNumber
      orderTotal
      merchantId
      orderItems {
        loyaltyPromotionId
        itemId
        name
        tags
        quantity
        price
        orderTime
      }
      description
    }
  }
}
    `;

/**
 * __useLoyaltyMembersQuery__
 *
 * To run a query within a React component, call `useLoyaltyMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoyaltyMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoyaltyMembersQuery({
 *   variables: {
 *   },
 * });
 */
export function useLoyaltyMembersQuery(baseOptions?: Apollo.QueryHookOptions<LoyaltyMembersQuery, LoyaltyMembersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LoyaltyMembersQuery, LoyaltyMembersQueryVariables>(LoyaltyMembersDocument, options);
      }
export function useLoyaltyMembersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LoyaltyMembersQuery, LoyaltyMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LoyaltyMembersQuery, LoyaltyMembersQueryVariables>(LoyaltyMembersDocument, options);
        }
export function useLoyaltyMembersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LoyaltyMembersQuery, LoyaltyMembersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LoyaltyMembersQuery, LoyaltyMembersQueryVariables>(LoyaltyMembersDocument, options);
        }
export type LoyaltyMembersQueryHookResult = ReturnType<typeof useLoyaltyMembersQuery>;
export type LoyaltyMembersLazyQueryHookResult = ReturnType<typeof useLoyaltyMembersLazyQuery>;
export type LoyaltyMembersSuspenseQueryHookResult = ReturnType<typeof useLoyaltyMembersSuspenseQuery>;
export type LoyaltyMembersQueryResult = Apollo.QueryResult<LoyaltyMembersQuery, LoyaltyMembersQueryVariables>;
export const GetPromotionsOnLoyaltyMembersDocument = gql`
    query getPromotionsOnLoyaltyMembers {
  getPromotions {
    id
    name
    status
  }
}
    `;

/**
 * __useGetPromotionsOnLoyaltyMembersQuery__
 *
 * To run a query within a React component, call `useGetPromotionsOnLoyaltyMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPromotionsOnLoyaltyMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPromotionsOnLoyaltyMembersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPromotionsOnLoyaltyMembersQuery(baseOptions?: Apollo.QueryHookOptions<GetPromotionsOnLoyaltyMembersQuery, GetPromotionsOnLoyaltyMembersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPromotionsOnLoyaltyMembersQuery, GetPromotionsOnLoyaltyMembersQueryVariables>(GetPromotionsOnLoyaltyMembersDocument, options);
      }
export function useGetPromotionsOnLoyaltyMembersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPromotionsOnLoyaltyMembersQuery, GetPromotionsOnLoyaltyMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPromotionsOnLoyaltyMembersQuery, GetPromotionsOnLoyaltyMembersQueryVariables>(GetPromotionsOnLoyaltyMembersDocument, options);
        }
export function useGetPromotionsOnLoyaltyMembersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPromotionsOnLoyaltyMembersQuery, GetPromotionsOnLoyaltyMembersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPromotionsOnLoyaltyMembersQuery, GetPromotionsOnLoyaltyMembersQueryVariables>(GetPromotionsOnLoyaltyMembersDocument, options);
        }
export type GetPromotionsOnLoyaltyMembersQueryHookResult = ReturnType<typeof useGetPromotionsOnLoyaltyMembersQuery>;
export type GetPromotionsOnLoyaltyMembersLazyQueryHookResult = ReturnType<typeof useGetPromotionsOnLoyaltyMembersLazyQuery>;
export type GetPromotionsOnLoyaltyMembersSuspenseQueryHookResult = ReturnType<typeof useGetPromotionsOnLoyaltyMembersSuspenseQuery>;
export type GetPromotionsOnLoyaltyMembersQueryResult = Apollo.QueryResult<GetPromotionsOnLoyaltyMembersQuery, GetPromotionsOnLoyaltyMembersQueryVariables>;
export const GetMenusDocument = gql`
    query getMenus {
  getMenus {
    id
    name
    description
    isEnabled
    status
    type
    createdAt
    promotionTags
  }
}
    `;

/**
 * __useGetMenusQuery__
 *
 * To run a query within a React component, call `useGetMenusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMenusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMenusQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMenusQuery(baseOptions?: Apollo.QueryHookOptions<GetMenusQuery, GetMenusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMenusQuery, GetMenusQueryVariables>(GetMenusDocument, options);
      }
export function useGetMenusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMenusQuery, GetMenusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMenusQuery, GetMenusQueryVariables>(GetMenusDocument, options);
        }
export function useGetMenusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMenusQuery, GetMenusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMenusQuery, GetMenusQueryVariables>(GetMenusDocument, options);
        }
export type GetMenusQueryHookResult = ReturnType<typeof useGetMenusQuery>;
export type GetMenusLazyQueryHookResult = ReturnType<typeof useGetMenusLazyQuery>;
export type GetMenusSuspenseQueryHookResult = ReturnType<typeof useGetMenusSuspenseQuery>;
export type GetMenusQueryResult = Apollo.QueryResult<GetMenusQuery, GetMenusQueryVariables>;
export const CreateMenuDocument = gql`
    mutation createMenu($menu: MenuInput!) {
  createMenu(menu: $menu)
}
    `;
export type CreateMenuMutationFn = Apollo.MutationFunction<CreateMenuMutation, CreateMenuMutationVariables>;

/**
 * __useCreateMenuMutation__
 *
 * To run a mutation, you first call `useCreateMenuMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMenuMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMenuMutation, { data, loading, error }] = useCreateMenuMutation({
 *   variables: {
 *      menu: // value for 'menu'
 *   },
 * });
 */
export function useCreateMenuMutation(baseOptions?: Apollo.MutationHookOptions<CreateMenuMutation, CreateMenuMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMenuMutation, CreateMenuMutationVariables>(CreateMenuDocument, options);
      }
export type CreateMenuMutationHookResult = ReturnType<typeof useCreateMenuMutation>;
export type CreateMenuMutationResult = Apollo.MutationResult<CreateMenuMutation>;
export type CreateMenuMutationOptions = Apollo.BaseMutationOptions<CreateMenuMutation, CreateMenuMutationVariables>;
export const UpdateMenuDocument = gql`
    mutation updateMenu($menu: MenuInput!, $menuId: String!) {
  updateMenu(menu: $menu, menuId: $menuId)
}
    `;
export type UpdateMenuMutationFn = Apollo.MutationFunction<UpdateMenuMutation, UpdateMenuMutationVariables>;

/**
 * __useUpdateMenuMutation__
 *
 * To run a mutation, you first call `useUpdateMenuMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMenuMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMenuMutation, { data, loading, error }] = useUpdateMenuMutation({
 *   variables: {
 *      menu: // value for 'menu'
 *      menuId: // value for 'menuId'
 *   },
 * });
 */
export function useUpdateMenuMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMenuMutation, UpdateMenuMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMenuMutation, UpdateMenuMutationVariables>(UpdateMenuDocument, options);
      }
export type UpdateMenuMutationHookResult = ReturnType<typeof useUpdateMenuMutation>;
export type UpdateMenuMutationResult = Apollo.MutationResult<UpdateMenuMutation>;
export type UpdateMenuMutationOptions = Apollo.BaseMutationOptions<UpdateMenuMutation, UpdateMenuMutationVariables>;
export const DeleteMenuDocument = gql`
    mutation deleteMenu($menuId: String!) {
  deleteMenu(menuId: $menuId)
}
    `;
export type DeleteMenuMutationFn = Apollo.MutationFunction<DeleteMenuMutation, DeleteMenuMutationVariables>;

/**
 * __useDeleteMenuMutation__
 *
 * To run a mutation, you first call `useDeleteMenuMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMenuMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMenuMutation, { data, loading, error }] = useDeleteMenuMutation({
 *   variables: {
 *      menuId: // value for 'menuId'
 *   },
 * });
 */
export function useDeleteMenuMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMenuMutation, DeleteMenuMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMenuMutation, DeleteMenuMutationVariables>(DeleteMenuDocument, options);
      }
export type DeleteMenuMutationHookResult = ReturnType<typeof useDeleteMenuMutation>;
export type DeleteMenuMutationResult = Apollo.MutationResult<DeleteMenuMutation>;
export type DeleteMenuMutationOptions = Apollo.BaseMutationOptions<DeleteMenuMutation, DeleteMenuMutationVariables>;
export const MenuGroupDocument = gql`
    query MenuGroup($menuId: String!) {
  getMenuGroups(menuId: $menuId) {
    id
    name
    allow_quantity
    force_max
    force_min
    options {
      id
      name
      shortName
      groupId
      default
      price
      sort
    }
    sort
  }
}
    `;

/**
 * __useMenuGroupQuery__
 *
 * To run a query within a React component, call `useMenuGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useMenuGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMenuGroupQuery({
 *   variables: {
 *      menuId: // value for 'menuId'
 *   },
 * });
 */
export function useMenuGroupQuery(baseOptions: Apollo.QueryHookOptions<MenuGroupQuery, MenuGroupQueryVariables> & ({ variables: MenuGroupQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MenuGroupQuery, MenuGroupQueryVariables>(MenuGroupDocument, options);
      }
export function useMenuGroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MenuGroupQuery, MenuGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MenuGroupQuery, MenuGroupQueryVariables>(MenuGroupDocument, options);
        }
export function useMenuGroupSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MenuGroupQuery, MenuGroupQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MenuGroupQuery, MenuGroupQueryVariables>(MenuGroupDocument, options);
        }
export type MenuGroupQueryHookResult = ReturnType<typeof useMenuGroupQuery>;
export type MenuGroupLazyQueryHookResult = ReturnType<typeof useMenuGroupLazyQuery>;
export type MenuGroupSuspenseQueryHookResult = ReturnType<typeof useMenuGroupSuspenseQuery>;
export type MenuGroupQueryResult = Apollo.QueryResult<MenuGroupQuery, MenuGroupQueryVariables>;
export const CreateMenuGroupDocument = gql`
    mutation createMenuGroup($group: MenuGroupInput!) {
  createMenuGroup(group: $group)
}
    `;
export type CreateMenuGroupMutationFn = Apollo.MutationFunction<CreateMenuGroupMutation, CreateMenuGroupMutationVariables>;

/**
 * __useCreateMenuGroupMutation__
 *
 * To run a mutation, you first call `useCreateMenuGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMenuGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMenuGroupMutation, { data, loading, error }] = useCreateMenuGroupMutation({
 *   variables: {
 *      group: // value for 'group'
 *   },
 * });
 */
export function useCreateMenuGroupMutation(baseOptions?: Apollo.MutationHookOptions<CreateMenuGroupMutation, CreateMenuGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMenuGroupMutation, CreateMenuGroupMutationVariables>(CreateMenuGroupDocument, options);
      }
export type CreateMenuGroupMutationHookResult = ReturnType<typeof useCreateMenuGroupMutation>;
export type CreateMenuGroupMutationResult = Apollo.MutationResult<CreateMenuGroupMutation>;
export type CreateMenuGroupMutationOptions = Apollo.BaseMutationOptions<CreateMenuGroupMutation, CreateMenuGroupMutationVariables>;
export const DeleteMenuGroupDocument = gql`
    mutation deleteMenuGroup($menuId: String!, $groupId: String!) {
  deleteMenuGroup(menuId: $menuId, groupId: $groupId)
}
    `;
export type DeleteMenuGroupMutationFn = Apollo.MutationFunction<DeleteMenuGroupMutation, DeleteMenuGroupMutationVariables>;

/**
 * __useDeleteMenuGroupMutation__
 *
 * To run a mutation, you first call `useDeleteMenuGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMenuGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMenuGroupMutation, { data, loading, error }] = useDeleteMenuGroupMutation({
 *   variables: {
 *      menuId: // value for 'menuId'
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useDeleteMenuGroupMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMenuGroupMutation, DeleteMenuGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMenuGroupMutation, DeleteMenuGroupMutationVariables>(DeleteMenuGroupDocument, options);
      }
export type DeleteMenuGroupMutationHookResult = ReturnType<typeof useDeleteMenuGroupMutation>;
export type DeleteMenuGroupMutationResult = Apollo.MutationResult<DeleteMenuGroupMutation>;
export type DeleteMenuGroupMutationOptions = Apollo.BaseMutationOptions<DeleteMenuGroupMutation, DeleteMenuGroupMutationVariables>;
export const GetMenuDocument = gql`
    query getMenu($menuId: String!) {
  getMenu(menuId: $menuId) {
    name
    description
    isEnabled
    status
    createdAt
    type
    promotionTags
  }
}
    `;

/**
 * __useGetMenuQuery__
 *
 * To run a query within a React component, call `useGetMenuQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMenuQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMenuQuery({
 *   variables: {
 *      menuId: // value for 'menuId'
 *   },
 * });
 */
export function useGetMenuQuery(baseOptions: Apollo.QueryHookOptions<GetMenuQuery, GetMenuQueryVariables> & ({ variables: GetMenuQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMenuQuery, GetMenuQueryVariables>(GetMenuDocument, options);
      }
export function useGetMenuLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMenuQuery, GetMenuQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMenuQuery, GetMenuQueryVariables>(GetMenuDocument, options);
        }
export function useGetMenuSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMenuQuery, GetMenuQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMenuQuery, GetMenuQueryVariables>(GetMenuDocument, options);
        }
export type GetMenuQueryHookResult = ReturnType<typeof useGetMenuQuery>;
export type GetMenuLazyQueryHookResult = ReturnType<typeof useGetMenuLazyQuery>;
export type GetMenuSuspenseQueryHookResult = ReturnType<typeof useGetMenuSuspenseQuery>;
export type GetMenuQueryResult = Apollo.QueryResult<GetMenuQuery, GetMenuQueryVariables>;
export const GetMenuCategoriesDocument = gql`
    query getMenuCategories($menuId: String!) {
  getMenuCategories(menuId: $menuId) {
    name
    id
    altName
    active_begin
    description
    active_end
    hidden_until
    active
    menuId
    cookingPriority
    sort
    promotionTags
    items {
      id
      tags
      price
      active
      description
      menuId
      image
      hidden_until
      sort
      name
      active_end
      displayNumber
      altName
      ingredients
      active_begin
      cookingCategory
      categoryId
      promotionTags
      sizes {
        name
        price
        id
        default
        groups {
          id
          name
          allow_quantity
          force_max
          force_min
          menuId
          options {
            id
            name
            shortName
            default
            groupId
            price
            sort
          }
        }
      }
      groups {
        id
        sort
      }
    }
  }
}
    `;

/**
 * __useGetMenuCategoriesQuery__
 *
 * To run a query within a React component, call `useGetMenuCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMenuCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMenuCategoriesQuery({
 *   variables: {
 *      menuId: // value for 'menuId'
 *   },
 * });
 */
export function useGetMenuCategoriesQuery(baseOptions: Apollo.QueryHookOptions<GetMenuCategoriesQuery, GetMenuCategoriesQueryVariables> & ({ variables: GetMenuCategoriesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMenuCategoriesQuery, GetMenuCategoriesQueryVariables>(GetMenuCategoriesDocument, options);
      }
export function useGetMenuCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMenuCategoriesQuery, GetMenuCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMenuCategoriesQuery, GetMenuCategoriesQueryVariables>(GetMenuCategoriesDocument, options);
        }
export function useGetMenuCategoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMenuCategoriesQuery, GetMenuCategoriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMenuCategoriesQuery, GetMenuCategoriesQueryVariables>(GetMenuCategoriesDocument, options);
        }
export type GetMenuCategoriesQueryHookResult = ReturnType<typeof useGetMenuCategoriesQuery>;
export type GetMenuCategoriesLazyQueryHookResult = ReturnType<typeof useGetMenuCategoriesLazyQuery>;
export type GetMenuCategoriesSuspenseQueryHookResult = ReturnType<typeof useGetMenuCategoriesSuspenseQuery>;
export type GetMenuCategoriesQueryResult = Apollo.QueryResult<GetMenuCategoriesQuery, GetMenuCategoriesQueryVariables>;
export const CreateMenuCategoryDocument = gql`
    mutation createMenuCategory($category: MenuCategoryInput) {
  createMenuCategory(category: $category)
}
    `;
export type CreateMenuCategoryMutationFn = Apollo.MutationFunction<CreateMenuCategoryMutation, CreateMenuCategoryMutationVariables>;

/**
 * __useCreateMenuCategoryMutation__
 *
 * To run a mutation, you first call `useCreateMenuCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMenuCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMenuCategoryMutation, { data, loading, error }] = useCreateMenuCategoryMutation({
 *   variables: {
 *      category: // value for 'category'
 *   },
 * });
 */
export function useCreateMenuCategoryMutation(baseOptions?: Apollo.MutationHookOptions<CreateMenuCategoryMutation, CreateMenuCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMenuCategoryMutation, CreateMenuCategoryMutationVariables>(CreateMenuCategoryDocument, options);
      }
export type CreateMenuCategoryMutationHookResult = ReturnType<typeof useCreateMenuCategoryMutation>;
export type CreateMenuCategoryMutationResult = Apollo.MutationResult<CreateMenuCategoryMutation>;
export type CreateMenuCategoryMutationOptions = Apollo.BaseMutationOptions<CreateMenuCategoryMutation, CreateMenuCategoryMutationVariables>;
export const UpdateMenuCategoryDocument = gql`
    mutation updateMenuCategory($menuId: String!, $categroyId: String!, $category: MenuCategoryInput!) {
  updateMenuCategory(
    menuId: $menuId
    categroyId: $categroyId
    category: $category
  )
}
    `;
export type UpdateMenuCategoryMutationFn = Apollo.MutationFunction<UpdateMenuCategoryMutation, UpdateMenuCategoryMutationVariables>;

/**
 * __useUpdateMenuCategoryMutation__
 *
 * To run a mutation, you first call `useUpdateMenuCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMenuCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMenuCategoryMutation, { data, loading, error }] = useUpdateMenuCategoryMutation({
 *   variables: {
 *      menuId: // value for 'menuId'
 *      categroyId: // value for 'categroyId'
 *      category: // value for 'category'
 *   },
 * });
 */
export function useUpdateMenuCategoryMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMenuCategoryMutation, UpdateMenuCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMenuCategoryMutation, UpdateMenuCategoryMutationVariables>(UpdateMenuCategoryDocument, options);
      }
export type UpdateMenuCategoryMutationHookResult = ReturnType<typeof useUpdateMenuCategoryMutation>;
export type UpdateMenuCategoryMutationResult = Apollo.MutationResult<UpdateMenuCategoryMutation>;
export type UpdateMenuCategoryMutationOptions = Apollo.BaseMutationOptions<UpdateMenuCategoryMutation, UpdateMenuCategoryMutationVariables>;
export const DeleteMenuCategoryDocument = gql`
    mutation deleteMenuCategory($menuId: String!, $categroyId: String!) {
  deleteMenuCategory(menuId: $menuId, categroyId: $categroyId)
}
    `;
export type DeleteMenuCategoryMutationFn = Apollo.MutationFunction<DeleteMenuCategoryMutation, DeleteMenuCategoryMutationVariables>;

/**
 * __useDeleteMenuCategoryMutation__
 *
 * To run a mutation, you first call `useDeleteMenuCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMenuCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMenuCategoryMutation, { data, loading, error }] = useDeleteMenuCategoryMutation({
 *   variables: {
 *      menuId: // value for 'menuId'
 *      categroyId: // value for 'categroyId'
 *   },
 * });
 */
export function useDeleteMenuCategoryMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMenuCategoryMutation, DeleteMenuCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMenuCategoryMutation, DeleteMenuCategoryMutationVariables>(DeleteMenuCategoryDocument, options);
      }
export type DeleteMenuCategoryMutationHookResult = ReturnType<typeof useDeleteMenuCategoryMutation>;
export type DeleteMenuCategoryMutationResult = Apollo.MutationResult<DeleteMenuCategoryMutation>;
export type DeleteMenuCategoryMutationOptions = Apollo.BaseMutationOptions<DeleteMenuCategoryMutation, DeleteMenuCategoryMutationVariables>;
export const CreateMenuItemDocument = gql`
    mutation createMenuItem($item: MenuItemInput) {
  createMenuItem(item: $item)
}
    `;
export type CreateMenuItemMutationFn = Apollo.MutationFunction<CreateMenuItemMutation, CreateMenuItemMutationVariables>;

/**
 * __useCreateMenuItemMutation__
 *
 * To run a mutation, you first call `useCreateMenuItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMenuItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMenuItemMutation, { data, loading, error }] = useCreateMenuItemMutation({
 *   variables: {
 *      item: // value for 'item'
 *   },
 * });
 */
export function useCreateMenuItemMutation(baseOptions?: Apollo.MutationHookOptions<CreateMenuItemMutation, CreateMenuItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMenuItemMutation, CreateMenuItemMutationVariables>(CreateMenuItemDocument, options);
      }
export type CreateMenuItemMutationHookResult = ReturnType<typeof useCreateMenuItemMutation>;
export type CreateMenuItemMutationResult = Apollo.MutationResult<CreateMenuItemMutation>;
export type CreateMenuItemMutationOptions = Apollo.BaseMutationOptions<CreateMenuItemMutation, CreateMenuItemMutationVariables>;
export const CreateMenuGroupOptionDocument = gql`
    mutation createMenuGroupOption($option: MenuOptionInput!) {
  createMenuGroupOption(option: $option)
}
    `;
export type CreateMenuGroupOptionMutationFn = Apollo.MutationFunction<CreateMenuGroupOptionMutation, CreateMenuGroupOptionMutationVariables>;

/**
 * __useCreateMenuGroupOptionMutation__
 *
 * To run a mutation, you first call `useCreateMenuGroupOptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMenuGroupOptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMenuGroupOptionMutation, { data, loading, error }] = useCreateMenuGroupOptionMutation({
 *   variables: {
 *      option: // value for 'option'
 *   },
 * });
 */
export function useCreateMenuGroupOptionMutation(baseOptions?: Apollo.MutationHookOptions<CreateMenuGroupOptionMutation, CreateMenuGroupOptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMenuGroupOptionMutation, CreateMenuGroupOptionMutationVariables>(CreateMenuGroupOptionDocument, options);
      }
export type CreateMenuGroupOptionMutationHookResult = ReturnType<typeof useCreateMenuGroupOptionMutation>;
export type CreateMenuGroupOptionMutationResult = Apollo.MutationResult<CreateMenuGroupOptionMutation>;
export type CreateMenuGroupOptionMutationOptions = Apollo.BaseMutationOptions<CreateMenuGroupOptionMutation, CreateMenuGroupOptionMutationVariables>;
export const UpdateMenuGroupOptionsDocument = gql`
    mutation updateMenuGroupOptions($menuId: String!, $groupId: String!, $options: [MenuOptionInput]!) {
  updateMenuGroupOptions(menuId: $menuId, groupId: $groupId, options: $options)
}
    `;
export type UpdateMenuGroupOptionsMutationFn = Apollo.MutationFunction<UpdateMenuGroupOptionsMutation, UpdateMenuGroupOptionsMutationVariables>;

/**
 * __useUpdateMenuGroupOptionsMutation__
 *
 * To run a mutation, you first call `useUpdateMenuGroupOptionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMenuGroupOptionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMenuGroupOptionsMutation, { data, loading, error }] = useUpdateMenuGroupOptionsMutation({
 *   variables: {
 *      menuId: // value for 'menuId'
 *      groupId: // value for 'groupId'
 *      options: // value for 'options'
 *   },
 * });
 */
export function useUpdateMenuGroupOptionsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMenuGroupOptionsMutation, UpdateMenuGroupOptionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMenuGroupOptionsMutation, UpdateMenuGroupOptionsMutationVariables>(UpdateMenuGroupOptionsDocument, options);
      }
export type UpdateMenuGroupOptionsMutationHookResult = ReturnType<typeof useUpdateMenuGroupOptionsMutation>;
export type UpdateMenuGroupOptionsMutationResult = Apollo.MutationResult<UpdateMenuGroupOptionsMutation>;
export type UpdateMenuGroupOptionsMutationOptions = Apollo.BaseMutationOptions<UpdateMenuGroupOptionsMutation, UpdateMenuGroupOptionsMutationVariables>;
export const UpdateMenuGroupDocument = gql`
    mutation updateMenuGroup($menuId: String!, $groupId: String!, $group: MenuGroupInput!) {
  updateMenuGroup(menuId: $menuId, groupId: $groupId, group: $group)
}
    `;
export type UpdateMenuGroupMutationFn = Apollo.MutationFunction<UpdateMenuGroupMutation, UpdateMenuGroupMutationVariables>;

/**
 * __useUpdateMenuGroupMutation__
 *
 * To run a mutation, you first call `useUpdateMenuGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMenuGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMenuGroupMutation, { data, loading, error }] = useUpdateMenuGroupMutation({
 *   variables: {
 *      menuId: // value for 'menuId'
 *      groupId: // value for 'groupId'
 *      group: // value for 'group'
 *   },
 * });
 */
export function useUpdateMenuGroupMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMenuGroupMutation, UpdateMenuGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMenuGroupMutation, UpdateMenuGroupMutationVariables>(UpdateMenuGroupDocument, options);
      }
export type UpdateMenuGroupMutationHookResult = ReturnType<typeof useUpdateMenuGroupMutation>;
export type UpdateMenuGroupMutationResult = Apollo.MutationResult<UpdateMenuGroupMutation>;
export type UpdateMenuGroupMutationOptions = Apollo.BaseMutationOptions<UpdateMenuGroupMutation, UpdateMenuGroupMutationVariables>;
export const UpdateMenuItemGroupsDocument = gql`
    mutation updateMenuItemGroups($menuId: String!, $categroyId: String!, $menuItemId: String!, $groups: [MenuItemGroupsInput]) {
  updateMenuItemGroups(
    menuId: $menuId
    categroyId: $categroyId
    menuItemId: $menuItemId
    groups: $groups
  )
}
    `;
export type UpdateMenuItemGroupsMutationFn = Apollo.MutationFunction<UpdateMenuItemGroupsMutation, UpdateMenuItemGroupsMutationVariables>;

/**
 * __useUpdateMenuItemGroupsMutation__
 *
 * To run a mutation, you first call `useUpdateMenuItemGroupsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMenuItemGroupsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMenuItemGroupsMutation, { data, loading, error }] = useUpdateMenuItemGroupsMutation({
 *   variables: {
 *      menuId: // value for 'menuId'
 *      categroyId: // value for 'categroyId'
 *      menuItemId: // value for 'menuItemId'
 *      groups: // value for 'groups'
 *   },
 * });
 */
export function useUpdateMenuItemGroupsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMenuItemGroupsMutation, UpdateMenuItemGroupsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMenuItemGroupsMutation, UpdateMenuItemGroupsMutationVariables>(UpdateMenuItemGroupsDocument, options);
      }
export type UpdateMenuItemGroupsMutationHookResult = ReturnType<typeof useUpdateMenuItemGroupsMutation>;
export type UpdateMenuItemGroupsMutationResult = Apollo.MutationResult<UpdateMenuItemGroupsMutation>;
export type UpdateMenuItemGroupsMutationOptions = Apollo.BaseMutationOptions<UpdateMenuItemGroupsMutation, UpdateMenuItemGroupsMutationVariables>;
export const UpdateMenuItemDocument = gql`
    mutation updateMenuItem($menuId: String!, $categroyId: String!, $menuItem: MenuItemInput!) {
  updateMenuItem(menuId: $menuId, categroyId: $categroyId, menuItem: $menuItem)
}
    `;
export type UpdateMenuItemMutationFn = Apollo.MutationFunction<UpdateMenuItemMutation, UpdateMenuItemMutationVariables>;

/**
 * __useUpdateMenuItemMutation__
 *
 * To run a mutation, you first call `useUpdateMenuItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMenuItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMenuItemMutation, { data, loading, error }] = useUpdateMenuItemMutation({
 *   variables: {
 *      menuId: // value for 'menuId'
 *      categroyId: // value for 'categroyId'
 *      menuItem: // value for 'menuItem'
 *   },
 * });
 */
export function useUpdateMenuItemMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMenuItemMutation, UpdateMenuItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMenuItemMutation, UpdateMenuItemMutationVariables>(UpdateMenuItemDocument, options);
      }
export type UpdateMenuItemMutationHookResult = ReturnType<typeof useUpdateMenuItemMutation>;
export type UpdateMenuItemMutationResult = Apollo.MutationResult<UpdateMenuItemMutation>;
export type UpdateMenuItemMutationOptions = Apollo.BaseMutationOptions<UpdateMenuItemMutation, UpdateMenuItemMutationVariables>;
export const UpdateMenuItemsDocument = gql`
    mutation updateMenuItems($menuId: String!, $categroyId: String!, $items: [MenuItemInput]!) {
  updateMenuItems(menuId: $menuId, categroyId: $categroyId, items: $items)
}
    `;
export type UpdateMenuItemsMutationFn = Apollo.MutationFunction<UpdateMenuItemsMutation, UpdateMenuItemsMutationVariables>;

/**
 * __useUpdateMenuItemsMutation__
 *
 * To run a mutation, you first call `useUpdateMenuItemsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMenuItemsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMenuItemsMutation, { data, loading, error }] = useUpdateMenuItemsMutation({
 *   variables: {
 *      menuId: // value for 'menuId'
 *      categroyId: // value for 'categroyId'
 *      items: // value for 'items'
 *   },
 * });
 */
export function useUpdateMenuItemsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMenuItemsMutation, UpdateMenuItemsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMenuItemsMutation, UpdateMenuItemsMutationVariables>(UpdateMenuItemsDocument, options);
      }
export type UpdateMenuItemsMutationHookResult = ReturnType<typeof useUpdateMenuItemsMutation>;
export type UpdateMenuItemsMutationResult = Apollo.MutationResult<UpdateMenuItemsMutation>;
export type UpdateMenuItemsMutationOptions = Apollo.BaseMutationOptions<UpdateMenuItemsMutation, UpdateMenuItemsMutationVariables>;
export const PublishMenuDocument = gql`
    mutation publishMenu($menuId: String!) {
  publishMenu(menuId: $menuId)
}
    `;
export type PublishMenuMutationFn = Apollo.MutationFunction<PublishMenuMutation, PublishMenuMutationVariables>;

/**
 * __usePublishMenuMutation__
 *
 * To run a mutation, you first call `usePublishMenuMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishMenuMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishMenuMutation, { data, loading, error }] = usePublishMenuMutation({
 *   variables: {
 *      menuId: // value for 'menuId'
 *   },
 * });
 */
export function usePublishMenuMutation(baseOptions?: Apollo.MutationHookOptions<PublishMenuMutation, PublishMenuMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PublishMenuMutation, PublishMenuMutationVariables>(PublishMenuDocument, options);
      }
export type PublishMenuMutationHookResult = ReturnType<typeof usePublishMenuMutation>;
export type PublishMenuMutationResult = Apollo.MutationResult<PublishMenuMutation>;
export type PublishMenuMutationOptions = Apollo.BaseMutationOptions<PublishMenuMutation, PublishMenuMutationVariables>;
export const DeleteMenuItemImageDocument = gql`
    mutation deleteMenuItemImage($menuId: String!, $categroyId: String!, $menuItemId: String!) {
  deleteMenuItemImage(
    menuId: $menuId
    categroyId: $categroyId
    menuItemId: $menuItemId
  )
}
    `;
export type DeleteMenuItemImageMutationFn = Apollo.MutationFunction<DeleteMenuItemImageMutation, DeleteMenuItemImageMutationVariables>;

/**
 * __useDeleteMenuItemImageMutation__
 *
 * To run a mutation, you first call `useDeleteMenuItemImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMenuItemImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMenuItemImageMutation, { data, loading, error }] = useDeleteMenuItemImageMutation({
 *   variables: {
 *      menuId: // value for 'menuId'
 *      categroyId: // value for 'categroyId'
 *      menuItemId: // value for 'menuItemId'
 *   },
 * });
 */
export function useDeleteMenuItemImageMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMenuItemImageMutation, DeleteMenuItemImageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMenuItemImageMutation, DeleteMenuItemImageMutationVariables>(DeleteMenuItemImageDocument, options);
      }
export type DeleteMenuItemImageMutationHookResult = ReturnType<typeof useDeleteMenuItemImageMutation>;
export type DeleteMenuItemImageMutationResult = Apollo.MutationResult<DeleteMenuItemImageMutation>;
export type DeleteMenuItemImageMutationOptions = Apollo.BaseMutationOptions<DeleteMenuItemImageMutation, DeleteMenuItemImageMutationVariables>;
export const MoveMenuItemImageDocument = gql`
    mutation moveMenuItemImage($menuItemId: ID!, $fromCategoryId: ID!, $toCategoryId: ID!, $menuId: ID!) {
  moveMenuItemImage(
    menuItemId: $menuItemId
    fromCategoryId: $fromCategoryId
    toCategoryId: $toCategoryId
    menuId: $menuId
  )
}
    `;
export type MoveMenuItemImageMutationFn = Apollo.MutationFunction<MoveMenuItemImageMutation, MoveMenuItemImageMutationVariables>;

/**
 * __useMoveMenuItemImageMutation__
 *
 * To run a mutation, you first call `useMoveMenuItemImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveMenuItemImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveMenuItemImageMutation, { data, loading, error }] = useMoveMenuItemImageMutation({
 *   variables: {
 *      menuItemId: // value for 'menuItemId'
 *      fromCategoryId: // value for 'fromCategoryId'
 *      toCategoryId: // value for 'toCategoryId'
 *      menuId: // value for 'menuId'
 *   },
 * });
 */
export function useMoveMenuItemImageMutation(baseOptions?: Apollo.MutationHookOptions<MoveMenuItemImageMutation, MoveMenuItemImageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MoveMenuItemImageMutation, MoveMenuItemImageMutationVariables>(MoveMenuItemImageDocument, options);
      }
export type MoveMenuItemImageMutationHookResult = ReturnType<typeof useMoveMenuItemImageMutation>;
export type MoveMenuItemImageMutationResult = Apollo.MutationResult<MoveMenuItemImageMutation>;
export type MoveMenuItemImageMutationOptions = Apollo.BaseMutationOptions<MoveMenuItemImageMutation, MoveMenuItemImageMutationVariables>;
export const GetAllMerchantsDocument = gql`
    query getAllMerchants {
  getAllMerchants {
    merchantId
    name
    altName
    address
    phoneNumber
    abn
    suburb
    city
    latitude
    longitude
    logo
    logoImages
    createdAt
    merchantAdminEmail
    openTime {
      closeDates
      openHours {
        openStart
        openEnd
        weekDays
      }
    }
    tags
    type
    restaurantType
    restaurantCategory
    settings {
      isStripePaymentEnabled
      areSoldOutItemsDisplayedInApp
      stripeAccountId
      maxPromotions
      appServices
    }
    timezone
    surchargeSettings {
      id
      name
      surchargeDescription
      weekdays
      isEnabled
      isPercentage
      amount
      publicHolidayDays
    }
    serviceMonthlyPrice
    orderbuddyMerchantId
    bookingMerchantId
    merchantStatus
    addressObject {
      city
      country
      countryCode
      line1
      line2
      line3
      location {
        longitude
        latitude
      }
      postalCode
      stateOrProvince
      stateOrProvinceCode
    }
  }
}
    `;

/**
 * __useGetAllMerchantsQuery__
 *
 * To run a query within a React component, call `useGetAllMerchantsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllMerchantsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllMerchantsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllMerchantsQuery(baseOptions?: Apollo.QueryHookOptions<GetAllMerchantsQuery, GetAllMerchantsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllMerchantsQuery, GetAllMerchantsQueryVariables>(GetAllMerchantsDocument, options);
      }
export function useGetAllMerchantsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllMerchantsQuery, GetAllMerchantsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllMerchantsQuery, GetAllMerchantsQueryVariables>(GetAllMerchantsDocument, options);
        }
export function useGetAllMerchantsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllMerchantsQuery, GetAllMerchantsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllMerchantsQuery, GetAllMerchantsQueryVariables>(GetAllMerchantsDocument, options);
        }
export type GetAllMerchantsQueryHookResult = ReturnType<typeof useGetAllMerchantsQuery>;
export type GetAllMerchantsLazyQueryHookResult = ReturnType<typeof useGetAllMerchantsLazyQuery>;
export type GetAllMerchantsSuspenseQueryHookResult = ReturnType<typeof useGetAllMerchantsSuspenseQuery>;
export type GetAllMerchantsQueryResult = Apollo.QueryResult<GetAllMerchantsQuery, GetAllMerchantsQueryVariables>;
export const MerchantDocument = gql`
    query merchant($merchantId: String!) {
  getMerchant(merchantId: $merchantId) {
    merchantId
    name
    altName
    address
    phoneNumber
    abn
    suburb
    city
    latitude
    longitude
    logo
    logoImages
    createdAt
    merchantAdminEmail
    contactEmail
    openTime {
      closeDates
      openHours {
        openStart
        openEnd
        weekDays
      }
    }
    tags
    type
    restaurantType
    restaurantCategory
    settings {
      isStripePaymentEnabled
      areSoldOutItemsDisplayedInApp
      stripeAccountId
      maxPromotions
      appServices
    }
    timezone
    surchargeSettings {
      id
      name
      surchargeDescription
      weekdays
      isEnabled
      isPercentage
      amount
      publicHolidayDays
    }
    serviceMonthlyPrice
    orderbuddyMerchantId
    bookingMerchantId
    merchantStatus
    addressObject {
      city
      country
      countryCode
      line1
      line2
      line3
      location {
        longitude
        latitude
      }
      postalCode
      stateOrProvince
      stateOrProvinceCode
    }
  }
}
    `;

/**
 * __useMerchantQuery__
 *
 * To run a query within a React component, call `useMerchantQuery` and pass it any options that fit your needs.
 * When your component renders, `useMerchantQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMerchantQuery({
 *   variables: {
 *      merchantId: // value for 'merchantId'
 *   },
 * });
 */
export function useMerchantQuery(baseOptions: Apollo.QueryHookOptions<MerchantQuery, MerchantQueryVariables> & ({ variables: MerchantQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MerchantQuery, MerchantQueryVariables>(MerchantDocument, options);
      }
export function useMerchantLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MerchantQuery, MerchantQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MerchantQuery, MerchantQueryVariables>(MerchantDocument, options);
        }
export function useMerchantSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MerchantQuery, MerchantQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MerchantQuery, MerchantQueryVariables>(MerchantDocument, options);
        }
export type MerchantQueryHookResult = ReturnType<typeof useMerchantQuery>;
export type MerchantLazyQueryHookResult = ReturnType<typeof useMerchantLazyQuery>;
export type MerchantSuspenseQueryHookResult = ReturnType<typeof useMerchantSuspenseQuery>;
export type MerchantQueryResult = Apollo.QueryResult<MerchantQuery, MerchantQueryVariables>;
export const PosMerchantDocument = gql`
    query posMerchant($posRestaurantId: String!) {
  posMerchant(posRestaurantId: $posRestaurantId) {
    merchantId
    name
    altName
    address
    abn
    latitude
    longitude
    logo
    logoImages
    suburb
    city
    phoneNumber
    merchantAdminEmail
    createdAt
    restaurantType
    restaurantCategory
    tags
    timezone
    onlineStatus
    onlineOrderCount
    settings {
      isStripePaymentEnabled
      stripeAccountId
      maxPromotions
    }
    serviceMonthlyPrice
    orderbuddyMerchantId
    bookingMerchantId
    surchargeSettings {
      id
      name
      amount
      isEnabled
      isPercentage
      publicHolidayDays
      weekdays
      surchargeDescription
    }
    addressObject {
      city
      country
      countryCode
      line1
      line2
      line3
      location {
        longitude
        latitude
      }
      postalCode
      stateOrProvince
      stateOrProvinceCode
    }
  }
}
    `;

/**
 * __usePosMerchantQuery__
 *
 * To run a query within a React component, call `usePosMerchantQuery` and pass it any options that fit your needs.
 * When your component renders, `usePosMerchantQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePosMerchantQuery({
 *   variables: {
 *      posRestaurantId: // value for 'posRestaurantId'
 *   },
 * });
 */
export function usePosMerchantQuery(baseOptions: Apollo.QueryHookOptions<PosMerchantQuery, PosMerchantQueryVariables> & ({ variables: PosMerchantQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PosMerchantQuery, PosMerchantQueryVariables>(PosMerchantDocument, options);
      }
export function usePosMerchantLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PosMerchantQuery, PosMerchantQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PosMerchantQuery, PosMerchantQueryVariables>(PosMerchantDocument, options);
        }
export function usePosMerchantSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PosMerchantQuery, PosMerchantQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PosMerchantQuery, PosMerchantQueryVariables>(PosMerchantDocument, options);
        }
export type PosMerchantQueryHookResult = ReturnType<typeof usePosMerchantQuery>;
export type PosMerchantLazyQueryHookResult = ReturnType<typeof usePosMerchantLazyQuery>;
export type PosMerchantSuspenseQueryHookResult = ReturnType<typeof usePosMerchantSuspenseQuery>;
export type PosMerchantQueryResult = Apollo.QueryResult<PosMerchantQuery, PosMerchantQueryVariables>;
export const CreateMerchantDocument = gql`
    mutation createMerchant($merchant: MerchantInput!) {
  createMerchant(merchant: $merchant)
}
    `;
export type CreateMerchantMutationFn = Apollo.MutationFunction<CreateMerchantMutation, CreateMerchantMutationVariables>;

/**
 * __useCreateMerchantMutation__
 *
 * To run a mutation, you first call `useCreateMerchantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMerchantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMerchantMutation, { data, loading, error }] = useCreateMerchantMutation({
 *   variables: {
 *      merchant: // value for 'merchant'
 *   },
 * });
 */
export function useCreateMerchantMutation(baseOptions?: Apollo.MutationHookOptions<CreateMerchantMutation, CreateMerchantMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMerchantMutation, CreateMerchantMutationVariables>(CreateMerchantDocument, options);
      }
export type CreateMerchantMutationHookResult = ReturnType<typeof useCreateMerchantMutation>;
export type CreateMerchantMutationResult = Apollo.MutationResult<CreateMerchantMutation>;
export type CreateMerchantMutationOptions = Apollo.BaseMutationOptions<CreateMerchantMutation, CreateMerchantMutationVariables>;
export const AddUserToMerchantDocument = gql`
    mutation addUserToMerchant($role: UserRole!, $email: String!, $merchantId: String!) {
  addUserToMerchant(role: $role, email: $email, merchantId: $merchantId)
}
    `;
export type AddUserToMerchantMutationFn = Apollo.MutationFunction<AddUserToMerchantMutation, AddUserToMerchantMutationVariables>;

/**
 * __useAddUserToMerchantMutation__
 *
 * To run a mutation, you first call `useAddUserToMerchantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUserToMerchantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUserToMerchantMutation, { data, loading, error }] = useAddUserToMerchantMutation({
 *   variables: {
 *      role: // value for 'role'
 *      email: // value for 'email'
 *      merchantId: // value for 'merchantId'
 *   },
 * });
 */
export function useAddUserToMerchantMutation(baseOptions?: Apollo.MutationHookOptions<AddUserToMerchantMutation, AddUserToMerchantMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddUserToMerchantMutation, AddUserToMerchantMutationVariables>(AddUserToMerchantDocument, options);
      }
export type AddUserToMerchantMutationHookResult = ReturnType<typeof useAddUserToMerchantMutation>;
export type AddUserToMerchantMutationResult = Apollo.MutationResult<AddUserToMerchantMutation>;
export type AddUserToMerchantMutationOptions = Apollo.BaseMutationOptions<AddUserToMerchantMutation, AddUserToMerchantMutationVariables>;
export const UpdateMerchantDocument = gql`
    mutation updateMerchant($merchant: MerchantInput!) {
  updateMerchant(merchant: $merchant)
}
    `;
export type UpdateMerchantMutationFn = Apollo.MutationFunction<UpdateMerchantMutation, UpdateMerchantMutationVariables>;

/**
 * __useUpdateMerchantMutation__
 *
 * To run a mutation, you first call `useUpdateMerchantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMerchantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMerchantMutation, { data, loading, error }] = useUpdateMerchantMutation({
 *   variables: {
 *      merchant: // value for 'merchant'
 *   },
 * });
 */
export function useUpdateMerchantMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMerchantMutation, UpdateMerchantMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMerchantMutation, UpdateMerchantMutationVariables>(UpdateMerchantDocument, options);
      }
export type UpdateMerchantMutationHookResult = ReturnType<typeof useUpdateMerchantMutation>;
export type UpdateMerchantMutationResult = Apollo.MutationResult<UpdateMerchantMutation>;
export type UpdateMerchantMutationOptions = Apollo.BaseMutationOptions<UpdateMerchantMutation, UpdateMerchantMutationVariables>;
export const UpdateMerchantOpenTimeDocument = gql`
    mutation updateMerchantOpenTime($openTime: OpenTimeInput!, $merchantId: String!) {
  updateMerchantOpenTime(openTime: $openTime, merchantId: $merchantId)
}
    `;
export type UpdateMerchantOpenTimeMutationFn = Apollo.MutationFunction<UpdateMerchantOpenTimeMutation, UpdateMerchantOpenTimeMutationVariables>;

/**
 * __useUpdateMerchantOpenTimeMutation__
 *
 * To run a mutation, you first call `useUpdateMerchantOpenTimeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMerchantOpenTimeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMerchantOpenTimeMutation, { data, loading, error }] = useUpdateMerchantOpenTimeMutation({
 *   variables: {
 *      openTime: // value for 'openTime'
 *      merchantId: // value for 'merchantId'
 *   },
 * });
 */
export function useUpdateMerchantOpenTimeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMerchantOpenTimeMutation, UpdateMerchantOpenTimeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMerchantOpenTimeMutation, UpdateMerchantOpenTimeMutationVariables>(UpdateMerchantOpenTimeDocument, options);
      }
export type UpdateMerchantOpenTimeMutationHookResult = ReturnType<typeof useUpdateMerchantOpenTimeMutation>;
export type UpdateMerchantOpenTimeMutationResult = Apollo.MutationResult<UpdateMerchantOpenTimeMutation>;
export type UpdateMerchantOpenTimeMutationOptions = Apollo.BaseMutationOptions<UpdateMerchantOpenTimeMutation, UpdateMerchantOpenTimeMutationVariables>;
export const SwitchMerchantDocument = gql`
    mutation switchMerchant($merchantId: String!) {
  switchMerchant(merchantId: $merchantId)
}
    `;
export type SwitchMerchantMutationFn = Apollo.MutationFunction<SwitchMerchantMutation, SwitchMerchantMutationVariables>;

/**
 * __useSwitchMerchantMutation__
 *
 * To run a mutation, you first call `useSwitchMerchantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSwitchMerchantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [switchMerchantMutation, { data, loading, error }] = useSwitchMerchantMutation({
 *   variables: {
 *      merchantId: // value for 'merchantId'
 *   },
 * });
 */
export function useSwitchMerchantMutation(baseOptions?: Apollo.MutationHookOptions<SwitchMerchantMutation, SwitchMerchantMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SwitchMerchantMutation, SwitchMerchantMutationVariables>(SwitchMerchantDocument, options);
      }
export type SwitchMerchantMutationHookResult = ReturnType<typeof useSwitchMerchantMutation>;
export type SwitchMerchantMutationResult = Apollo.MutationResult<SwitchMerchantMutation>;
export type SwitchMerchantMutationOptions = Apollo.BaseMutationOptions<SwitchMerchantMutation, SwitchMerchantMutationVariables>;
export const UpdateMerchantSettingsDocument = gql`
    mutation updateMerchantSettings($merchantSettings: MerchantSetingsInput!, $merchantId: ID!) {
  updateMerchantSettings(
    merchantSettings: $merchantSettings
    merchantId: $merchantId
  )
}
    `;
export type UpdateMerchantSettingsMutationFn = Apollo.MutationFunction<UpdateMerchantSettingsMutation, UpdateMerchantSettingsMutationVariables>;

/**
 * __useUpdateMerchantSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateMerchantSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMerchantSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMerchantSettingsMutation, { data, loading, error }] = useUpdateMerchantSettingsMutation({
 *   variables: {
 *      merchantSettings: // value for 'merchantSettings'
 *      merchantId: // value for 'merchantId'
 *   },
 * });
 */
export function useUpdateMerchantSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMerchantSettingsMutation, UpdateMerchantSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMerchantSettingsMutation, UpdateMerchantSettingsMutationVariables>(UpdateMerchantSettingsDocument, options);
      }
export type UpdateMerchantSettingsMutationHookResult = ReturnType<typeof useUpdateMerchantSettingsMutation>;
export type UpdateMerchantSettingsMutationResult = Apollo.MutationResult<UpdateMerchantSettingsMutation>;
export type UpdateMerchantSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateMerchantSettingsMutation, UpdateMerchantSettingsMutationVariables>;
export const UpdateMerchantSurchargesDocument = gql`
    mutation updateMerchantSurcharges($surcharges: [SurchargeInput]!, $merchantId: ID!) {
  updateMerchantSurcharges(surcharges: $surcharges, merchantId: $merchantId)
}
    `;
export type UpdateMerchantSurchargesMutationFn = Apollo.MutationFunction<UpdateMerchantSurchargesMutation, UpdateMerchantSurchargesMutationVariables>;

/**
 * __useUpdateMerchantSurchargesMutation__
 *
 * To run a mutation, you first call `useUpdateMerchantSurchargesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMerchantSurchargesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMerchantSurchargesMutation, { data, loading, error }] = useUpdateMerchantSurchargesMutation({
 *   variables: {
 *      surcharges: // value for 'surcharges'
 *      merchantId: // value for 'merchantId'
 *   },
 * });
 */
export function useUpdateMerchantSurchargesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMerchantSurchargesMutation, UpdateMerchantSurchargesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMerchantSurchargesMutation, UpdateMerchantSurchargesMutationVariables>(UpdateMerchantSurchargesDocument, options);
      }
export type UpdateMerchantSurchargesMutationHookResult = ReturnType<typeof useUpdateMerchantSurchargesMutation>;
export type UpdateMerchantSurchargesMutationResult = Apollo.MutationResult<UpdateMerchantSurchargesMutation>;
export type UpdateMerchantSurchargesMutationOptions = Apollo.BaseMutationOptions<UpdateMerchantSurchargesMutation, UpdateMerchantSurchargesMutationVariables>;
export const GetProductsDocument = gql`
    query getProducts {
  getProducts {
    product {
      name
      description
    }
    unit_amount
    id
  }
}
    `;

/**
 * __useGetProductsQuery__
 *
 * To run a query within a React component, call `useGetProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetProductsQuery(baseOptions?: Apollo.QueryHookOptions<GetProductsQuery, GetProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductsQuery, GetProductsQueryVariables>(GetProductsDocument, options);
      }
export function useGetProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductsQuery, GetProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductsQuery, GetProductsQueryVariables>(GetProductsDocument, options);
        }
export function useGetProductsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProductsQuery, GetProductsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProductsQuery, GetProductsQueryVariables>(GetProductsDocument, options);
        }
export type GetProductsQueryHookResult = ReturnType<typeof useGetProductsQuery>;
export type GetProductsLazyQueryHookResult = ReturnType<typeof useGetProductsLazyQuery>;
export type GetProductsSuspenseQueryHookResult = ReturnType<typeof useGetProductsSuspenseQuery>;
export type GetProductsQueryResult = Apollo.QueryResult<GetProductsQuery, GetProductsQueryVariables>;
export const DeleteMerchantLogoDocument = gql`
    mutation deleteMerchantLogo($imageName: String!) {
  deleteMerchantLogo(imageName: $imageName)
}
    `;
export type DeleteMerchantLogoMutationFn = Apollo.MutationFunction<DeleteMerchantLogoMutation, DeleteMerchantLogoMutationVariables>;

/**
 * __useDeleteMerchantLogoMutation__
 *
 * To run a mutation, you first call `useDeleteMerchantLogoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMerchantLogoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMerchantLogoMutation, { data, loading, error }] = useDeleteMerchantLogoMutation({
 *   variables: {
 *      imageName: // value for 'imageName'
 *   },
 * });
 */
export function useDeleteMerchantLogoMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMerchantLogoMutation, DeleteMerchantLogoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMerchantLogoMutation, DeleteMerchantLogoMutationVariables>(DeleteMerchantLogoDocument, options);
      }
export type DeleteMerchantLogoMutationHookResult = ReturnType<typeof useDeleteMerchantLogoMutation>;
export type DeleteMerchantLogoMutationResult = Apollo.MutationResult<DeleteMerchantLogoMutation>;
export type DeleteMerchantLogoMutationOptions = Apollo.BaseMutationOptions<DeleteMerchantLogoMutation, DeleteMerchantLogoMutationVariables>;
export const UpdateMerchantLogosDocument = gql`
    mutation updateMerchantLogos($urlStringArray: [String]!) {
  updateMerchantLogos(urlStringArray: $urlStringArray)
}
    `;
export type UpdateMerchantLogosMutationFn = Apollo.MutationFunction<UpdateMerchantLogosMutation, UpdateMerchantLogosMutationVariables>;

/**
 * __useUpdateMerchantLogosMutation__
 *
 * To run a mutation, you first call `useUpdateMerchantLogosMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMerchantLogosMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMerchantLogosMutation, { data, loading, error }] = useUpdateMerchantLogosMutation({
 *   variables: {
 *      urlStringArray: // value for 'urlStringArray'
 *   },
 * });
 */
export function useUpdateMerchantLogosMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMerchantLogosMutation, UpdateMerchantLogosMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMerchantLogosMutation, UpdateMerchantLogosMutationVariables>(UpdateMerchantLogosDocument, options);
      }
export type UpdateMerchantLogosMutationHookResult = ReturnType<typeof useUpdateMerchantLogosMutation>;
export type UpdateMerchantLogosMutationResult = Apollo.MutationResult<UpdateMerchantLogosMutation>;
export type UpdateMerchantLogosMutationOptions = Apollo.BaseMutationOptions<UpdateMerchantLogosMutation, UpdateMerchantLogosMutationVariables>;
export const PosMenusDocument = gql`
    query posMenus {
  posMenus {
    id
    name
    description
    isEnabled
    type
    status
    createdAt
    promotionTags
  }
}
    `;

/**
 * __usePosMenusQuery__
 *
 * To run a query within a React component, call `usePosMenusQuery` and pass it any options that fit your needs.
 * When your component renders, `usePosMenusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePosMenusQuery({
 *   variables: {
 *   },
 * });
 */
export function usePosMenusQuery(baseOptions?: Apollo.QueryHookOptions<PosMenusQuery, PosMenusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PosMenusQuery, PosMenusQueryVariables>(PosMenusDocument, options);
      }
export function usePosMenusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PosMenusQuery, PosMenusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PosMenusQuery, PosMenusQueryVariables>(PosMenusDocument, options);
        }
export function usePosMenusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PosMenusQuery, PosMenusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PosMenusQuery, PosMenusQueryVariables>(PosMenusDocument, options);
        }
export type PosMenusQueryHookResult = ReturnType<typeof usePosMenusQuery>;
export type PosMenusLazyQueryHookResult = ReturnType<typeof usePosMenusLazyQuery>;
export type PosMenusSuspenseQueryHookResult = ReturnType<typeof usePosMenusSuspenseQuery>;
export type PosMenusQueryResult = Apollo.QueryResult<PosMenusQuery, PosMenusQueryVariables>;
export const PosMenuDocument = gql`
    query posMenu($menuId: String!) {
  posMenu(menuId: $menuId) {
    id
    name
    description
    isEnabled
    type
    status
    createdAt
    promotionTags
  }
}
    `;

/**
 * __usePosMenuQuery__
 *
 * To run a query within a React component, call `usePosMenuQuery` and pass it any options that fit your needs.
 * When your component renders, `usePosMenuQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePosMenuQuery({
 *   variables: {
 *      menuId: // value for 'menuId'
 *   },
 * });
 */
export function usePosMenuQuery(baseOptions: Apollo.QueryHookOptions<PosMenuQuery, PosMenuQueryVariables> & ({ variables: PosMenuQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PosMenuQuery, PosMenuQueryVariables>(PosMenuDocument, options);
      }
export function usePosMenuLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PosMenuQuery, PosMenuQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PosMenuQuery, PosMenuQueryVariables>(PosMenuDocument, options);
        }
export function usePosMenuSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PosMenuQuery, PosMenuQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PosMenuQuery, PosMenuQueryVariables>(PosMenuDocument, options);
        }
export type PosMenuQueryHookResult = ReturnType<typeof usePosMenuQuery>;
export type PosMenuLazyQueryHookResult = ReturnType<typeof usePosMenuLazyQuery>;
export type PosMenuSuspenseQueryHookResult = ReturnType<typeof usePosMenuSuspenseQuery>;
export type PosMenuQueryResult = Apollo.QueryResult<PosMenuQuery, PosMenuQueryVariables>;
export const MerchantAreasDocument = gql`
    query merchantAreas {
  merchantAreas {
    name
    description
    sort
    tables {
      minimumNumberOfGuests
      maximumNumberOfGuests
      tableNumber
    }
  }
}
    `;

/**
 * __useMerchantAreasQuery__
 *
 * To run a query within a React component, call `useMerchantAreasQuery` and pass it any options that fit your needs.
 * When your component renders, `useMerchantAreasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMerchantAreasQuery({
 *   variables: {
 *   },
 * });
 */
export function useMerchantAreasQuery(baseOptions?: Apollo.QueryHookOptions<MerchantAreasQuery, MerchantAreasQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MerchantAreasQuery, MerchantAreasQueryVariables>(MerchantAreasDocument, options);
      }
export function useMerchantAreasLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MerchantAreasQuery, MerchantAreasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MerchantAreasQuery, MerchantAreasQueryVariables>(MerchantAreasDocument, options);
        }
export function useMerchantAreasSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MerchantAreasQuery, MerchantAreasQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MerchantAreasQuery, MerchantAreasQueryVariables>(MerchantAreasDocument, options);
        }
export type MerchantAreasQueryHookResult = ReturnType<typeof useMerchantAreasQuery>;
export type MerchantAreasLazyQueryHookResult = ReturnType<typeof useMerchantAreasLazyQuery>;
export type MerchantAreasSuspenseQueryHookResult = ReturnType<typeof useMerchantAreasSuspenseQuery>;
export type MerchantAreasQueryResult = Apollo.QueryResult<MerchantAreasQuery, MerchantAreasQueryVariables>;
export const SyncPosMerchantDataDocument = gql`
    mutation syncPOSMerchantData {
  syncPOSMerchantData
}
    `;
export type SyncPosMerchantDataMutationFn = Apollo.MutationFunction<SyncPosMerchantDataMutation, SyncPosMerchantDataMutationVariables>;

/**
 * __useSyncPosMerchantDataMutation__
 *
 * To run a mutation, you first call `useSyncPosMerchantDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncPosMerchantDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncPosMerchantDataMutation, { data, loading, error }] = useSyncPosMerchantDataMutation({
 *   variables: {
 *   },
 * });
 */
export function useSyncPosMerchantDataMutation(baseOptions?: Apollo.MutationHookOptions<SyncPosMerchantDataMutation, SyncPosMerchantDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SyncPosMerchantDataMutation, SyncPosMerchantDataMutationVariables>(SyncPosMerchantDataDocument, options);
      }
export type SyncPosMerchantDataMutationHookResult = ReturnType<typeof useSyncPosMerchantDataMutation>;
export type SyncPosMerchantDataMutationResult = Apollo.MutationResult<SyncPosMerchantDataMutation>;
export type SyncPosMerchantDataMutationOptions = Apollo.BaseMutationOptions<SyncPosMerchantDataMutation, SyncPosMerchantDataMutationVariables>;
export const SyncPosMerchantOpenHoursDocument = gql`
    mutation syncPOSMerchantOpenHours {
  syncPOSMerchantOpenHours
}
    `;
export type SyncPosMerchantOpenHoursMutationFn = Apollo.MutationFunction<SyncPosMerchantOpenHoursMutation, SyncPosMerchantOpenHoursMutationVariables>;

/**
 * __useSyncPosMerchantOpenHoursMutation__
 *
 * To run a mutation, you first call `useSyncPosMerchantOpenHoursMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncPosMerchantOpenHoursMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncPosMerchantOpenHoursMutation, { data, loading, error }] = useSyncPosMerchantOpenHoursMutation({
 *   variables: {
 *   },
 * });
 */
export function useSyncPosMerchantOpenHoursMutation(baseOptions?: Apollo.MutationHookOptions<SyncPosMerchantOpenHoursMutation, SyncPosMerchantOpenHoursMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SyncPosMerchantOpenHoursMutation, SyncPosMerchantOpenHoursMutationVariables>(SyncPosMerchantOpenHoursDocument, options);
      }
export type SyncPosMerchantOpenHoursMutationHookResult = ReturnType<typeof useSyncPosMerchantOpenHoursMutation>;
export type SyncPosMerchantOpenHoursMutationResult = Apollo.MutationResult<SyncPosMerchantOpenHoursMutation>;
export type SyncPosMerchantOpenHoursMutationOptions = Apollo.BaseMutationOptions<SyncPosMerchantOpenHoursMutation, SyncPosMerchantOpenHoursMutationVariables>;
export const SyncPosMerchantTablesDocument = gql`
    mutation syncPOSMerchantTables {
  syncPOSMerchantTables
}
    `;
export type SyncPosMerchantTablesMutationFn = Apollo.MutationFunction<SyncPosMerchantTablesMutation, SyncPosMerchantTablesMutationVariables>;

/**
 * __useSyncPosMerchantTablesMutation__
 *
 * To run a mutation, you first call `useSyncPosMerchantTablesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncPosMerchantTablesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncPosMerchantTablesMutation, { data, loading, error }] = useSyncPosMerchantTablesMutation({
 *   variables: {
 *   },
 * });
 */
export function useSyncPosMerchantTablesMutation(baseOptions?: Apollo.MutationHookOptions<SyncPosMerchantTablesMutation, SyncPosMerchantTablesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SyncPosMerchantTablesMutation, SyncPosMerchantTablesMutationVariables>(SyncPosMerchantTablesDocument, options);
      }
export type SyncPosMerchantTablesMutationHookResult = ReturnType<typeof useSyncPosMerchantTablesMutation>;
export type SyncPosMerchantTablesMutationResult = Apollo.MutationResult<SyncPosMerchantTablesMutation>;
export type SyncPosMerchantTablesMutationOptions = Apollo.BaseMutationOptions<SyncPosMerchantTablesMutation, SyncPosMerchantTablesMutationVariables>;
export const SyncPosMerchantBasicInfoDocument = gql`
    mutation syncPOSMerchantBasicInfo {
  syncPOSMerchantBasicInfo
}
    `;
export type SyncPosMerchantBasicInfoMutationFn = Apollo.MutationFunction<SyncPosMerchantBasicInfoMutation, SyncPosMerchantBasicInfoMutationVariables>;

/**
 * __useSyncPosMerchantBasicInfoMutation__
 *
 * To run a mutation, you first call `useSyncPosMerchantBasicInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncPosMerchantBasicInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncPosMerchantBasicInfoMutation, { data, loading, error }] = useSyncPosMerchantBasicInfoMutation({
 *   variables: {
 *   },
 * });
 */
export function useSyncPosMerchantBasicInfoMutation(baseOptions?: Apollo.MutationHookOptions<SyncPosMerchantBasicInfoMutation, SyncPosMerchantBasicInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SyncPosMerchantBasicInfoMutation, SyncPosMerchantBasicInfoMutationVariables>(SyncPosMerchantBasicInfoDocument, options);
      }
export type SyncPosMerchantBasicInfoMutationHookResult = ReturnType<typeof useSyncPosMerchantBasicInfoMutation>;
export type SyncPosMerchantBasicInfoMutationResult = Apollo.MutationResult<SyncPosMerchantBasicInfoMutation>;
export type SyncPosMerchantBasicInfoMutationOptions = Apollo.BaseMutationOptions<SyncPosMerchantBasicInfoMutation, SyncPosMerchantBasicInfoMutationVariables>;
export const OrdersDocument = gql`
    query orders($dateString: String!) {
  orders(dateString: $dateString) {
    orderNumber
    merchant {
      merchantId
      tableId
    }
    createdAt
    orderFrom
    order {
      pickupTime
      total
      paymentType
      type
      selectedDate
      notes
      orderTime
      adjustments {
        adjustmentType
        amount
        voucherNo
        description
      }
      items {
        size {
          name
          price
          groups {
            id
            name
            menuId
            options {
              id
              name
              shortName
              price
            }
          }
        }
        subTotal
        quantity
        specialInstructions
        isTakeaway
        id
        options {
          id
          quantity
          price
          name
          shortName
          price
        }
        dish {
          id
          price
          description
          name
        }
      }
    }
    user {
      name
      email
      phoneNumber
      guestNum
      address
      postcode
      foodAllergies
      geolocation {
        longitude
        latitude
      }
    }
  }
}
    `;

/**
 * __useOrdersQuery__
 *
 * To run a query within a React component, call `useOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrdersQuery({
 *   variables: {
 *      dateString: // value for 'dateString'
 *   },
 * });
 */
export function useOrdersQuery(baseOptions: Apollo.QueryHookOptions<OrdersQuery, OrdersQueryVariables> & ({ variables: OrdersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrdersQuery, OrdersQueryVariables>(OrdersDocument, options);
      }
export function useOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrdersQuery, OrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrdersQuery, OrdersQueryVariables>(OrdersDocument, options);
        }
export function useOrdersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrdersQuery, OrdersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrdersQuery, OrdersQueryVariables>(OrdersDocument, options);
        }
export type OrdersQueryHookResult = ReturnType<typeof useOrdersQuery>;
export type OrdersLazyQueryHookResult = ReturnType<typeof useOrdersLazyQuery>;
export type OrdersSuspenseQueryHookResult = ReturnType<typeof useOrdersSuspenseQuery>;
export type OrdersQueryResult = Apollo.QueryResult<OrdersQuery, OrdersQueryVariables>;
export const OrderDocument = gql`
    query order($dateString: String!, $orderNumber: String!) {
  order(dateString: $dateString, orderNumber: $orderNumber) {
    orderNumber
    merchant {
      merchantId
      tableId
    }
    createdAt
    orderFrom
    order {
      pickupTime
      total
      paymentType
      type
      selectedDate
      notes
      orderTime
      adjustments {
        adjustmentType
        priceDecimal
        name
      }
      items {
        size {
          name
          price
          groups {
            id
            name
            menuId
            options {
              id
              name
              shortName
              price
            }
          }
        }
        subTotal
        quantity
        specialInstructions
        isTakeaway
        id
        options {
          id
          quantity
          price
          name
          shortName
          price
        }
        dish {
          id
          price
          description
          name
        }
      }
    }
    user {
      name
      email
      phoneNumber
      guestNum
      address
      postcode
      foodAllergies
      geolocation {
        longitude
        latitude
      }
    }
  }
}
    `;

/**
 * __useOrderQuery__
 *
 * To run a query within a React component, call `useOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderQuery({
 *   variables: {
 *      dateString: // value for 'dateString'
 *      orderNumber: // value for 'orderNumber'
 *   },
 * });
 */
export function useOrderQuery(baseOptions: Apollo.QueryHookOptions<OrderQuery, OrderQueryVariables> & ({ variables: OrderQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrderQuery, OrderQueryVariables>(OrderDocument, options);
      }
export function useOrderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderQuery, OrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrderQuery, OrderQueryVariables>(OrderDocument, options);
        }
export function useOrderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrderQuery, OrderQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrderQuery, OrderQueryVariables>(OrderDocument, options);
        }
export type OrderQueryHookResult = ReturnType<typeof useOrderQuery>;
export type OrderLazyQueryHookResult = ReturnType<typeof useOrderLazyQuery>;
export type OrderSuspenseQueryHookResult = ReturnType<typeof useOrderSuspenseQuery>;
export type OrderQueryResult = Apollo.QueryResult<OrderQuery, OrderQueryVariables>;
export const GetPromotionsDocument = gql`
    query getPromotions {
  getPromotions {
    id
    name
    description
    status
    type
    numberOfDeals
    usedQuantity
    createdAt
    minimumAmount
    merchantId
    orders {
      orderNumber
      sourceType
      createdAt
    }
    bookings {
      id
      createdAt
      merchantId
    }
    canBeUsedWithOtherPromotions
    effectiveDateTime {
      startDate
      endDate
      recurringWeekDays
      hours {
        openStart
        openEnd
      }
    }
    applyOptionDiscount
    excludedPromotionTags
    includedPromotionTags
    includedGetItemsPromoTags
    discountedItemQty
    availableType
    buyN
    freeN
    percentage
    discountAmount
    isPercentage
    upToAmount
    isOffer
    isSignUpPromotion
    isHiddenInApp
    offerVoucherSettings {
      offerName
      offerDescription
      offerExcludedItemTags
      effectiveHoursAfterOfferActivated
      effectiveDateTime {
        startDate
        endDate
        recurringWeekDays
        hours {
          openStart
          openEnd
        }
      }
      minimumAmount
      upToAmount
      voucherTerms
      displaySettings {
        displayTitle
        displayDescription
        displayAltDescription
        displayAltTitle
        displayImage
        displayTerms
      }
    }
    type
    useType
    isLoyalty
    entrySpendAmountCents
    prizeDescription
    winPercentage
    winnerCount
    entryLimitPerUser
    winCountLimitPerPerson
    isEntryAutomatic
    resultingPromotions {
      promotionId
      winPercentage
    }
    isPaymentRequired
    loyaltyDetails {
      expiryDays
      loyaltyReviewDate
    }
    loyaltySettings {
      pointsPerDollar
      maxPointsPerTransaction
      expiryDays
      loyaltyReviewDate
      loyaltyBenefits {
        id
        name
        description
        requiredPoints
        benefitPromotionIds
        displaySettings {
          displayTitle
          displayDescription
          displayAltDescription
          displayAltTitle
          displayImage
          displayTerms
        }
      }
    }
    displaySettings {
      displayTitle
      displayDescription
      displayAltDescription
      displayAltTitle
      displayImage
      displayTerms
    }
  }
}
    `;

/**
 * __useGetPromotionsQuery__
 *
 * To run a query within a React component, call `useGetPromotionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPromotionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPromotionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPromotionsQuery(baseOptions?: Apollo.QueryHookOptions<GetPromotionsQuery, GetPromotionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPromotionsQuery, GetPromotionsQueryVariables>(GetPromotionsDocument, options);
      }
export function useGetPromotionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPromotionsQuery, GetPromotionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPromotionsQuery, GetPromotionsQueryVariables>(GetPromotionsDocument, options);
        }
export function useGetPromotionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPromotionsQuery, GetPromotionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPromotionsQuery, GetPromotionsQueryVariables>(GetPromotionsDocument, options);
        }
export type GetPromotionsQueryHookResult = ReturnType<typeof useGetPromotionsQuery>;
export type GetPromotionsLazyQueryHookResult = ReturnType<typeof useGetPromotionsLazyQuery>;
export type GetPromotionsSuspenseQueryHookResult = ReturnType<typeof useGetPromotionsSuspenseQuery>;
export type GetPromotionsQueryResult = Apollo.QueryResult<GetPromotionsQuery, GetPromotionsQueryVariables>;
export const GetPromotionsOnLuckyDrawDocument = gql`
    query getPromotionsOnLuckyDraw {
  getPromotions {
    id
    name
    status
    effectiveDateTime {
      startDate
      endDate
      recurringWeekDays
      hours {
        openStart
        openEnd
      }
    }
    isOffer
    type
  }
}
    `;

/**
 * __useGetPromotionsOnLuckyDrawQuery__
 *
 * To run a query within a React component, call `useGetPromotionsOnLuckyDrawQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPromotionsOnLuckyDrawQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPromotionsOnLuckyDrawQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPromotionsOnLuckyDrawQuery(baseOptions?: Apollo.QueryHookOptions<GetPromotionsOnLuckyDrawQuery, GetPromotionsOnLuckyDrawQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPromotionsOnLuckyDrawQuery, GetPromotionsOnLuckyDrawQueryVariables>(GetPromotionsOnLuckyDrawDocument, options);
      }
export function useGetPromotionsOnLuckyDrawLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPromotionsOnLuckyDrawQuery, GetPromotionsOnLuckyDrawQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPromotionsOnLuckyDrawQuery, GetPromotionsOnLuckyDrawQueryVariables>(GetPromotionsOnLuckyDrawDocument, options);
        }
export function useGetPromotionsOnLuckyDrawSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPromotionsOnLuckyDrawQuery, GetPromotionsOnLuckyDrawQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPromotionsOnLuckyDrawQuery, GetPromotionsOnLuckyDrawQueryVariables>(GetPromotionsOnLuckyDrawDocument, options);
        }
export type GetPromotionsOnLuckyDrawQueryHookResult = ReturnType<typeof useGetPromotionsOnLuckyDrawQuery>;
export type GetPromotionsOnLuckyDrawLazyQueryHookResult = ReturnType<typeof useGetPromotionsOnLuckyDrawLazyQuery>;
export type GetPromotionsOnLuckyDrawSuspenseQueryHookResult = ReturnType<typeof useGetPromotionsOnLuckyDrawSuspenseQuery>;
export type GetPromotionsOnLuckyDrawQueryResult = Apollo.QueryResult<GetPromotionsOnLuckyDrawQuery, GetPromotionsOnLuckyDrawQueryVariables>;
export const GetPublishedMenuCategoriesDocument = gql`
    query getPublishedMenuCategories {
  getPublishedMenuCategories {
    name
    id
    altName
    active_begin
    description
    active_end
    hidden_until
    active
    menuId
    cookingPriority
    groups {
      id
      name
      allow_quantity
      force_max
      force_min
      menuId
      options {
        id
        name
        shortName
        default
        groupId
        price
        sort
      }
    }
    items {
      id
      tags
      price
      active
      description
      menuId
      image
      hidden_until
      sort
      name
      active_end
      displayNumber
      altName
      ingredients
      active_begin
      cookingCategory
      categoryId
      sizes {
        name
        price
        id
        default
        groups {
          id
          name
          allow_quantity
          force_max
          force_min
          menuId
          options {
            id
            name
            shortName
            default
            groupId
            price
            sort
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetPublishedMenuCategoriesQuery__
 *
 * To run a query within a React component, call `useGetPublishedMenuCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPublishedMenuCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPublishedMenuCategoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPublishedMenuCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<GetPublishedMenuCategoriesQuery, GetPublishedMenuCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPublishedMenuCategoriesQuery, GetPublishedMenuCategoriesQueryVariables>(GetPublishedMenuCategoriesDocument, options);
      }
export function useGetPublishedMenuCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPublishedMenuCategoriesQuery, GetPublishedMenuCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPublishedMenuCategoriesQuery, GetPublishedMenuCategoriesQueryVariables>(GetPublishedMenuCategoriesDocument, options);
        }
export function useGetPublishedMenuCategoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPublishedMenuCategoriesQuery, GetPublishedMenuCategoriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPublishedMenuCategoriesQuery, GetPublishedMenuCategoriesQueryVariables>(GetPublishedMenuCategoriesDocument, options);
        }
export type GetPublishedMenuCategoriesQueryHookResult = ReturnType<typeof useGetPublishedMenuCategoriesQuery>;
export type GetPublishedMenuCategoriesLazyQueryHookResult = ReturnType<typeof useGetPublishedMenuCategoriesLazyQuery>;
export type GetPublishedMenuCategoriesSuspenseQueryHookResult = ReturnType<typeof useGetPublishedMenuCategoriesSuspenseQuery>;
export type GetPublishedMenuCategoriesQueryResult = Apollo.QueryResult<GetPublishedMenuCategoriesQuery, GetPublishedMenuCategoriesQueryVariables>;
export const GetPercentagePromotionDocument = gql`
    query getPercentagePromotion($promotionId: String!) {
  getPercentagePromotion(promotionId: $promotionId) {
    id
    name
    description
    percentage
    discountAmount
    isPercentage
    excludedPromotionTags
    includedPromotionTags
    includedGetItemsPromoTags
    numberOfDeals
    availableType
    minimumAmount
    isHiddenInApp
    effectiveDateTime {
      startDate
      endDate
      recurringWeekDays
      hours {
        openStart
        openEnd
      }
    }
    canBeUsedWithOtherPromotions
    isSignUpPromotion
    upToAmount
    isOffer
    offerVoucherSettings {
      offerName
      offerDescription
      offerExcludedItemTags
      effectiveHoursAfterOfferActivated
      effectiveDateTime {
        startDate
        endDate
        recurringWeekDays
        hours {
          openStart
          openEnd
        }
      }
      minimumAmount
      upToAmount
      voucherTerms
      displaySettings {
        displayTitle
        displayDescription
        displayAltDescription
        displayAltTitle
        displayImage
        displayTerms
      }
    }
    useType
    applyOptionDiscount
    isLoyalty
    loyaltyDetails {
      expiryDays
      loyaltyReviewDate
    }
    displaySettings {
      displayTitle
      displayDescription
      displayAltDescription
      displayAltTitle
      displayImage
      displayTerms
    }
  }
}
    `;

/**
 * __useGetPercentagePromotionQuery__
 *
 * To run a query within a React component, call `useGetPercentagePromotionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPercentagePromotionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPercentagePromotionQuery({
 *   variables: {
 *      promotionId: // value for 'promotionId'
 *   },
 * });
 */
export function useGetPercentagePromotionQuery(baseOptions: Apollo.QueryHookOptions<GetPercentagePromotionQuery, GetPercentagePromotionQueryVariables> & ({ variables: GetPercentagePromotionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPercentagePromotionQuery, GetPercentagePromotionQueryVariables>(GetPercentagePromotionDocument, options);
      }
export function useGetPercentagePromotionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPercentagePromotionQuery, GetPercentagePromotionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPercentagePromotionQuery, GetPercentagePromotionQueryVariables>(GetPercentagePromotionDocument, options);
        }
export function useGetPercentagePromotionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPercentagePromotionQuery, GetPercentagePromotionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPercentagePromotionQuery, GetPercentagePromotionQueryVariables>(GetPercentagePromotionDocument, options);
        }
export type GetPercentagePromotionQueryHookResult = ReturnType<typeof useGetPercentagePromotionQuery>;
export type GetPercentagePromotionLazyQueryHookResult = ReturnType<typeof useGetPercentagePromotionLazyQuery>;
export type GetPercentagePromotionSuspenseQueryHookResult = ReturnType<typeof useGetPercentagePromotionSuspenseQuery>;
export type GetPercentagePromotionQueryResult = Apollo.QueryResult<GetPercentagePromotionQuery, GetPercentagePromotionQueryVariables>;
export const GetLoyaltyPromotionDocument = gql`
    query getLoyaltyPromotion($promotionId: String!) {
  loyaltyPromotion(promotionId: $promotionId) {
    id
    name
    description
    status
    type
    numberOfDeals
    merchantId
    useType
    isHiddenInApp
    isLoyalty
    includedPromotionTags
    excludedPromotionTags
    canBeUsedWithOtherPromotions
    effectiveDateTime {
      startDate
      endDate
      recurringWeekDays
      hours {
        openStart
        openEnd
      }
    }
    loyaltySettings {
      pointsPerDollar
      maxPointsPerTransaction
      expiryDays
      loyaltyReviewDate
      loyaltyBenefits {
        id
        name
        description
        requiredPoints
        benefitPromotionIds
        displaySettings {
          displayTitle
          displayDescription
          displayAltDescription
          displayAltTitle
          displayImage
          displayTerms
        }
      }
    }
    displaySettings {
      displayTitle
      displayDescription
      displayAltDescription
      displayAltTitle
      displayImage
      displayTerms
    }
  }
}
    `;

/**
 * __useGetLoyaltyPromotionQuery__
 *
 * To run a query within a React component, call `useGetLoyaltyPromotionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLoyaltyPromotionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLoyaltyPromotionQuery({
 *   variables: {
 *      promotionId: // value for 'promotionId'
 *   },
 * });
 */
export function useGetLoyaltyPromotionQuery(baseOptions: Apollo.QueryHookOptions<GetLoyaltyPromotionQuery, GetLoyaltyPromotionQueryVariables> & ({ variables: GetLoyaltyPromotionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLoyaltyPromotionQuery, GetLoyaltyPromotionQueryVariables>(GetLoyaltyPromotionDocument, options);
      }
export function useGetLoyaltyPromotionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLoyaltyPromotionQuery, GetLoyaltyPromotionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLoyaltyPromotionQuery, GetLoyaltyPromotionQueryVariables>(GetLoyaltyPromotionDocument, options);
        }
export function useGetLoyaltyPromotionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLoyaltyPromotionQuery, GetLoyaltyPromotionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLoyaltyPromotionQuery, GetLoyaltyPromotionQueryVariables>(GetLoyaltyPromotionDocument, options);
        }
export type GetLoyaltyPromotionQueryHookResult = ReturnType<typeof useGetLoyaltyPromotionQuery>;
export type GetLoyaltyPromotionLazyQueryHookResult = ReturnType<typeof useGetLoyaltyPromotionLazyQuery>;
export type GetLoyaltyPromotionSuspenseQueryHookResult = ReturnType<typeof useGetLoyaltyPromotionSuspenseQuery>;
export type GetLoyaltyPromotionQueryResult = Apollo.QueryResult<GetLoyaltyPromotionQuery, GetLoyaltyPromotionQueryVariables>;
export const GetSpendPromotionDocument = gql`
    query getSpendPromotion($promotionId: String!) {
  getSpendPromotion(promotionId: $promotionId) {
    name
    description
    percentage
    discountAmount
    isPercentage
    numberOfDeals
    availableType
    excludedPromotionTags
    includedPromotionTags
    effectiveDateTime {
      startDate
      endDate
      recurringWeekDays
      hours {
        openStart
        openEnd
      }
    }
    isHiddenInApp
    canBeUsedWithOtherPromotions
    includedGetItemsPromoTags
    discountedItemQty
    minimumAmount
    isSignUpPromotion
    upToAmount
    isOffer
    offerVoucherSettings {
      offerName
      offerDescription
      offerExcludedItemTags
      effectiveHoursAfterOfferActivated
      effectiveDateTime {
        startDate
        endDate
        recurringWeekDays
        hours {
          openStart
          openEnd
        }
      }
      minimumAmount
      upToAmount
      voucherTerms
      displaySettings {
        displayTitle
        displayDescription
        displayAltDescription
        displayAltTitle
        displayImage
        displayTerms
      }
    }
    useType
    applyOptionDiscount
    isLoyalty
    loyaltyDetails {
      expiryDays
      loyaltyReviewDate
    }
    displaySettings {
      displayTitle
      displayDescription
      displayAltDescription
      displayAltTitle
      displayImage
      displayTerms
    }
  }
}
    `;

/**
 * __useGetSpendPromotionQuery__
 *
 * To run a query within a React component, call `useGetSpendPromotionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSpendPromotionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSpendPromotionQuery({
 *   variables: {
 *      promotionId: // value for 'promotionId'
 *   },
 * });
 */
export function useGetSpendPromotionQuery(baseOptions: Apollo.QueryHookOptions<GetSpendPromotionQuery, GetSpendPromotionQueryVariables> & ({ variables: GetSpendPromotionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSpendPromotionQuery, GetSpendPromotionQueryVariables>(GetSpendPromotionDocument, options);
      }
export function useGetSpendPromotionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSpendPromotionQuery, GetSpendPromotionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSpendPromotionQuery, GetSpendPromotionQueryVariables>(GetSpendPromotionDocument, options);
        }
export function useGetSpendPromotionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSpendPromotionQuery, GetSpendPromotionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSpendPromotionQuery, GetSpendPromotionQueryVariables>(GetSpendPromotionDocument, options);
        }
export type GetSpendPromotionQueryHookResult = ReturnType<typeof useGetSpendPromotionQuery>;
export type GetSpendPromotionLazyQueryHookResult = ReturnType<typeof useGetSpendPromotionLazyQuery>;
export type GetSpendPromotionSuspenseQueryHookResult = ReturnType<typeof useGetSpendPromotionSuspenseQuery>;
export type GetSpendPromotionQueryResult = Apollo.QueryResult<GetSpendPromotionQuery, GetSpendPromotionQueryVariables>;
export const GetBuyNGetNFreePromotionDocument = gql`
    query getBuyNGetNFreePromotion($promotionId: String!) {
  getBuyNGetNFreePromotion(promotionId: $promotionId) {
    id
    name
    description
    buyN
    freeN
    numberOfDeals
    availableType
    minimumAmount
    effectiveDateTime {
      startDate
      endDate
      recurringWeekDays
      hours {
        openStart
        openEnd
      }
    }
    includedGetItemsPromoTags
    excludedPromotionTags
    includedPromotionTags
    canBeUsedWithOtherPromotions
    percentage
    discountAmount
    isPercentage
    upToAmount
    isOffer
    isHiddenInApp
    offerVoucherSettings {
      offerName
      offerDescription
      offerExcludedItemTags
      effectiveHoursAfterOfferActivated
      effectiveDateTime {
        startDate
        endDate
        recurringWeekDays
        hours {
          openStart
          openEnd
        }
      }
      minimumAmount
      upToAmount
      voucherTerms
      displaySettings {
        displayTitle
        displayDescription
        displayAltDescription
        displayAltTitle
        displayImage
        displayTerms
      }
    }
    useType
    isSignUpPromotion
    applyOptionDiscount
    isLoyalty
    loyaltyDetails {
      expiryDays
      loyaltyReviewDate
    }
    displaySettings {
      displayTitle
      displayDescription
      displayAltDescription
      displayAltTitle
      displayImage
      displayTerms
    }
  }
}
    `;

/**
 * __useGetBuyNGetNFreePromotionQuery__
 *
 * To run a query within a React component, call `useGetBuyNGetNFreePromotionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBuyNGetNFreePromotionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBuyNGetNFreePromotionQuery({
 *   variables: {
 *      promotionId: // value for 'promotionId'
 *   },
 * });
 */
export function useGetBuyNGetNFreePromotionQuery(baseOptions: Apollo.QueryHookOptions<GetBuyNGetNFreePromotionQuery, GetBuyNGetNFreePromotionQueryVariables> & ({ variables: GetBuyNGetNFreePromotionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBuyNGetNFreePromotionQuery, GetBuyNGetNFreePromotionQueryVariables>(GetBuyNGetNFreePromotionDocument, options);
      }
export function useGetBuyNGetNFreePromotionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBuyNGetNFreePromotionQuery, GetBuyNGetNFreePromotionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBuyNGetNFreePromotionQuery, GetBuyNGetNFreePromotionQueryVariables>(GetBuyNGetNFreePromotionDocument, options);
        }
export function useGetBuyNGetNFreePromotionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBuyNGetNFreePromotionQuery, GetBuyNGetNFreePromotionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBuyNGetNFreePromotionQuery, GetBuyNGetNFreePromotionQueryVariables>(GetBuyNGetNFreePromotionDocument, options);
        }
export type GetBuyNGetNFreePromotionQueryHookResult = ReturnType<typeof useGetBuyNGetNFreePromotionQuery>;
export type GetBuyNGetNFreePromotionLazyQueryHookResult = ReturnType<typeof useGetBuyNGetNFreePromotionLazyQuery>;
export type GetBuyNGetNFreePromotionSuspenseQueryHookResult = ReturnType<typeof useGetBuyNGetNFreePromotionSuspenseQuery>;
export type GetBuyNGetNFreePromotionQueryResult = Apollo.QueryResult<GetBuyNGetNFreePromotionQuery, GetBuyNGetNFreePromotionQueryVariables>;
export const PublishPromotionDocument = gql`
    mutation publishPromotion($promotionId: String!) {
  publishPromotion(promotionId: $promotionId)
}
    `;
export type PublishPromotionMutationFn = Apollo.MutationFunction<PublishPromotionMutation, PublishPromotionMutationVariables>;

/**
 * __usePublishPromotionMutation__
 *
 * To run a mutation, you first call `usePublishPromotionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishPromotionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishPromotionMutation, { data, loading, error }] = usePublishPromotionMutation({
 *   variables: {
 *      promotionId: // value for 'promotionId'
 *   },
 * });
 */
export function usePublishPromotionMutation(baseOptions?: Apollo.MutationHookOptions<PublishPromotionMutation, PublishPromotionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PublishPromotionMutation, PublishPromotionMutationVariables>(PublishPromotionDocument, options);
      }
export type PublishPromotionMutationHookResult = ReturnType<typeof usePublishPromotionMutation>;
export type PublishPromotionMutationResult = Apollo.MutationResult<PublishPromotionMutation>;
export type PublishPromotionMutationOptions = Apollo.BaseMutationOptions<PublishPromotionMutation, PublishPromotionMutationVariables>;
export const UnpublishPromotionDocument = gql`
    mutation unpublishPromotion($promotionId: String!) {
  unpublishPromotion(promotionId: $promotionId)
}
    `;
export type UnpublishPromotionMutationFn = Apollo.MutationFunction<UnpublishPromotionMutation, UnpublishPromotionMutationVariables>;

/**
 * __useUnpublishPromotionMutation__
 *
 * To run a mutation, you first call `useUnpublishPromotionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnpublishPromotionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unpublishPromotionMutation, { data, loading, error }] = useUnpublishPromotionMutation({
 *   variables: {
 *      promotionId: // value for 'promotionId'
 *   },
 * });
 */
export function useUnpublishPromotionMutation(baseOptions?: Apollo.MutationHookOptions<UnpublishPromotionMutation, UnpublishPromotionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnpublishPromotionMutation, UnpublishPromotionMutationVariables>(UnpublishPromotionDocument, options);
      }
export type UnpublishPromotionMutationHookResult = ReturnType<typeof useUnpublishPromotionMutation>;
export type UnpublishPromotionMutationResult = Apollo.MutationResult<UnpublishPromotionMutation>;
export type UnpublishPromotionMutationOptions = Apollo.BaseMutationOptions<UnpublishPromotionMutation, UnpublishPromotionMutationVariables>;
export const DeletePromotionDocument = gql`
    mutation deletePromotion($promotionId: String!) {
  deletePromotion(promotionId: $promotionId)
}
    `;
export type DeletePromotionMutationFn = Apollo.MutationFunction<DeletePromotionMutation, DeletePromotionMutationVariables>;

/**
 * __useDeletePromotionMutation__
 *
 * To run a mutation, you first call `useDeletePromotionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePromotionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePromotionMutation, { data, loading, error }] = useDeletePromotionMutation({
 *   variables: {
 *      promotionId: // value for 'promotionId'
 *   },
 * });
 */
export function useDeletePromotionMutation(baseOptions?: Apollo.MutationHookOptions<DeletePromotionMutation, DeletePromotionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePromotionMutation, DeletePromotionMutationVariables>(DeletePromotionDocument, options);
      }
export type DeletePromotionMutationHookResult = ReturnType<typeof useDeletePromotionMutation>;
export type DeletePromotionMutationResult = Apollo.MutationResult<DeletePromotionMutation>;
export type DeletePromotionMutationOptions = Apollo.BaseMutationOptions<DeletePromotionMutation, DeletePromotionMutationVariables>;
export const CreatePercentagePromotionDocument = gql`
    mutation createPercentagePromotion($promotion: PercentagePromotionInput!) {
  createPercentagePromotion(promotion: $promotion)
}
    `;
export type CreatePercentagePromotionMutationFn = Apollo.MutationFunction<CreatePercentagePromotionMutation, CreatePercentagePromotionMutationVariables>;

/**
 * __useCreatePercentagePromotionMutation__
 *
 * To run a mutation, you first call `useCreatePercentagePromotionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePercentagePromotionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPercentagePromotionMutation, { data, loading, error }] = useCreatePercentagePromotionMutation({
 *   variables: {
 *      promotion: // value for 'promotion'
 *   },
 * });
 */
export function useCreatePercentagePromotionMutation(baseOptions?: Apollo.MutationHookOptions<CreatePercentagePromotionMutation, CreatePercentagePromotionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePercentagePromotionMutation, CreatePercentagePromotionMutationVariables>(CreatePercentagePromotionDocument, options);
      }
export type CreatePercentagePromotionMutationHookResult = ReturnType<typeof useCreatePercentagePromotionMutation>;
export type CreatePercentagePromotionMutationResult = Apollo.MutationResult<CreatePercentagePromotionMutation>;
export type CreatePercentagePromotionMutationOptions = Apollo.BaseMutationOptions<CreatePercentagePromotionMutation, CreatePercentagePromotionMutationVariables>;
export const CreateLoyaltyPromotionDocument = gql`
    mutation createLoyaltyPromotion($promotion: LoyaltyPromotionInput!) {
  createLoyaltyPromotion(promotion: $promotion)
}
    `;
export type CreateLoyaltyPromotionMutationFn = Apollo.MutationFunction<CreateLoyaltyPromotionMutation, CreateLoyaltyPromotionMutationVariables>;

/**
 * __useCreateLoyaltyPromotionMutation__
 *
 * To run a mutation, you first call `useCreateLoyaltyPromotionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLoyaltyPromotionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLoyaltyPromotionMutation, { data, loading, error }] = useCreateLoyaltyPromotionMutation({
 *   variables: {
 *      promotion: // value for 'promotion'
 *   },
 * });
 */
export function useCreateLoyaltyPromotionMutation(baseOptions?: Apollo.MutationHookOptions<CreateLoyaltyPromotionMutation, CreateLoyaltyPromotionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLoyaltyPromotionMutation, CreateLoyaltyPromotionMutationVariables>(CreateLoyaltyPromotionDocument, options);
      }
export type CreateLoyaltyPromotionMutationHookResult = ReturnType<typeof useCreateLoyaltyPromotionMutation>;
export type CreateLoyaltyPromotionMutationResult = Apollo.MutationResult<CreateLoyaltyPromotionMutation>;
export type CreateLoyaltyPromotionMutationOptions = Apollo.BaseMutationOptions<CreateLoyaltyPromotionMutation, CreateLoyaltyPromotionMutationVariables>;
export const UpdatePercentagePromotionDocument = gql`
    mutation updatePercentagePromotion($promotion: PercentagePromotionInput!, $promotionId: String!) {
  updatePercentagePromotion(promotion: $promotion, promotionId: $promotionId)
}
    `;
export type UpdatePercentagePromotionMutationFn = Apollo.MutationFunction<UpdatePercentagePromotionMutation, UpdatePercentagePromotionMutationVariables>;

/**
 * __useUpdatePercentagePromotionMutation__
 *
 * To run a mutation, you first call `useUpdatePercentagePromotionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePercentagePromotionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePercentagePromotionMutation, { data, loading, error }] = useUpdatePercentagePromotionMutation({
 *   variables: {
 *      promotion: // value for 'promotion'
 *      promotionId: // value for 'promotionId'
 *   },
 * });
 */
export function useUpdatePercentagePromotionMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePercentagePromotionMutation, UpdatePercentagePromotionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePercentagePromotionMutation, UpdatePercentagePromotionMutationVariables>(UpdatePercentagePromotionDocument, options);
      }
export type UpdatePercentagePromotionMutationHookResult = ReturnType<typeof useUpdatePercentagePromotionMutation>;
export type UpdatePercentagePromotionMutationResult = Apollo.MutationResult<UpdatePercentagePromotionMutation>;
export type UpdatePercentagePromotionMutationOptions = Apollo.BaseMutationOptions<UpdatePercentagePromotionMutation, UpdatePercentagePromotionMutationVariables>;
export const UpdateLoyaltyPromotionDocument = gql`
    mutation updateLoyaltyPromotion($promotion: LoyaltyPromotionInput!, $promotionId: String!) {
  updateLoyaltyPromotion(promotion: $promotion, promotionId: $promotionId)
}
    `;
export type UpdateLoyaltyPromotionMutationFn = Apollo.MutationFunction<UpdateLoyaltyPromotionMutation, UpdateLoyaltyPromotionMutationVariables>;

/**
 * __useUpdateLoyaltyPromotionMutation__
 *
 * To run a mutation, you first call `useUpdateLoyaltyPromotionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLoyaltyPromotionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLoyaltyPromotionMutation, { data, loading, error }] = useUpdateLoyaltyPromotionMutation({
 *   variables: {
 *      promotion: // value for 'promotion'
 *      promotionId: // value for 'promotionId'
 *   },
 * });
 */
export function useUpdateLoyaltyPromotionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLoyaltyPromotionMutation, UpdateLoyaltyPromotionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLoyaltyPromotionMutation, UpdateLoyaltyPromotionMutationVariables>(UpdateLoyaltyPromotionDocument, options);
      }
export type UpdateLoyaltyPromotionMutationHookResult = ReturnType<typeof useUpdateLoyaltyPromotionMutation>;
export type UpdateLoyaltyPromotionMutationResult = Apollo.MutationResult<UpdateLoyaltyPromotionMutation>;
export type UpdateLoyaltyPromotionMutationOptions = Apollo.BaseMutationOptions<UpdateLoyaltyPromotionMutation, UpdateLoyaltyPromotionMutationVariables>;
export const CreateSpendPromotionDocument = gql`
    mutation createSpendPromotion($promotion: SpendPromotionInput!) {
  createSpendPromotion(promotion: $promotion)
}
    `;
export type CreateSpendPromotionMutationFn = Apollo.MutationFunction<CreateSpendPromotionMutation, CreateSpendPromotionMutationVariables>;

/**
 * __useCreateSpendPromotionMutation__
 *
 * To run a mutation, you first call `useCreateSpendPromotionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSpendPromotionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSpendPromotionMutation, { data, loading, error }] = useCreateSpendPromotionMutation({
 *   variables: {
 *      promotion: // value for 'promotion'
 *   },
 * });
 */
export function useCreateSpendPromotionMutation(baseOptions?: Apollo.MutationHookOptions<CreateSpendPromotionMutation, CreateSpendPromotionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSpendPromotionMutation, CreateSpendPromotionMutationVariables>(CreateSpendPromotionDocument, options);
      }
export type CreateSpendPromotionMutationHookResult = ReturnType<typeof useCreateSpendPromotionMutation>;
export type CreateSpendPromotionMutationResult = Apollo.MutationResult<CreateSpendPromotionMutation>;
export type CreateSpendPromotionMutationOptions = Apollo.BaseMutationOptions<CreateSpendPromotionMutation, CreateSpendPromotionMutationVariables>;
export const UpdateSpendPromotionDocument = gql`
    mutation updateSpendPromotion($promotion: SpendPromotionInput!, $promotionId: String!) {
  updateSpendPromotion(promotion: $promotion, promotionId: $promotionId)
}
    `;
export type UpdateSpendPromotionMutationFn = Apollo.MutationFunction<UpdateSpendPromotionMutation, UpdateSpendPromotionMutationVariables>;

/**
 * __useUpdateSpendPromotionMutation__
 *
 * To run a mutation, you first call `useUpdateSpendPromotionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSpendPromotionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSpendPromotionMutation, { data, loading, error }] = useUpdateSpendPromotionMutation({
 *   variables: {
 *      promotion: // value for 'promotion'
 *      promotionId: // value for 'promotionId'
 *   },
 * });
 */
export function useUpdateSpendPromotionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSpendPromotionMutation, UpdateSpendPromotionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSpendPromotionMutation, UpdateSpendPromotionMutationVariables>(UpdateSpendPromotionDocument, options);
      }
export type UpdateSpendPromotionMutationHookResult = ReturnType<typeof useUpdateSpendPromotionMutation>;
export type UpdateSpendPromotionMutationResult = Apollo.MutationResult<UpdateSpendPromotionMutation>;
export type UpdateSpendPromotionMutationOptions = Apollo.BaseMutationOptions<UpdateSpendPromotionMutation, UpdateSpendPromotionMutationVariables>;
export const UpdateBuyNGetNFreePromotionDocument = gql`
    mutation updateBuyNGetNFreePromotion($promotion: BuyNGetNFreePromotionInput!, $promotionId: String!) {
  updateBuyNGetNFreePromotion(promotion: $promotion, promotionId: $promotionId)
}
    `;
export type UpdateBuyNGetNFreePromotionMutationFn = Apollo.MutationFunction<UpdateBuyNGetNFreePromotionMutation, UpdateBuyNGetNFreePromotionMutationVariables>;

/**
 * __useUpdateBuyNGetNFreePromotionMutation__
 *
 * To run a mutation, you first call `useUpdateBuyNGetNFreePromotionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBuyNGetNFreePromotionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBuyNGetNFreePromotionMutation, { data, loading, error }] = useUpdateBuyNGetNFreePromotionMutation({
 *   variables: {
 *      promotion: // value for 'promotion'
 *      promotionId: // value for 'promotionId'
 *   },
 * });
 */
export function useUpdateBuyNGetNFreePromotionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBuyNGetNFreePromotionMutation, UpdateBuyNGetNFreePromotionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBuyNGetNFreePromotionMutation, UpdateBuyNGetNFreePromotionMutationVariables>(UpdateBuyNGetNFreePromotionDocument, options);
      }
export type UpdateBuyNGetNFreePromotionMutationHookResult = ReturnType<typeof useUpdateBuyNGetNFreePromotionMutation>;
export type UpdateBuyNGetNFreePromotionMutationResult = Apollo.MutationResult<UpdateBuyNGetNFreePromotionMutation>;
export type UpdateBuyNGetNFreePromotionMutationOptions = Apollo.BaseMutationOptions<UpdateBuyNGetNFreePromotionMutation, UpdateBuyNGetNFreePromotionMutationVariables>;
export const CreateBuyNGetNFreePromotionDocument = gql`
    mutation createBuyNGetNFreePromotion($promotion: BuyNGetNFreePromotionInput!) {
  createBuyNGetNFreePromotion(promotion: $promotion)
}
    `;
export type CreateBuyNGetNFreePromotionMutationFn = Apollo.MutationFunction<CreateBuyNGetNFreePromotionMutation, CreateBuyNGetNFreePromotionMutationVariables>;

/**
 * __useCreateBuyNGetNFreePromotionMutation__
 *
 * To run a mutation, you first call `useCreateBuyNGetNFreePromotionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBuyNGetNFreePromotionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBuyNGetNFreePromotionMutation, { data, loading, error }] = useCreateBuyNGetNFreePromotionMutation({
 *   variables: {
 *      promotion: // value for 'promotion'
 *   },
 * });
 */
export function useCreateBuyNGetNFreePromotionMutation(baseOptions?: Apollo.MutationHookOptions<CreateBuyNGetNFreePromotionMutation, CreateBuyNGetNFreePromotionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBuyNGetNFreePromotionMutation, CreateBuyNGetNFreePromotionMutationVariables>(CreateBuyNGetNFreePromotionDocument, options);
      }
export type CreateBuyNGetNFreePromotionMutationHookResult = ReturnType<typeof useCreateBuyNGetNFreePromotionMutation>;
export type CreateBuyNGetNFreePromotionMutationResult = Apollo.MutationResult<CreateBuyNGetNFreePromotionMutation>;
export type CreateBuyNGetNFreePromotionMutationOptions = Apollo.BaseMutationOptions<CreateBuyNGetNFreePromotionMutation, CreateBuyNGetNFreePromotionMutationVariables>;
export const GetLuckyDrawPromotionDocument = gql`
    query getLuckyDrawPromotion($promotionId: String!) {
  getLuckyDrawPromotion(promotionId: $promotionId) {
    id
    name
    description
    numberOfDeals
    availableType
    effectiveDateTime {
      startDate
      endDate
      recurringWeekDays
      hours {
        openStart
        openEnd
      }
    }
    isPublished
    useType
    isSignUpPromotion
    prizeDescription
    winPercentage
    winnerCount
    entryLimitPerUser
    minimumAmount
    winCountLimitPerPerson
    isEntryAutomatic
    resultingPromotions {
      promotionId
      winPercentage
    }
    isPaymentRequired
    isLoyalty
    loyaltyDetails {
      expiryDays
      loyaltyReviewDate
    }
    displaySettings {
      displayTitle
      displayDescription
      displayAltDescription
      displayAltTitle
      displayImage
      displayTerms
    }
  }
}
    `;

/**
 * __useGetLuckyDrawPromotionQuery__
 *
 * To run a query within a React component, call `useGetLuckyDrawPromotionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLuckyDrawPromotionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLuckyDrawPromotionQuery({
 *   variables: {
 *      promotionId: // value for 'promotionId'
 *   },
 * });
 */
export function useGetLuckyDrawPromotionQuery(baseOptions: Apollo.QueryHookOptions<GetLuckyDrawPromotionQuery, GetLuckyDrawPromotionQueryVariables> & ({ variables: GetLuckyDrawPromotionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLuckyDrawPromotionQuery, GetLuckyDrawPromotionQueryVariables>(GetLuckyDrawPromotionDocument, options);
      }
export function useGetLuckyDrawPromotionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLuckyDrawPromotionQuery, GetLuckyDrawPromotionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLuckyDrawPromotionQuery, GetLuckyDrawPromotionQueryVariables>(GetLuckyDrawPromotionDocument, options);
        }
export function useGetLuckyDrawPromotionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLuckyDrawPromotionQuery, GetLuckyDrawPromotionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLuckyDrawPromotionQuery, GetLuckyDrawPromotionQueryVariables>(GetLuckyDrawPromotionDocument, options);
        }
export type GetLuckyDrawPromotionQueryHookResult = ReturnType<typeof useGetLuckyDrawPromotionQuery>;
export type GetLuckyDrawPromotionLazyQueryHookResult = ReturnType<typeof useGetLuckyDrawPromotionLazyQuery>;
export type GetLuckyDrawPromotionSuspenseQueryHookResult = ReturnType<typeof useGetLuckyDrawPromotionSuspenseQuery>;
export type GetLuckyDrawPromotionQueryResult = Apollo.QueryResult<GetLuckyDrawPromotionQuery, GetLuckyDrawPromotionQueryVariables>;
export const CreateLuckyDrawPromotionDocument = gql`
    mutation createLuckyDrawPromotion($promotion: LuckyDrawPromotionInput!) {
  createLuckyDrawPromotion(promotion: $promotion)
}
    `;
export type CreateLuckyDrawPromotionMutationFn = Apollo.MutationFunction<CreateLuckyDrawPromotionMutation, CreateLuckyDrawPromotionMutationVariables>;

/**
 * __useCreateLuckyDrawPromotionMutation__
 *
 * To run a mutation, you first call `useCreateLuckyDrawPromotionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLuckyDrawPromotionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLuckyDrawPromotionMutation, { data, loading, error }] = useCreateLuckyDrawPromotionMutation({
 *   variables: {
 *      promotion: // value for 'promotion'
 *   },
 * });
 */
export function useCreateLuckyDrawPromotionMutation(baseOptions?: Apollo.MutationHookOptions<CreateLuckyDrawPromotionMutation, CreateLuckyDrawPromotionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLuckyDrawPromotionMutation, CreateLuckyDrawPromotionMutationVariables>(CreateLuckyDrawPromotionDocument, options);
      }
export type CreateLuckyDrawPromotionMutationHookResult = ReturnType<typeof useCreateLuckyDrawPromotionMutation>;
export type CreateLuckyDrawPromotionMutationResult = Apollo.MutationResult<CreateLuckyDrawPromotionMutation>;
export type CreateLuckyDrawPromotionMutationOptions = Apollo.BaseMutationOptions<CreateLuckyDrawPromotionMutation, CreateLuckyDrawPromotionMutationVariables>;
export const UpdateLuckyDrawPromotionDocument = gql`
    mutation updateLuckyDrawPromotion($promotion: LuckyDrawPromotionInput!, $promotionId: String!) {
  updateLuckyDrawPromotion(promotion: $promotion, promotionId: $promotionId)
}
    `;
export type UpdateLuckyDrawPromotionMutationFn = Apollo.MutationFunction<UpdateLuckyDrawPromotionMutation, UpdateLuckyDrawPromotionMutationVariables>;

/**
 * __useUpdateLuckyDrawPromotionMutation__
 *
 * To run a mutation, you first call `useUpdateLuckyDrawPromotionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLuckyDrawPromotionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLuckyDrawPromotionMutation, { data, loading, error }] = useUpdateLuckyDrawPromotionMutation({
 *   variables: {
 *      promotion: // value for 'promotion'
 *      promotionId: // value for 'promotionId'
 *   },
 * });
 */
export function useUpdateLuckyDrawPromotionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLuckyDrawPromotionMutation, UpdateLuckyDrawPromotionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLuckyDrawPromotionMutation, UpdateLuckyDrawPromotionMutationVariables>(UpdateLuckyDrawPromotionDocument, options);
      }
export type UpdateLuckyDrawPromotionMutationHookResult = ReturnType<typeof useUpdateLuckyDrawPromotionMutation>;
export type UpdateLuckyDrawPromotionMutationResult = Apollo.MutationResult<UpdateLuckyDrawPromotionMutation>;
export type UpdateLuckyDrawPromotionMutationOptions = Apollo.BaseMutationOptions<UpdateLuckyDrawPromotionMutation, UpdateLuckyDrawPromotionMutationVariables>;
export const TopRestaurantTypesDocument = gql`
    query topRestaurantTypes {
  topRestaurantTypes
}
    `;

/**
 * __useTopRestaurantTypesQuery__
 *
 * To run a query within a React component, call `useTopRestaurantTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTopRestaurantTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTopRestaurantTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useTopRestaurantTypesQuery(baseOptions?: Apollo.QueryHookOptions<TopRestaurantTypesQuery, TopRestaurantTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TopRestaurantTypesQuery, TopRestaurantTypesQueryVariables>(TopRestaurantTypesDocument, options);
      }
export function useTopRestaurantTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TopRestaurantTypesQuery, TopRestaurantTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TopRestaurantTypesQuery, TopRestaurantTypesQueryVariables>(TopRestaurantTypesDocument, options);
        }
export function useTopRestaurantTypesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TopRestaurantTypesQuery, TopRestaurantTypesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TopRestaurantTypesQuery, TopRestaurantTypesQueryVariables>(TopRestaurantTypesDocument, options);
        }
export type TopRestaurantTypesQueryHookResult = ReturnType<typeof useTopRestaurantTypesQuery>;
export type TopRestaurantTypesLazyQueryHookResult = ReturnType<typeof useTopRestaurantTypesLazyQuery>;
export type TopRestaurantTypesSuspenseQueryHookResult = ReturnType<typeof useTopRestaurantTypesSuspenseQuery>;
export type TopRestaurantTypesQueryResult = Apollo.QueryResult<TopRestaurantTypesQuery, TopRestaurantTypesQueryVariables>;
export const CreateOrUpdateTopRestaurantTypesDocument = gql`
    mutation CreateOrUpdateTopRestaurantTypes($types: [RestaurantType]!) {
  createOrUpdateTopRestaurantTypes(types: $types)
}
    `;
export type CreateOrUpdateTopRestaurantTypesMutationFn = Apollo.MutationFunction<CreateOrUpdateTopRestaurantTypesMutation, CreateOrUpdateTopRestaurantTypesMutationVariables>;

/**
 * __useCreateOrUpdateTopRestaurantTypesMutation__
 *
 * To run a mutation, you first call `useCreateOrUpdateTopRestaurantTypesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrUpdateTopRestaurantTypesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrUpdateTopRestaurantTypesMutation, { data, loading, error }] = useCreateOrUpdateTopRestaurantTypesMutation({
 *   variables: {
 *      types: // value for 'types'
 *   },
 * });
 */
export function useCreateOrUpdateTopRestaurantTypesMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrUpdateTopRestaurantTypesMutation, CreateOrUpdateTopRestaurantTypesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrUpdateTopRestaurantTypesMutation, CreateOrUpdateTopRestaurantTypesMutationVariables>(CreateOrUpdateTopRestaurantTypesDocument, options);
      }
export type CreateOrUpdateTopRestaurantTypesMutationHookResult = ReturnType<typeof useCreateOrUpdateTopRestaurantTypesMutation>;
export type CreateOrUpdateTopRestaurantTypesMutationResult = Apollo.MutationResult<CreateOrUpdateTopRestaurantTypesMutation>;
export type CreateOrUpdateTopRestaurantTypesMutationOptions = Apollo.BaseMutationOptions<CreateOrUpdateTopRestaurantTypesMutation, CreateOrUpdateTopRestaurantTypesMutationVariables>;
export const GetAllUsersDocument = gql`
    query getAllUsers {
  getAllUsers {
    id
    name
    role
    roles
    email
    merchantId
    phoneNumber
    permissions
    createdAt
  }
}
    `;

/**
 * __useGetAllUsersQuery__
 *
 * To run a query within a React component, call `useGetAllUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllUsersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllUsersQuery(baseOptions?: Apollo.QueryHookOptions<GetAllUsersQuery, GetAllUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllUsersQuery, GetAllUsersQueryVariables>(GetAllUsersDocument, options);
      }
export function useGetAllUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllUsersQuery, GetAllUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllUsersQuery, GetAllUsersQueryVariables>(GetAllUsersDocument, options);
        }
export function useGetAllUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllUsersQuery, GetAllUsersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllUsersQuery, GetAllUsersQueryVariables>(GetAllUsersDocument, options);
        }
export type GetAllUsersQueryHookResult = ReturnType<typeof useGetAllUsersQuery>;
export type GetAllUsersLazyQueryHookResult = ReturnType<typeof useGetAllUsersLazyQuery>;
export type GetAllUsersSuspenseQueryHookResult = ReturnType<typeof useGetAllUsersSuspenseQuery>;
export type GetAllUsersQueryResult = Apollo.QueryResult<GetAllUsersQuery, GetAllUsersQueryVariables>;
export const CreateUserDocument = gql`
    mutation createUser($email: String!, $merchantId: ID, $password: String!, $role: UserRole!, $name: String!, $roles: [UserRole!]) {
  createUser(
    email: $email
    merchantId: $merchantId
    password: $password
    role: $role
    name: $name
    roles: $roles
  )
}
    `;
export type CreateUserMutationFn = Apollo.MutationFunction<CreateUserMutation, CreateUserMutationVariables>;

/**
 * __useCreateUserMutation__
 *
 * To run a mutation, you first call `useCreateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserMutation, { data, loading, error }] = useCreateUserMutation({
 *   variables: {
 *      email: // value for 'email'
 *      merchantId: // value for 'merchantId'
 *      password: // value for 'password'
 *      role: // value for 'role'
 *      name: // value for 'name'
 *      roles: // value for 'roles'
 *   },
 * });
 */
export function useCreateUserMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserMutation, CreateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserMutation, CreateUserMutationVariables>(CreateUserDocument, options);
      }
export type CreateUserMutationHookResult = ReturnType<typeof useCreateUserMutation>;
export type CreateUserMutationResult = Apollo.MutationResult<CreateUserMutation>;
export type CreateUserMutationOptions = Apollo.BaseMutationOptions<CreateUserMutation, CreateUserMutationVariables>;
export const DeleteUserDocument = gql`
    mutation deleteUser($email: String!) {
  deleteUser(email: $email)
}
    `;
export type DeleteUserMutationFn = Apollo.MutationFunction<DeleteUserMutation, DeleteUserMutationVariables>;

/**
 * __useDeleteUserMutation__
 *
 * To run a mutation, you first call `useDeleteUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserMutation, { data, loading, error }] = useDeleteUserMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useDeleteUserMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUserMutation, DeleteUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUserMutation, DeleteUserMutationVariables>(DeleteUserDocument, options);
      }
export type DeleteUserMutationHookResult = ReturnType<typeof useDeleteUserMutation>;
export type DeleteUserMutationResult = Apollo.MutationResult<DeleteUserMutation>;
export type DeleteUserMutationOptions = Apollo.BaseMutationOptions<DeleteUserMutation, DeleteUserMutationVariables>;
export const GetUserDetailDocument = gql`
    query getUserDetail {
  getUserDetail {
    id
    name
    role
    roles
    email
    merchantId
    phoneNumber
    permissions
    createdAt
    loginToken
  }
}
    `;

/**
 * __useGetUserDetailQuery__
 *
 * To run a query within a React component, call `useGetUserDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserDetailQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserDetailQuery(baseOptions?: Apollo.QueryHookOptions<GetUserDetailQuery, GetUserDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserDetailQuery, GetUserDetailQueryVariables>(GetUserDetailDocument, options);
      }
export function useGetUserDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserDetailQuery, GetUserDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserDetailQuery, GetUserDetailQueryVariables>(GetUserDetailDocument, options);
        }
export function useGetUserDetailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserDetailQuery, GetUserDetailQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserDetailQuery, GetUserDetailQueryVariables>(GetUserDetailDocument, options);
        }
export type GetUserDetailQueryHookResult = ReturnType<typeof useGetUserDetailQuery>;
export type GetUserDetailLazyQueryHookResult = ReturnType<typeof useGetUserDetailLazyQuery>;
export type GetUserDetailSuspenseQueryHookResult = ReturnType<typeof useGetUserDetailSuspenseQuery>;
export type GetUserDetailQueryResult = Apollo.QueryResult<GetUserDetailQuery, GetUserDetailQueryVariables>;
export const ChangePasswordDocument = gql`
    mutation changePassword($oldPassword: String!, $newPassword: String!) {
  changePassword(oldPassword: $oldPassword, newPassword: $newPassword)
}
    `;
export type ChangePasswordMutationFn = Apollo.MutationFunction<ChangePasswordMutation, ChangePasswordMutationVariables>;

/**
 * __useChangePasswordMutation__
 *
 * To run a mutation, you first call `useChangePasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangePasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changePasswordMutation, { data, loading, error }] = useChangePasswordMutation({
 *   variables: {
 *      oldPassword: // value for 'oldPassword'
 *      newPassword: // value for 'newPassword'
 *   },
 * });
 */
export function useChangePasswordMutation(baseOptions?: Apollo.MutationHookOptions<ChangePasswordMutation, ChangePasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangePasswordMutation, ChangePasswordMutationVariables>(ChangePasswordDocument, options);
      }
export type ChangePasswordMutationHookResult = ReturnType<typeof useChangePasswordMutation>;
export type ChangePasswordMutationResult = Apollo.MutationResult<ChangePasswordMutation>;
export type ChangePasswordMutationOptions = Apollo.BaseMutationOptions<ChangePasswordMutation, ChangePasswordMutationVariables>;
export const UpdateUserDetailsDocument = gql`
    mutation updateUserDetails($user: UserInput!) {
  updateUserDetails(user: $user)
}
    `;
export type UpdateUserDetailsMutationFn = Apollo.MutationFunction<UpdateUserDetailsMutation, UpdateUserDetailsMutationVariables>;

/**
 * __useUpdateUserDetailsMutation__
 *
 * To run a mutation, you first call `useUpdateUserDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserDetailsMutation, { data, loading, error }] = useUpdateUserDetailsMutation({
 *   variables: {
 *      user: // value for 'user'
 *   },
 * });
 */
export function useUpdateUserDetailsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserDetailsMutation, UpdateUserDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserDetailsMutation, UpdateUserDetailsMutationVariables>(UpdateUserDetailsDocument, options);
      }
export type UpdateUserDetailsMutationHookResult = ReturnType<typeof useUpdateUserDetailsMutation>;
export type UpdateUserDetailsMutationResult = Apollo.MutationResult<UpdateUserDetailsMutation>;
export type UpdateUserDetailsMutationOptions = Apollo.BaseMutationOptions<UpdateUserDetailsMutation, UpdateUserDetailsMutationVariables>;
export const UpdateUserDocument = gql`
    mutation updateUser($user: AccountInput!) {
  updateUser(user: $user)
}
    `;
export type UpdateUserMutationFn = Apollo.MutationFunction<UpdateUserMutation, UpdateUserMutationVariables>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      user: // value for 'user'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserMutation, UpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, options);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = Apollo.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>;